/* Copyright (c) yasc GmbH
 * ALL RIGHTS RESERVED
 * This software is protected by the inclusion of the above copyright
 * notice. This software may not be provided or otherwise made available
 * to, or used by, any other person. No title to or ownership of the
 * software is  hereby  transferred.
 * The information contained in this document is considered the
 * CONFIDENTIAL and PROPRIETARY information of yasc GmbH and may
 * not be disclosed or discussed with anyone who is not employed by
 * yasc GmbH, unless the individual/company
 * (i) has an express need to know such information, and
 * (ii) disclosure of information is subject to the terms of a duly
 * executed Confidentiality and Non-Disclosure Agreement between
 * yasc GmbH and the individual/company.
 */
export const i18nDeDe = {
    false: "Nein",
    true: "Ja",
    back: 'Zurück',
    continue: 'Weiter',
    type: 'Typ',
    edit: 'Bearbeiten',
    globalShortcuts: 'Globale Shortcuts',
    notification: 'Benachrichtigungen',
    timeClock: 'Stempeluhr',
    reportBug: "Fehler melden",
    start: 'Start',
    pause: 'Pause',
    stop: 'Stop',
    CTRLM: 'STRG + M',
    CTRLO: 'STRG + O',
    CTRLB: 'STRG + B',
    ImportCsv: "CSV importieren",
    ExportCsv: "CSV exportieren",
    ImportExcel: "Excel importieren",
    ExportExcel: "Excel exportieren",
    Create: "Erstellen",
    Show: "Anzeigen",
    Edit: "Bearbeiten",
    Copy: "Kopieren",
    Delete: "Löschen",
    Close: "Schließen",
    Cancel: "Abbrechen",
    Update: "Aktualisieren",
    Redo: "Wiederholen",
    Undo: "Rückgängig",
    Reset: "Zurücksetzen",
    attachment: 'Anhang',
    onThisPage: 'Auf dieser Seite',
    accountCompanyInfoHeader: 'Firmendaten',
    accountCompanyAddCompany: 'Neue Firma Erstellen',
    accountEmployeeGroupConfirmed: 'Verifizierte Nutzer',
    accountEmployeeGroupNotConfirmed: 'Nicht verifizierte Nutzer',
    accountEmployeeAddUser: 'Neuen Nutzer hinzufügen',
    accountGeneralHeader: 'Accountdaten',
    accountPersonalInfoHeader: 'Persönliche Daten',
    accountPersonalSignature: "Signatur",
    accountPersonalUploadSignature: "Unterschrift hochladen",
    companyDetailsUploadLogo: "Logo hochladen",
    accountSaveBottomBar: 'Änderung speichern',
    accountNewDepartment: 'Neue Abteilung',
    accountConfirmationHeader: 'Account Erfolgreich Bestätigt ',
    accountConfirmationContent: 'Es wurde eine Bestätigungsmail versendet. Bitte bestätigen Sie Ihren Account.',
    accountPwResetConfirmation: 'Es wurde eine Email versendet. Bitte bestätigen Sie diese.',
    accountConfirmationSetNewPasswordHeader: 'Bitte geben sie ein Passwort für Ihren neuen Account ein:',
    accountConfirmationContinueToHome: 'Weiter zum Kundenportal',
    userIsVerifiedHint: 'E-Mail-Adresse bestätigt',
    userHasSignatureHint: 'Unterschrift digital hinterlegt',
    addComingSoon: 'Feature to update screenshots coming soon!',
    addFeatureDesc: 'Feature-Beschreibung',
    addFeatureHeader: '{{index}}. Feature:',
    addFeatureTitle: 'Feature-Titel',
    addFinish: 'Erstelle {{prodName}}',
    addFinishEdit: 'Aktualisiere {{prodName}}',
    addLongDesc: 'Ausführliche Beschreibung für {{langCode}}',
    addName: 'Name des neuen Produktes',
    productCostTrendYear: 'Jahr',
    productCostTrendCosts: 'Kosten in €',
    addNameEdit: 'Name des Produktes',
    addPaymentInterval: 'Zahlungsinterval (in Monaten)',
    addPricingFeature: 'Abrechnungskosten / Feature',
    addProductDiscounts: "Rabatte / Ab Lizenz",
    addProductDiscountsEnabled: "Rabattierung aktiviert",
    addPrice: 'Preis',
    addProductImage: 'Produktbild auswählen',
    addProductUniversalScreenshot: 'Sprach-Unabhänige Bilder',
    selectLanguage: "Sprache Wählen",
    addShortDesc: 'Kurzbeschreibung für {{langCode}}',
    addStepFeature: 'Features',
    addStepGeneral: 'Generelle Informationen',
    addStepScreenshot: 'Screenshots',
    addAttachments: 'Anhänge',
    addStepLicenseAgreements: 'Lizenzvereinbarungen',
    addStepPricing: 'Preise & Rabatte',
    pricingFeatures: 'Feature-Übersicht',
    addressAddNewAddress: 'Neue Adresse hinzufügen',
    addressEditAddress: 'Adresse bearbeiten',
    addressCreateHelpTextPre: "Hier können Sie Ihre Firmenadresse einsehen oder ändern. Adressen werden im meistens als Lieferadressen und/oder Rechnungsadressen verwendet.",
    addressCreateHelpTextAfter: "Nach dem Speichern wird die Adresse sofort in Übersicht aktualisiert.",
    addressFederalState: 'Bundesland',
    addressLand: 'Land',
    addressNumber: 'Hausnummer',
    addressPageHeader: 'Firmenaddressen',
    addressStreet: 'Straßenname',
    addressTown: 'Stadt',
    addressType: 'Addresstyp',
    addressZip: 'Postleitzahl',
    authConfirmationHeader: 'Bestätigung',
    authConfirmationInfoTextOpen: 'Zur Bestätigung Ihres Accounts wurde Ihnen eine E-Mail an die folgende Addresse geschickt {{email}}.',
    authConfirmationSuccess: 'Herzlichen Glückwunsch! \n Ihr Account wurde erfolgreich bestätigt',
    checkoutAddress: 'Wählen Sie eine Addresse aus',
    checkoutAutoRenewMulti: 'Aktualisiert die Lizenz automatisch alle {{interval}} Monate',
    checkoutAutoRenewSingle: 'Aktualisiert die Lizenz automatisch jeden Monat',
    checkoutCredit: 'Kreditkarte',
    checkoutDebit: 'Lastschrift',
    checkoutMail: 'E-Mail-Anfrage',
    checkoutOrder: 'Auftragsdetails',
    checkoutOwnedBy: 'Verwaltet von {{owner}}',
    checkoutPayPal: 'PayPal',
    checkoutPayment: 'Wählen Sie eine Bankverbindung aus',
    checkoutRouteToNewAddress: 'Nicht die richtige Addresse vorhanden? \n Klicken Sie hier um eine neue hinzuzufügen.',
    checkoutRouteToNewBank: 'Nicht die richtige Bankverbindung vorhanden? \n Klicken Sie hier um eine neue hinzuzufügen.',
    checkoutValueContainer: '{{amount}} €',
    checkoutOrderDetailsHeader: 'Bestelldetails',
    checkoutVisa: 'Visa',
    checkoutToolTip: '{{method}} in Kürze verfügbar',
    ComboBoxValueEmpty: '--leer--',
    confirmationCancelText: 'Sind Sie sicher das Sie den Vorgang abbrechen Möchten?',
    confirmationNo: 'Nein',
    confirmationSureText: 'Sind Sie sicher?',
    confirmationYes: 'Ja',
    detailTabDownload: 'Downloads',
    detailTabFeatures: 'Features',
    detailTabNews: 'Nachrichten',
    detailTabReleases: 'Releases',
    detailTabPricing: 'Preise',
    detailTabDocuments: 'Dokumente',
    detailTabNoDocuments: 'Keine Lizenzdokumente vorhanden',
    detailTabDocumentsLicenses: 'Lizenzen',
    detailTabDocumentsDocuments: 'Dokumente',
    departmentHeader: 'Abteilungen',
    departmentAlreadyExists: 'Department existiert bereits',
    employeeAccountCreate: 'Neuen Mitarbeiter hinzufügen',
    employeeAccountUpdate: 'Mitarbeiter bearbeiten',
    employeeBirthdate: 'Geburtstag',
    employeeCountry: 'Geburtsort',
    employeeDegree: 'Akademischer Titel',
    employeeDepartment: 'Abteilung',
    employeeEmail: 'E-Mail',
    employeeVerified: "Verifiziert",
    employeeLastPasswordChange: "Letzte Passwortänderung",
    employeeGivenName: 'Vorname',
    employeeLastName: 'Nachname',
    employeeName: 'Name',
    employeeNoPhone: 'Keine Telefonummer angegeben',
    employeeNoDepartment: 'Kein Department vergeben',
    employeeNoBirthplace: 'Keine Geburtsort angegeben',
    employeePageHeader: 'Mitarbeiterverwaltung',
    employeePhone: 'Telefonnummer',
    employeeRole: 'Berechtigung',
    employeeRoles: 'Berechtigungen',
    employeeSalutations: 'Anrede',
    employeeSalutationsFemale: 'Frau',
    employeeSalutationsMale: 'Herr',
    employeeSalutationsOther: 'Divers',
    employeeUsername: 'Benutzername',
    generalRequireTasks: "Tasks verpflichtend",
    generalTitle: "Titel",
    general_to: "bis",
    generalSelectedTab: "Tab",
    generalRoute: "Frontend-Route",
    generalDetails: 'Details',
    generalSecurity: "Passwort & Sicherheit",
    generalFor: "für",
    generalAll:'Alle',
    generalReset: "Zurücksetzen",
    generalRole: "Rolle",
    generalRoles: "Rollen",
    generalAlias: 'Aliasse',
    generalManagement: 'Management',
    generalRemove: 'Entfernen',
    generalArchive: 'Archivieren',
    generalEdit: 'Bearbeiten',
    generalChangesSaved: 'Ihre Änderungen wurden erfolgreich gespeichert',
    generalError: "Fehler",
    generalSuccess: "Erfolg",
    generalBack: 'Zurück',
    generalCancel: 'Abbrechen',
    generalCompanyManagingDirectors: 'Geschäftsführung',
    generalCompanyName: 'Firma',
    generalCount: "Anzahl",
    generalDescription: 'Beschreibung',
    generalFileUploadChoseMulti: 'Dateien auswählen',
    generalFileUploadChoseSingle: 'Datei auswählen',
    generalGroupBy: 'Gruppieren nach',
    generalName: 'Name',
    generalMutability: 'Schreibrechte',
    generalExpiryDate: 'Gültig bis',
    generalId: "Id",
    generalNext: 'Weiter',
    generalPassword: 'Passwort',
    generalNewPassword: "Neues Passwort",
    generalRegister: 'Registrieren',
    generalSave: 'Speichern',
    generalSearch: 'Suchen',
    generalSortBy: 'Sortieren nach:',
    generalUpload: 'Hochladen',
    generalProduct: 'Produkt',
    generalProductId: 'Produkt-Id',
    generalAvailability: 'Verfügbarkeiten',
    generalCreate: 'Erstellen',
    generalCreated: 'Erstellt',
    generalImport: 'Import',
    generalImportCsv: 'Import CSV',
    generalImportExcel: 'Import Excel',
    generalExport: "Export",
    generalExportCsv: "Export CSV",
    generalExportExcel: "Export Excel",
    generalRegexPattern: "Regulärer ausdruck",
    generalRegexCaptureGroup: "Regex Gruppe",
    generalAccountInfos: "Accountinformationen",
    generalGroupName: "Gruppe",
    generalOrderIdShort: "Bestellnr.",
    generalOrderId: "Bestellnummer",
    generalReceiptNoShort: "Rechnungsnr.",
    generalReceiptNo: "Rechnungsnummer",
    generalGroupAdd: "Gruppe Hinzufügen",
    generalBuyer: "Käufer",
    generalPieces: "Stück",
    generalHours: "Stunden",
    generalPosition: "Position",
    generalPositions: "Positionen",
    generalReceiver: "Empfänger",
    generalSent: "Gesendet",
    generalType: "Typ",
    generalReadAll: "Alle gelesen",
    generalClearAll: "Leeren",
    generalExecute: "Ausführen",
    homeNews: 'Neuigkeiten',
    homeQuickAccess: 'Schnellzugriff',
    loginChangePassword: 'Passwort ändern',
    loginNewPassword: 'Neues Passwort',
    loginNoAccount: 'Noch kein Account?',
    accountProfile: "Profil",
    administration: "Administration",
    adminAvailableBackups: "Verfügbare Backups",
    adminRestoreHelpText: "Mit dieser Funktion können die Applikationsdaten aus einem Backup wiederhergestellt werden. Stellen Sie sicher, dass das Backup aktuell ist und von der gleichen Instanz stammt. Beachten Sie, dass alle Applikationsdaten durch die Daten aus dem Backup ersetzt werden.",
    adminBackupHelpText: "Mit dieser Funktion lässt sich die gesamte Applikation sichern. Achten Sie bitte darauf, dass der Pfad 'BackupPath' richtig konfiguriert wurde und der Datenbank Benutzer die nötigen Rechte hat, um ein Backup auszuführen.",
    adminBackupCreatedText: "Erfolgreich erstelltes Backup: {{fileName}} mit einer Größe von {{size}} MB",
    adminCreateBackup: "Backup erstellen",
    generalBackup: "Backup",
    adminRestore: "Aus backup herstellen (Coming soon)",
    loginOneTimePassword: 'Einmalpasswort',
    loginSignIn: 'Anmelden',
    loginInsteadHint: 'Zurück zur Anmeldung',
    loginSignUp: 'Registrieren Sie sich hier!',
    loginOutOfDate: 'Ihr Passwort Scheint abgelaufen zu sein!\nGeben sie bitte ein neues ein',
    newsAddNews: 'Neue Nachricht hinzufügen',
    newsImage: 'Anzeigebild',
    newsProductRelation: 'Produktbeziehungen',
    newsAttachments: "Anhänge",
    newsTranslations: "Übersetzungen",
    managementAboutProd: 'Über die Software:',
    managementAssignmentError: 'Nutzerlimit für diese Lizenz erreicht',
    managementAutoRenewal: 'Automatische Erneuerung:',
    managementBoughtLicences: 'Erworbene Aktivierungen:',
    managementDividerFirstname: 'Vornamen die mit {{sortedKey}} anfangen',
    managementDividerLastname: 'Nachnamen die mit {{sortedKey}} anfangen',
    managementDividerLicence: 'Nutzer mit {{sortedKey}} Lizenz',
    managementDividerNoLicence: 'Nutzer ohne Lizenz',
    managementDividerRole: 'Nutzer mit {{sortedKey}} Berechtigung',
    managementDividerUsername: 'Nutzernamen die mit {{sortedKey}} anfangen',
    managementEditAssignment: 'Lizenz zuweisen',
    managementGroup1None: 'Nicht Gruppieren',
    managementGroup2Licences: 'Lizenz',
    managementGroup6Roles: 'Nutzerrolle',
    managementHeader: 'Erworbene Lizenzen',
    managementLicenceFrom: 'Lizenz erworben am:',
    managementLicenceId: 'Lizenz-ID:',
    managementLicenceTo: 'Lizenz gültig bis:',
    managementMiniFabAdd: 'Vergibt dem Nutzer die Lizenz',
    managementMiniFabRemove: 'Enzieht dem Nutzer die Lizenz',
    managementNewLicence: 'Weitere Lizenzen bestellen',
    managementNextRenewal: 'Nächste Erneuerung:',
    managementNoLicenceOwned: 'Diesem Nutzer sind keine Lizenzen zugewiesen',
    managementNoProductsBooked: 'Sie haben keine Lizenz zu unseren Produkten\nKlicken Sie hier um zur Produkt-Seite weitergeleitet zu werden',
    managementOwnedLicenceHeader: 'Lizenzen, die dem Nutzer zugewiesen sind',
    managementRemainingActivations: 'Verbleibene Aktivierungen:',
    managementProductActive: 'Produkt aktiviert:',
    managementIsDemo: 'Demo Version:',
    managementToOverview: 'Zurück zur Übersicht',
    managementToProduct: 'Zum Produkt',
    managementUserWithLicence: 'Nutzer mit <b>{{product}}</b> Lizenz:',
    managementUserWithoutLicence: 'Nutzer ohne <b>{{product}}</b> Lizenz',
    licenseOrderConfirmation: "Ihre Lizenz wurde erfolgreich bestellt!",
    licenseCostPerUserYear: "pro Benutzer",
    licenseDiscountPerAmount: "Ab <b>{{amount}}</b> Lizenzen:",
    licenseDiscount: "Rabatte",
    licenseDiscountSingular: "Rabatt",
    licenseDiscountInPercent: "Rabatt in %",
    licenseSavedHint: "Sie sparen",
    licenseDiscountOldLicenseHint: "Mögliche zusätzliche Rabatte auf bereits existierende Lizenzen (z.B. Mengenrabatte) werden nach Bestellung automatisch angewandt. Diese werden nur in der aktuellen Kalkulation nicht berücksichtigt.",
    licenseDiscountHint: "Der Lizenzrabatt gilt für alle erworbenen Lizenzen sowie Features, unabhängig vom Zeitpunkt der Bestellung",
    licenseCostPerUserFirstYear: "erstes Jahr",
    licenseCostPerUserSecondYear: "zweites Jahr",
    licenseCostPerUserThirdYear: "drittes und folgende Jahre",
    licenseCostMwst: 'MwSt.',
    licenseCostInklMwst: 'inkl. MwSt.',
    licenseOrderDemo: 'Demo Version bestellen',
    managementProductNoUser: 'Noch kein nutzer Zugewiesen',
    paymentAccountOwner: 'Kontoinhaber',
    paymentAddNewBank: 'Neue Bankverbindung hinzufügen',
    paymentBankName: 'Name der Bank',
    paymentBic: 'BIC',
    paymentIban: 'IBAN',
    paymentPageHeader: 'Bankdaten',
    productSateDraft: "Entwurf",
    productSateAvailable: "Verföffentlicht",
    productSateArchived: "Archiviert",
    productDescriptions: 'Produktbeschreibungen',
    productChoseState: "Wählen Sie den Status aus",
    productManagementSectionText: "Diese Sektion beinhaltet management funktionen, die sich global auf das Produkt auswirken. Diese Funktionen sollten bedacht und mit Umsicht ausgeführt werden, da sich die Aktionen möglicherweise auf das laufende Produktgeschäft auswirken.",
    productLicenceSectionText: "Als Administrator haben Sie die Möglichkeit, Lizenzvereinbarungen für jedes Produkt hochzuladen. Diese Lizenzvereinbarungen werden im Downloadbereich des jeweiligen Produkts angezeigt. Sie dienen dazu, dem Endnutzer klare Informationen über die Nutzungsbedingungen und Einschränkungen des Produkts zu bieten. Durch das Hochladen dieser Vereinbarungen können Sie sicherstellen, dass Ihre Kunden stets gut informiert sind und die Produkte gemäß den festgelegten Richtlinien verwenden.",
    productDeleteHintText: "Löschen Sie dieses Produkt, ist das Produkt nicht mehr für Kunden sichtbar und kann auch nicht mehr bestellt werden. Lediglich laufende Verträge von bestehenden Kuden bleiben erhalten.",
    productArchiveHintText: "Archivieren Sie dieses Produkt, ist es nicht mehr für Kunden sichtbar. Die letzte Änderung wird vorgehalten und bei bedarf können Sie das Produkt wiederherstellen.",
    productPricingAndDiscountSectionText: "In diesem Abschnitt haben Sie die Möglichkeit Preise und Rabatte für Ihr Produkt zu bearbeiten. Diese werden Sofort wirksam. Die Änderungen werden nicht für existente Kunden-Verträge wirksam, sondern erst nach der nächsten Bestellung bzw. Nachbestellung des Kunden.",
    productFeatureSectionText: "Hier können Sie Ihr Produkt anhand von Features für den Kunden beschreiben und in Vorbereitung auf das folgende Preismodell detailliert anpassen. Änderungen am Feature set für bestehende Produkte wirken sich nicht auf bestehende Produkte von Kudnen aus. Werden hier Änderungen vorgenommen, sind diese erst für zukünftige Bestellungen wirksam.",
    productScreenshotsSectionText: "Produktbilder sind für Ihre Kunden das A & O. In dieser Section können Sie diese bearbeiten, löschen oder neue hinzufügen. Beachten Sie, dass Sie hier qualitativ hochwertige und aussagekräftige Bilder nutzen, sodass der Kunde den Fokuks auf die wesentlichen Produktfunktionen behält.",
    productAlreadyBoughtLicences: 'Anzahl gekaufter Lizenzen',
    productAvailableVersions: 'Verfügbare Downloads:',
    productBuyLicence: 'Lizenz erwerben',
    productChooseEmpty: 'Kein Produkt',
    productChooseProduct: 'Wählen Sie ein Produkt aus',
    productChooseVersion: 'Wählen Sie eine Version',
    productMainHeader: 'Unsere Produkte',
    productPaymentInterval: 'Zahlungsintervall',
    productPriceOfLicenceAmount: 'Gesamtpreis der aktuellen Anfrage',
    productPricePerLicence: 'Preis pro Lizenz',
    productProcureAmount: 'Anzahl der angefragten Lizenzen',
    productRelease: 'Neue Produktversion',
    productSearch: 'Suche Nutzer',
    productAvailableFrom: 'Verfügbar von',
    productAvailableTo: 'Verfügbar bis',
    productFeatureOrderableInDemo: 'Bestellbar in Demo-Version',
    productFeatureOrderableInProd: 'Bestellbar in Vollversion',
    newsMainHeader: 'Neuigkeiten',
    newsSubHeader: "Diese Seite ermöglicht es Mitarbeitern und Administratoren, aktuelle Neuigkeiten zu verwalten. Bitte beachten Sie, dass Produktinformationen nur dann relevant sind, wenn bestimmte Neuigkeiten sich auf ein spezifisches Produkt beziehen und nicht auf allgemeine Informationen. Das Veröffentlichungsdatum ist ausschließlich erforderlich, wenn ein Eintrag zu einem zukünftigen Zeitpunkt veröffentlicht werden soll.",
    newsDraft: "Entwurf",
    productSendRequest: 'Anfrage abschicken',
    productOrderAcceptTermsAndCondtionsStart: 'Ich akzeptiere die Bedingungen der',
    productOrderAcceptTermsAndCondtionsEnd: 'Lizenzvereinbarung',
    registerConfirmPassword: 'Passwort (Bestätigung)',
    registerHeader: 'Registrierung',
    releaseDialogPlatform: 'Platform',
    releaseDialogRelease: 'Release auswählen',
    releaseDialogVersion: 'Version',
    productReleaseDate: "Veröffentlicht am",
    productReleaseSize: "Dateigröße",
    sidebarAccount: 'Account',
    sidebarAccountAddresses: 'Adressen',
    sidebarAccountCompany: 'Firma',
    sidebarAccountEmployees: 'Mitarbeiter',
    sidebarAccountGeneral: 'Allgemein',
    sidebarAccountPayment: 'Bankdaten',
    sidebarHome: 'Startseite',
    sidebarLicenceManagement: 'Lizenzen',
    sidebarProducts: 'Produkte',
    userAddNewUser: 'Neuen Nutzer hinzufügen',
    userInfo: 'Nutzerinfo',
    validationCompareEmail: 'Email Adressen stimmen nicht überein',
    validationComparePassword: 'Passwörter stimmen nicht überein',
    validationErrorTypeDecimal: 'Entspricht nicht der geforderten dezimal-Schreibweise',
    validationErrorTypeUpperCase: 'Muss Großbuchstaben enthalten',
    validationErrorTypeNumbers: 'Muss Zahlen enthalten',
    validationErrorTypeLowerCase: 'Muss Kleinbuchstaben enthalten',
    validationErrorTypeNoUpperCase: 'Keine Großbuchstaben erlaubt',
    validationErrorTypeNoNumbers: 'Keine Nummern erlaubt',
    validationErrorTypeNoLowerCase: 'Keine Kleinbuchstaben erlaubt.',
    validationErrorTypeNoSpecialChar: 'Keine Sonderzeichen erlaubt',
    validationErrorTypeNoWhiteSpace: 'Darf kein Leerzeichen enthalten',
    validationErrorTypeSpecialChar: 'Muss Sonderzeichen enthalten',
    validationErrorTypeIban: 'Kein zulässiges Iban Format',
    validationErrorTypeFailedChecksum: 'Iban hat eine Invalide Checksum',
    validationErrorTypeIbanLength: 'Iban ist zu kurz',
    validationInvalidEmail: 'Bitte geben Sie eine gültige E-Mail Adresse an',
    validationIcloudInvalid: 'ICloud E-Mail Adressen werden nicht unterstützt',
    validationInvalidMaxLength: 'Darf nicht mehr als {{length}} Zeichen lang sein!',
    validationInvalidMinLength: 'Muss mehr als {{length}} Zeichen haben!',
    validationInvalidPassword: 'Passwort muss: eine Nummer, einen Großbuchstaben, ein Kleinbuchstaben und ein Sonderzeichen enthalten. Die Mindestlänge liegt bei 8 Zeichen',
    validationInvalidPattern: 'Input soll das folgende format haben: {{pattern}}',
    validationRequired: '{{label}} darf nicht leer sein',
    validationErrorTypePhone: "Bitte geben Sie eine gültige Telefonnummer ein",
    validationErrorTypeUrl: "Bitte geben Sie eine gültige URL ein (muss mit http:// oder https:// beginnen)",
    validationErrorTypeBic: "Bitte geben Sie eine gültige BIC/SWIFT-Nummer ein",
    validationErrorTypePattern: "Ungültiges Format",
    validation_invalidTimeInput:'Eine oder Mehrere Zeitangaben sind nicht Zulässig',
    passwordRecoverConfirmHeader: 'Neues Passwort Festlegen',
    passwordRecoverConfirmNewPassword: 'Neues Passwort',
    passwordRecoverConfirmNewPasswordCon: 'Passwort bestätigen',
    passwordChangeOld: 'Altes Passwort',
    passwordRecoverHeader: 'Passwort zurücksetzen',
    passwordRecoverDescription: 'Um Ihr Passwort zurückzusetzen geben Sie bitte Ihre E-Mail Adresse ein. Sobald Sie diese abschicken, erhalten Sie eine E-Mail mit einem Reset-Link.',
    generalSend: 'Abschicken',
    passwordForgotten: 'Passwort vergessen?',
    addNewsTitle: 'Nachrichten Titel',
    addNewsNewsText: 'Nachrichten Inhalt',
    newsChooseProduct: 'Wählen Sie das zugehörige Produkt aus',
    newsChooseType: "Wählen Sie den News Typ aus",
    newsReleaseDate: "Veröffentlichungsdatum",
    newsChooseProductVersion: 'Wählen Sie die zugehörige Produktversion aus',
    generalSetDefault: 'Als Standard festlegen',
    generalDefault: 'Standard',
    productExtendButtonRelease: 'Release hinzufügen',
    productExtendButtonNews: 'News hinzufügen',
    productExtendButtonProduct: 'Produkt bearbeiten',
    addressTypeDefault: 'Anschrift',
    addressTypeShipping: 'Lieferadresse',
    addressTypeBilling: 'Rechnungsadresse',

    // CRM TRANSLATION KEYS
    dialogHeaderContact: 'Kontaktdetails',
    inPerson: 'Persönlich',
    letter: 'Brief',
    fax: 'Fax',
    carrierPigeon: 'Brieftaube',
    addBusinessHours: 'Öffnungszeiten hinzufügen',
    addRelationType: 'Wähle ein Verbindung:',
    addRelationMinComm: 'Die Nachricht ist eine {{type}} auf:',
    addToDoTitle: 'Neuen ToDo erstellen',
    addToDoTask: 'Aufgabe',
    addToDoText: 'Beschreibung',
    generalWatcher: "Beobachter",
    addProjectDialogeOptionalInfos: 'Optionale Informationen',
    communicationEdit: 'Bearbeiten',
    communicationAddRelation: 'Zusammenhänge',
    communicationAddStatus: 'für den Status',
    communicationDelete: 'Entfernen',
    addCommunicationTitle: 'Neuer Eintrag',
    commDetailEdit: 'Eintrag Bearbeiten',
    commDetailDelete: 'Eintrag Entfernen',
    commDetailTitleInput: 'Titel',
    commDetailTextInput: 'Notizen',
    commDetailTypeInput: 'Nachrichtentyp',
    commDetailParent: 'Diese Nachricht ist eine Antwort auf:',
    commDetailRelationHeader: 'Antworten auf diese Nachricht',
    companyDisplayChangeCompany: 'Unternehmen ändern',
    companyDisplayLocalTime: 'Lokale Zeit',
    companyDisplayBusinessHours: 'Öffnungszeiten',
    companyDisplayContactPerson: 'Ansprechpartner',
    companyDisplayAddNewContact: 'Ansprechpartner hinzufügen',
    companyDisplayLinkNewTracker: 'Neuen Tracker starten',
    companyCreateHeader: 'Neue Firma erstellen',
    companyCreateSetTimeZone: 'Zeitzonen verschiebung (h):',
    companyCreateSetName: 'Firmenname',
    companyCreateSetOpeningTime: 'Öffnungszeiten',
    companyManagerSignatureMissing: 'Hinweis: Folgende Geschäftsführer haben noch keine gültige Unterschrift: ',
    companyManagerSignatureMissingSubText: 'Diese ist für ausgehende Rechnungen oder anderweitigen Schriftverkehr anzugeben.',
    companyTaxNumber: "Steuernummer",
    companySalesTaxNumber: "Umsatzsteuer Nr.",
    companyTaxOffice: "Zuständiges Finanzamt",
    companyCourtOffice: "Name Amtsgericht",
    companyCourtOfficeNr: "Handelsregister Nummer",
    companyCourtOfficePlaceholder: 'z. B. Amtsgericht Braunschweig',
    companyCourtOfficeNrPlaceholder: 'z. B. HRB 4863',
    courtOfficeName: 'Registergericht',
    courtOfficeNr: 'Handelsregisternummer',
    validationCourtOfficeNrRequired: 'Bitte eine Handelsregisternummer angeben, wenn ein Registergericht hinterlegt ist.',
    validationCourtOfficeRequired: 'Bitte ein Registergericht angeben, wenn eine Handelsregisternummer hinterlegt ist.',
    validationPreferredInvoiceFormatEdiIdRequired: 'Für EDIFACT und VDA muss beim Kunden eine EDI Partnerkennung hinterlegt sein.',
    validationPreferredInvoiceFormatVwReferenceRequired: 'Für Volkswagen VDA 4938 T2 muss beim Kunden eine VW Company Reference hinterlegt sein.',
    invoiceExportSellerEdiMissing: 'Die EDI Partnerkennung des Absenders fehlt. Bitte unter Administration → Firmendaten → Elektronischer Rechnungsaustausch hinterlegen.',
    invoiceExportBuyerEdiMissing: 'Die EDI Partnerkennung des Rechnungsempfängers fehlt. Bitte beim Kunden unter Elektronischer Rechnungsaustausch hinterlegen.',
    invoiceExportBuyerVwReferenceMissing: 'Für Volkswagen VDA 4938 T2 fehlt beim Rechnungsempfänger die VW Company Reference.',
    invoiceExportVdaDeliveryDateMissing: 'Für Volkswagen VDA 4938 T2 muss ein Lieferdatum in der Rechnung hinterlegt sein.',
    invoiceExportBuyerVwReferenceInvalid: 'Die VW Company Reference des Rechnungsempfängers muss genau 4 Zeichen lang sein.',
    companyProfitDetermination: "Art der Gewinnermittlung",
    companyFormOfAccounts: "Kontorahmen",
    companyWebsite: "Website",
    companyPhone: "Telefonnummer",
    contactDetailHeader: 'Kontaktdetail',
    contactCreateHeader: 'Erstelle einen neue Kontakt',
    confirmationTitle: 'Eintrag Löschen',
    confirmationText: 'Sind Sie sicher, dass Sie den Eintrag löschen wollen?',
    confirmationDeleteMultipleText: 'Sind Sie sicher, dass Sie die ausgewählten Einträge löschen wollen?',
    confirmationResetText: 'Sind Sie sicher, dass Sie alle Einträge zurücksetzen wollen?',
    dialogRelationMulti: 'Wähle Antworten aus',
    dialogRelationSingle: 'Wähle einen Parent aus',
    dialogRelationSetParent: 'setzte Nachricht als parent',
    dialogRelationSetAnswer: 'setze Nachrichten als antwort',
    filterByWorkflow: 'Nach Ablauf Filtern',
    filterByStatus: 'Nach Status Filtern',
    groupAdd: '',
    groupName: '',
    quickInputHead: 'Schnelldokumentierung',
    quickInputNewCompany: 'Neues Unternehmen erstellen',
    quickInputOldCompany: 'Vorhandes Unternehmen erweitern',
    quickInputTextTitle: 'Titel',
    quickInputText: 'Text',
    generalAdd: 'Hinzufügen',
    generalDate: 'Datum',
    generalCompany: 'Unternehmen',
    generalPronouns: 'Anrede',
    generalFirstName: 'Vorname',
    generalLastName: 'Nachname',
    generalEMail: 'E-Mail',
    generalPhone: 'Telefonnummer',
    generalLogin: 'Anmelden',
    generalContactPerson: 'Ansprechpartner',
    generalNote: 'Notiz',
    generalChooseWorkflow: 'Workflow',
    generalStartingStatus: 'Anfangs Status',
    generalUser: 'Nutzer',
    generalDelete: 'Löschen',
    generalUpdate: 'Aktualisieren',
    generalCurrency: '€',
    generalLock: "Sperren",
    generalUnlock: "Freischalten",
    generalRolesAndPermissions: "Rollen & Rechte",
    generalServerSettings: "Servereinstellungen",
    generalEnvironment: "Umgebungsvariablen",
    generalIntegrations: "Integrationen",
    generalVariablesSettings: "Variablen",
    generalDiagnostics: "Log & Diagnose",
    generalBackupRestore: "Sichern & Wiederherstellen",
    generalAccessManagement: "Rechteverwaltung",
    generalUserAndRoles: "Benutzer & Rechte",
    generalComingSoon: "Demnächst verfügbar",
    generalPaymentMethods: "Bezahlmethoden",
    linkTrackerHeader: 'Neuen Tracker für {{company}} starten',
    linkTrackerProduct: 'Wähle einen Produkt aus',
    linkTrackerTracker: 'Wähle einen gültigen Tracker aus',
    linkTrackerStatus: 'Wähle ein initialen Status aus',
    openingTimeItemOn: 'Am',
    trackerName: 'Tracker Name',
    stepLabelLinktTrackerFirst: 'Tracker Typ + Tracker Name',
    stepLabelLinktTrackerSecond: 'Zusätzliche Informationen',
    openingTimeItemSelectDay: 'Wähle einen Tag',
    openingTimeItemFrom: 'Von',
    openingTimeItemTo: 'Bis',
    projectTableTitle: "Projektübersicht",
    projectTableCustomer: 'Kunde',
    projectTableOrderNr: 'Bestell-Nr. (Kunde)',
    projectTableOfferNr: 'Angebot-Nr. (yasc)',
    projectTableProjectName: 'Projektname',
    projectTableTeam: 'Mitarbeiter',
    projectTableStatus: 'Projektstatus',
    projectTableNextBill: 'Nächste Rechnungstellung',
    projectTableBillFull: 'Rechnungssumme insgesamt',
    projectTableBillPart: 'Teil Betrag',
    projectTableBillDue: 'Fällig am',
    projectTableComments: 'Bemerkung',
    projectTable: 'Fertigstellungsgrad',
    projectTableTask: 'Task',
    projectTableToDo: 'Nächstes TODO',
    projectTableNoBill: 'Keine Abrechnung gefunden',
    projectTabletNoToDo: 'Keine Tickets gefunden',
    projectTableAddRole: 'Rolle',
    projectTableAddInvoiceType: 'Abrechnungs typ',
    projectTableVolume: 'Projektvolumen',
    projectTableInvoiceCnt: 'Anzahl der Abrechnungen',
    projectTablePartialAmount: 'Teil Betrag',
    projectTableDueDate: 'Fälligkeitsdatum',
    projectTableInvoice: 'Abrechnungen',
    projectTableTooSmallDate: 'Das Gewählte Datum ist kleiner als das des letzten bezahlten eintrag und konnte nicht gesetzt werden',
    projectTableCustomerNr: 'Kunden Nr',
    projectTableRemainingAmount: 'Offener Betrag',
    projectAddNewProject: 'Neues Projekt anlegen',
    projectBillsTitle: 'Rechnungsdetails',
    projectBillsHelpTextPre: "In diesem Bereich können Sie Rechnungen für das ausgewählte Projekt verwalten und ausstellen.",
    projectBillsHelpTextAfter: "Rechnungen können bearbeitet werden, bis die Rechnung versendet wurde. Änderungen sind dann nur noch über eine Revision möglich.",
    projectSlideOutTeamHeader: 'Team Details',
    projectTabGeneralTitle: "Projektdetails",
    projectTabGeneralName: "Details",
    projectTabTeamTitle: "Projektteam",
    projectTabTeamName: "Team",
    projectBudgetTitle: "Budgets und Abrechnungsbausteine",
    billingPreferredInvoiceFormat: 'Bevorzugtes Rechnungsformat',
    companyFormSectionGeneral: 'Allgemein',
    companyCustomerNumberPlaceholder: 'Automatisch, wenn leer',
    companyCustomerNumberHint: 'Optional bei der Anlage. Ohne Eingabe wird die nächste freie Kundennummer automatisch vergeben.',
    validationCustomerNumberRequired: 'Die Kundennummer darf beim Bearbeiten nicht leer sein.',
    companyFormSectionTax: 'Steuern und Register',
    companyFormSectionBilling: 'Abrechnung',
    companyFormSectionEdi: 'Elektronischer Rechnungsaustausch',
    companyDescriptionPlaceholder: 'Kurze interne Beschreibung zum Unternehmen',
    billingPreferredInvoiceFormatHint: 'Wird bei neuen Rechnungen für diesen Kunden als bevorzugtes Export und Versandformat vorausgewählt.',
    billingEdifactInterchangeId: 'EDI Partnerkennung',
    billingEdifactInterchangeIdPlaceholder: 'z. B. GLN oder vereinbarte Interchange ID',
    billingEdifactInterchangeIdCustomerHint: 'Technische EDIFACT Empfängerkennung dieses Kunden. Nur für EDIFACT und VDA Exporte erforderlich.',
    billingEdifactCompanyReference: 'VW Company Reference',
    billingEdifactCompanyReferencePlaceholder: 'Vom Volkswagen Partner vorgegebene Company Reference',
    billingEdifactCompanyReferenceHint: 'Nur für Volkswagen VDA 4938 T2 erforderlich. Die Company Reference muss genau 4 Zeichen lang sein.',
    billingEdifactSellerSectionTitle: 'Elektronischer Rechnungsaustausch',
    billingEdifactSellerSectionSubtitle: 'Technische Absenderkennung für EDIFACT und VDA Rechnungen',
    billingEdifactSellerHint: 'Diese Kennung gilt zentral für Ihr Unternehmen als Rechnungsabsender. Die EDI Empfängerkennung wird separat am jeweiligen Kunden gepflegt.',
    projectFormSectionGeneral: 'Allgemein',
    projectFormSectionBilling: 'Abrechnung',
    projectFormSectionPlanning: 'Planung',
    projectFormSectionSettings: 'Weitere Einstellungen',
    general_color: 'Farbe',
    generalBackendRequestFailed: 'Die Anfrage konnte nicht verarbeitet werden.',
    general_validationSummary: 'Bitte die markierten Eingaben prüfen oder offene Listeneinträge übernehmen.',
    projectBudgetEmployee: "Mitarbeiter / gemeinsamer Topf",
    projectBudgetReference: "Vertragsreferenz",
    projectBudgetStart: "Budget- oder Vertragsbeginn",
    projectBudgetEnd: "Budget- oder Vertragsende",
    projectBudgetTotalHours: "Budgetstunden",
    projectBudgetUsedHours: "Fakturierte Stunden",
    projectBudgetActualWorkedHours: "Angefallen",
    projectBudgetOperationalRemainingHours: "Restbudget",
    projectBudgetRemainingHours: "Reststunden zur Fakturierung",
    projectBudgetHourlyRate: "Stundensatz netto",
    projectBudgetTotalNetto: "Budgetwert netto",
    projectBudgetRemainingNetto: "Restwert netto",
    projectBudgetSourceOffer: "Quellangebot",
    projectBudgetPricingModel: "Abrechnungsmodell",
    projectBudgetCurrencyCode: "Währung",
    projectBudgetPlannedHours: "Planstunden (optional)",
    projectBudgetIncludedHours: "Enthaltenes Stundenkontingent",
    projectBudgetDefaultHourlyRate: "Stundensatz netto",
    projectBudgetFixedPrice: "Pauschalbetrag netto",
    projectBudgetAmountLimit: "Kostenobergrenze netto",
    projectBudgetRecurrenceType: "Wiederholung / Bereitstellung",
    projectBudgetRecurrenceInterval: "Individuelles Intervall",
    projectBudgetCarryOverType: "Übertrag ungenutzten Budgets",
    projectBudgetCarryOverLimitHours: "Maximal übertragbare Stunden",
    projectBudgetCarryOverLimitAmount: "Maximal übertragbarer Betrag",
    projectBudgetCarryOverPercentage: "Übertrag in Prozent",
    projectBudgetCarryOverExpirationPeriods: "Verfall nach Perioden",
    projectBudgetOveragePolicy: "Regel bei Überschreitung",
    projectBudgetOverageHourlyRate: "Stundensatz bei Überschreitung",
    projectBudgetFormDescription: "Ein Budget ist ein einzelner Abrechnungsbaustein des Projekts oder eines Vertrags, zum Beispiel Stundenkontingent, Pauschale, Vor Ort Leistung oder zusätzliche Leistung nach Aufwand. Lege zuerst die Zuordnung und anschließend das Abrechnungsmodell fest.",
    projectBudgetSectionAssignment: "Zuordnung",
    projectBudgetSectionBillingModel: "Abrechnungsmodell",
    projectBudgetSectionTerm: "Laufzeit",
    projectBudgetSectionConditions: "Budget und Konditionen",
    projectBudgetSectionRecurrence: "Wiederholung",
    projectBudgetSectionCarryOver: "Übertrag",
    projectBudgetSectionOverage: "Überschreitung",
    projectBudgetSectionAdditional: "Weitere Angaben",
    projectBudgetPricingModelHint: "Wähle zuerst das fachliche Abrechnungsmodell. Die folgenden Eingaben werden automatisch passend dazu ein- oder ausgeblendet.",
    projectBudgetPricingModelDescription: "Nach Aufwand: jede geleistete Stunde wird berechnet. Festpreis: pauschaler Gesamtpreis. Aufwand mit Obergrenze: Abrechnung nach Stunden bis zu einem Stunden- oder Kostenlimit. Stundenkontingent: feste enthaltene Stunden gegen Paketpreis. Wartungsvertrag / Retainer: wiederkehrender Pauschalbetrag, optional mit enthaltenem Stundenkontingent.",
    projectBudgetStartHint: "Ab diesem Datum darf das Budget Leistungen aufnehmen.",
    projectBudgetEndHint: "Optional. Leer lassen, wenn das Budget oder der Vertrag ohne festes Enddatum weiterläuft.",
    projectBudgetPlannedHoursHint: "Nur Plan- und Kalkulationswert. Planstunden begrenzen ein Budget nach Aufwand oder einen Festpreis nicht.",
    projectBudgetIncludedHoursHint: "Verbindlich enthaltenes Stundenkontingent. Bei einem gedeckelten Modell kann es als Stundenobergrenze dienen; bei Stundenpaket und Retainer als enthaltene Leistung.",
    projectBudgetDefaultHourlyRateHint: "Regulärer Nettostundensatz für die Abrechnung nach Aufwand.",
    projectBudgetFixedPriceHint: "Pauschaler Nettobetrag des Festpreises, Stundenpakets oder Retainers.",
    projectBudgetAmountLimitHint: "Beim Modell mit Obergrenze muss mindestens ein Stunden- oder Kostenlimit gesetzt sein. Werden beide gesetzt, gilt die zuerst erreichte Grenze.",
    projectBudgetRecurrenceTypeHint: "Für wiederkehrende Stundenpakete oder Wartungsverträge. Keine Wiederholung bedeutet ein einmaliges Budget; beim Wartungsvertrag / Retainer ist eine Wiederholung erforderlich.",
    projectBudgetRecurrenceIntervalHint: "Nur bei individueller Wiederholung. Gibt die Anzahl der Perioden zwischen zwei Bereitstellungen an.",
    projectBudgetCarryOverTypeHint: "Nur bei wiederkehrenden Budgets. Regelt, ob ungenutztes Budget in die nächste Periode übernommen wird.",
    projectBudgetCarryOverLimitHoursHint: "Maximale Anzahl ungenutzter Stunden, die in die nächste Periode übernommen werden darf.",
    projectBudgetCarryOverLimitAmountHint: "Maximaler ungenutzter Betrag, der in die nächste Periode übernommen werden darf.",
    projectBudgetCarryOverPercentageHint: "Prozentualer Anteil des ungenutzten Budgets, der in die nächste Periode übernommen wird.",
    projectBudgetCarryOverExpirationPeriodsHint: "Anzahl der Perioden, nach denen übertragene Werte verfallen.",
    projectBudgetOveragePolicyHint: "Nur für Budgets mit echter Obergrenze. Legt fest, was mit Leistungen oberhalb des verfügbaren Kontingents passiert.",
    projectBudgetOverageHourlyRateHint: "Optionaler abweichender Nettostundensatz für ausdrücklich abrechenbare Mehrleistung.",
    projectBudgetContract: "Vertrag",
    projectBudgetSectionCapacity: "Kapazität",
    projectBudgetCapacityUnit: "Kapazitätseinheit",
    projectBudgetCapacityInterval: "Kapazitätsintervall",
    projectBudgetCapacityIntervalHint: "Legt fest, wann das Grundkontingent erneut bereitgestellt wird. Dieses Intervall ist unabhängig vom Abrechnungsintervall.",
    projectBudgetHoursPerDay: "Stunden pro Tag",
    projectBudgetHoursPerDayHint: "Umrechnungsfaktor für tagesbasierte Kontingente.",
    projectBudgetConsumptionFactor: "Verbrauchsfaktor",
    projectBudgetConsumptionFactorHint: "Multiplikator für den Kapazitätsverbrauch, zum Beispiel 1,5 für Vor-Ort-Leistungen.",
    projectBudgetManualOnly: "Nur manuelle Zuordnung",
    projectBudgetManualOnlyHint: "Wenn aktiviert, wird das Budget bei der automatischen Zuordnung übersprungen und muss ausdrücklich ausgewählt werden.",
    projectBudgetCapacityUnitEnum: { Hours: 'Stunden', Days: 'Tage' },
    projectBudgetCapacityIntervalEnum: { None: 'Kein wiederkehrendes Kontingent', Weekly: 'Wöchentlich', Monthly: 'Monatlich', Quarterly: 'Quartalsweise', Yearly: 'Jährlich' },
    projectContractEntity: "Verträge",
    projectContractFormTitle: "Vertrag",
    projectContractTitle: "Vertrag",
    projectContractsTitle: "Verträge",
    projectContractsDescription: "Verträge bilden den rechtlichen und zeitlichen Rahmen des Projekts. Abrechnungsregeln und Kontingente werden darunter über Budgets und Abrechnungsbausteine definiert.",
    projectContractNumberDescription: "Interne oder vertraglich vereinbarte Vertragsnummer zur eindeutigen Zuordnung.",
    projectContractNameDescription: "Kurzer sprechender Name, zum Beispiel Wartungs- und Supportvertrag.",
    projectContractStartDescription: "Datum, ab dem der Vertrag für das Projekt gilt.",
    projectContractEndDescription: "Optionales Vertragsende. Leer lassen, wenn der Vertrag unbefristet läuft.",
    projectContractDocumentDescription: "Unterzeichneten Vertrag oder die aktuell gültige Vertragsfassung hinterlegen.",
    projectBudgetCapacityAmount: "Kapazität je Zeitraum",
    projectBudgetCapacityAmountHint: "Kapazität in der gewählten Einheit. Beispiel: 2 Tage bei Kapazitätsintervall Wöchentlich ergibt 2 Tage pro Woche. Bei Tagen wird Stunden pro Tag nur für die Umrechnung von Zeitbuchungen verwendet.",
    calendar_consumptionFactor: "Verbrauchsfaktor",
    calendar_consumptionFactorHint: "Optionaler Faktor nur für diese Zeitbuchung. Beispiel: 1,5 für Vor-Ort-Leistung. Leer bedeutet, dass der Faktor des Budgets verwendet wird.",
    projectContractFormDescription: "Verwaltet die Vertragsklammer für einen Kunden oder ein Projekt. Die kaufmännischen Konditionen bleiben auf den zugeordneten Projektbudgets.",
    projectContractNumber: "Vertragsnummer",
    projectContractStart: "Beginn",
    projectContractEnd: "Ende",
    projectContractDocument: "Vertragsdokument",
    projectContractBudgetCount: "Zugeordnete Budgets",
    projectContractSectionGeneral: "Allgemein",
    projectContractSectionAssignment: "Zuordnung",
    projectContractSectionTerm: "Laufzeit",
    projectContractSectionDocument: "Dokument",
    projectContractSectionAdditional: "Weitere Angaben",
    projectContractStatusEnum: { Draft: 'Entwurf', Active: 'Aktiv', Suspended: 'Pausiert', Terminated: 'Beendet', Expired: 'Abgelaufen' },
    navButtonProjectContracts: "Verträge",
    projectBudgetPricingModelEnum: {
        TimeAndMaterial: 'Abrechnung nach Aufwand',
        FixedPrice: 'Festpreis',
        CappedTimeAndMaterial: 'Aufwand mit Obergrenze',
        PrepaidHours: 'Stundenkontingent / Stundenpaket',
        Retainer: 'Wartungsvertrag / Retainer',
    },
    projectBudgetPricingModelDescriptionEnum: {
        TimeAndMaterial: 'Jede geleistete Stunde wird zum hinterlegten Stundensatz abgerechnet. Geeignet für Leistungen nach Aufwand ohne feste Preisobergrenze.',
        FixedPrice: 'Die vereinbarte Leistung wird zu einem festen Gesamtpreis abgerechnet. Geplante Stunden dienen nur der internen Kapazitätsplanung.',
        CappedTimeAndMaterial: 'Die Leistung wird nach Aufwand abgerechnet, jedoch nur bis zur festgelegten Stunden- oder Betragsobergrenze.',
        PrepaidHours: 'Ein festes Stundenkontingent wird gegen einen Paketpreis bereitgestellt. Das Kontingent kann periodisch erneuert und nach den Übertragsregeln in Folgeperioden übernommen werden.',
        Retainer: 'Wiederkehrende pauschale Vergütung, optional mit enthaltenem Kontingent. Geeignet für Wartungs- und Supportverträge mit regelmäßiger Grundvergütung.',
    },
    projectBudgetRecurrenceTypeEnum: {
        None: 'Einmalig / keine Wiederholung', Monthly: 'Monatlich', Quarterly: 'Quartalsweise', Yearly: 'Jährlich', Custom: 'Individuell',
    },
    projectBudgetCarryOverTypeEnum: {
        None: 'Kein Übertrag', Full: 'Vollständig', Limited: 'Begrenzt', Percentage: 'Prozentual',
    },
    projectBudgetOveragePolicyEnum: {
        Billable: 'Zusätzlich abrechenbar', NonBillable: 'Nicht abrechenbar', RequiresApproval: 'Nur nach Freigabe', NotAllowed: 'Nicht zulässig',
    },
    projectTabTodoTitle: "Projektaufgaben",
    projectTabTodoName: "Todos",
    projectTabTaskTitle: "Projekttasks",
    projectTabTaskName: "Tasks",
    projectTabInvoicesTitle: "Rechnungen",
    projectTabInvoicesName: "Rechnungen",
    projectTableStart: 'Projektstart',
    projectTableEnd: 'Projektende',
    projectRequireProjectBudget: 'Projektbudget bei Zeiterfassung erforderlich',
    projectBudgetBookingLabel: 'Projektbudget',
    projectBudgetBookingRequired: 'Bitte ein Projektbudget für diese Buchung auswählen.',
    projectRequireTasks: 'Aufgaben erforderlich',
    general_internalName: 'Interner Name',
    invoiceNumber: 'Rechnungsnummer',
    invoicePaymentTarget: 'Zahlungsziel',
    invoicePaidOn: 'Bezahlt am',
    projectCreatedInvoices: "Erzeugte Rechnungen",
    StartDate:'Start Datum',
    EndDate:'End Datum',
    StartTime:'Start Zeit',
    EndTime:'End Zeit',
    inRange:'Überlappt mit anderem Eintrag',
    endBefore:'Ende Liegt Vor dem Start',
    descriptionOrTask:'Wähle eine Aufgabe oder füge eine beschreibung hinzu',
    appointmentColor:'Termin Farbe',
    timeManagerImportExcel:'Excel importieren',
    calendarWeekView: 'Kalenderansicht der Woche',
    calendarWorkingWeek: 'Arbeitswoche',
    calendarFullWeek: 'Ganze Woche',
    statusHeaderCurrent: 'Status des Unternehmens',
    statusHeaderNoTrackerFound: 'Keine Tracker gefunden',
    toDoNoGroupsFound: 'Keine ToDo Gruppen gefunden',
    toDoCreateNewGroup: 'Neue Gruppe Erstellen',
    toDoNoTodosFoundInGroup: 'Keine ToDos in der Gruppe gefunden',
    toDoAddNew: 'Neues Todo anlegen',
    noTrackerFound: 'Keine Tracker gefunden',
    tracker: 'Tracker',
    noTrackers: 'Keine Tracker vorhanden. ',
    convertToTask: 'in Task umwandeln',
    noContractsFound: 'Keine Verträge gefunden',
    navInventory: 'Inventar',
    navGlobalVariables: "Variables",
    navResources: "Ressourcen",
    navDiagnosticLogs: "Server Logs",
    navButtonHumanResources: "Ressourcenplanung",
    navButtonProjectBudgets: "Projekt Budgets",
    navButtonTimeManagement: "Zeit Manager",
    navButtonApproveOffDay: "Urlab Bestätigen",
    navCp: "Kundenportal",
    navCrm: "CRM",
    navFibu: "Buchhaltung",
    navFin: "Finanzen",
    navButtonDashboard: 'Home',
    navButtonTracker: 'Nachverfolgung',
    navButtonDiagram: 'Diagramme',
    navButtonWorkflow: 'Workflow',
    navButtonToDo: 'Aufgaben',
    navButtonProject: 'Projekte',
    navButtonCompany: 'Firmen',
    navButtonContacts: 'Kontakte',
    navFibUnpostedVouchers: 'Ungebuchte Belege',
    navFibTransactions: 'Transaktionen',
    navFibBatchBooking: 'Stapelbuchung',
    navFibUnbookedVouchers: "Ungebuchte Beläge",
    navFibBankAccounts: 'Bankverbindungen',
    navFibJournal: 'Journal',
    navFibOffers: 'Angebote',
    navFibInvoices: 'Rechnungen',
    navGlobalPermissions: "Globale Berechtigungen",
    generalPermissions: "Berechtigungen",
    generalPermission: "Berechtigung",
    permissionActionBase: "Gruppe",
    permissionActionName: "Aktion",
    navUsers: "Benutzerliste",
    navGlobalRoles: "Globale Rollen",
    navFibRecurring: 'Wiederkehrend',
    navFibTemplates: 'Import Templates',
    navFibBankSettings: "Banken",
    navFibAccountPlan: "Kontenplan",
    navFibRecurringTitle: 'Wiederkehrende Buchungen',
    navFibExport: 'Export',
    navFibAccountCreate: "Konto erstellen",
    navEmailClients: "Email-Clients",
    finTransactions: "Bank-Transaktionen",
    finBank: "Bank",
    finCashBox: "Kasse",
    finSelectBankAccount: "Bitte wählen Sie das zugehörige Bankkonto",
    none: 'Keine Abrechnung',
    evenDistro: 'Gleichmäßige aufteilung',
    custom: 'Selbsterstellt',
    asTheyCome: 'Ad Hoc',
    fibuForms: "Aktive WebForms",
    fibuBookingDate: 'Buchungsdatum',
    fibuBookingPrefix: 'Kürzel',
    fibuBookingNumber: 'Buchungsnummer',
    fibuBookingText: 'Buchungstext',
    fibuBookingTotal: 'Betrag',
    fibuBookingTotalBrutto: 'Brutto Betrag',
    fibuBookingTotalNetto: 'Nettopreis',
    fibuBookingAmountType: 'Betrag Typ',
    fibuBookingCredit: 'Soll',
    fibuAddCredit: 'Splittung Soll',
    fibuAddDebit: 'Splittung Haben',
    fibuBookingDebit: 'Haben',
    fibuBookingAccount: 'Buchungskonto',
    fibuBookingAccountAddPattern: "Fügen Sie ein Regulären Ausdruck hinzu, um die automatisierte Zuordnung von Rechnungsnummern zu verbessern",
    fibuBookingVatAccount: 'Steuerkonto',
    fibuBookItems: 'Buchen',
    fibuBookItemsDialog: 'Wollen Sie alle Einträge in das Journal buchen?',
    fibuBookItemsNum: 'Wollen Sie wirklich {{amount}} Einträge in das Journal buchen?',
    fibuBookItemsSingle: 'Wollen Sie wirklich einen Eintrag in das Journal buchen?',
    fibuBookItemsDialogSingle: 'Wirklich in Journal buchen?',
    fibuOnlyNewBookings: "Nur neue Belege",
    fibuDatevDistributionChannels: "Vertriebswege",
    fibuVoucherType: "Belegeart",
    fibuAddVouchers: "Belege hinzufügen",
    fibuBookingType: "Buchungsart",
    fibuExportOptions: "Export",
    fibuImportDialogMappingTitle: "Zuordnung Importdaten",
    fibuImportDialogMappingSubText: "Bitte geben Sie Auskunft über die Zuordnung ihrer Quelldaten. Dieser Dialog importiert Umsatzdaten aus den verschiedensten Systemen, mit Hilfe von bereits angelegten Schemata. Mit diesen werden die in der Datei vorhandenen Daten in das Zielsystem übertragen. Ein schema können Sie jederzeit unter Buchhaltung / Tempaltes definierten oder ändern.",
    fibuTemplateName: "Name des Templates",
    fibuBookingImportTemplates: "Import Vorlagen (Templates)",
    fibuSelectedUploadTemplate: "Ausgewähltes Upload-Template",
    fibuBookedBy: "Gebucht von",
    fibuAmount: "Betrag",
    fibuAccountNumber: "Nr",
    fibuAccountName: "Account Name",
    fibuAccountType: "Account Typ",
    fibuAccountCategory: "Account Kategorie",
    fibuAccountTaxAccount: "Standard Steuersatz",
    fibuCredit: "Kreditor",
    fibuDebit: "Debitor",
    fibuGlAccount: "Sachkonto",
    fibuCreateImportTemplateTitle: "Import Vorlage erstellen",
    fibuImportTemplateHelpTextPre: "Laden Sie eine CSV-Datei hoch, aus der Sie ein Template erstellen möchten",
    fibuImportTemplateHelpTextAfter: "Anschließend können Sie die Quellspalten für die benötigten Buchungsinformationen auswählen",
    fibuCreateAccountPlan: "Erstellen Sie einen Kontotyp für Ihre Buchhaltung. Der Kontotyp Debitor/Kreditor oder Sachkonto ist entscheidend für die Kalkulation und die steuerlich korrekte Zuordnung von Buchungen",
    fibuCreateBooking: "Stapelbuchung erstellen",
    fibuCreateBookingHelpTextPre: "Erstellen Sie hier eine neue Buchung für den Buchungsstapel. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich auch gleich Ihre Belege an.",
    fibuCreateBookingHelpTextAfter: "Nach dem Speichern ist die Buchung sofort im Stapel verfügbar.",
    fibuCreateTxAlias: "Gläubiger Alias erstellen",
    fibuCreateTxAliasHelpTextPre: "Erstellen Sie hier einen neuen Alias für einen Gläubiger. Dieser wird unteranderem für die automatische Transaktionszuordnung verwendet werden. Oft hat ein Gläubiger wie z.B.'Amazon' mehrere Identitäten wenn es um Banktransaktionen geht. Beispielsweise werden im Bankverkehr Namen wie 'AMAZON EU S.A R.L.' oder 'AMAZON PAYMENTS EUROPE S.C.A.' benutzt",
    fibuCreateTxAliasTextAfter: "Bestimmen Sie im folgenden ein oder mehrere Aliase für Ihren Gläubiger um die automatische Zuordnung zu verbessern.",
    fibuCurrentAliasNames: "Aktuelle Aliasse",
    fibuNoAliasNamesPresent: "Kein Aliasse vorhanden",
    fibuFinancialYear: "Geschäftsjahr",
    fibuFinancialMonth: "Buchungsmonat",
    fibuBalanceSheet: "Bilanz",
    fibuIncomeSurplusCalculation: "EÜR",
    fibuGeneralAccountType: "Kontotyp",
    fibuHasSplits: "Splitbuchung",
    fibuBookingMaskDefault: "Standart Buchungsmaske",
    fibuBookingMaskAccount: "Buchungsmaske über Bankkonto",
    fibuBookingError: "Hinweise",
    fibuConCreate: "Bankverbindung herstellen",
    fibuConMakeConnection: "Verbindung herstellen",
    fibuConRemoveConnection: "Verbindung trennen",
    fibuConForwardFinapi: "Weiter zur Anmeldung",
    finApiBankId: "FinApi BankId",
    fibuConCreateHelpText: "Geben Sie Ihre Zugangsdaten für Ihre ausgewählte Verbindung ein. Ihre Eingaben werden verschlüsselt an die Bank übermittelt.",
    fibuConCreateHelpText2: "Die Verbindungsdaten werden ausschließlich dafür verwendet Umsätze anzuzeigen und Buchungen zuzuordnen.",
    fibuTransactionsBooked: "Gebucht",
    fibuTransactionsAccountNumber: "Account Nummer",
    fibuTransactionsBankBookingDate: "Buchungstag",
    fibuTransactionsCounterpart: "Gläubiger",
    fibuTransactionsPurpose: "Verwendungszweck",
    fibuTransactionsTotal: "Betrag",
    fibuFinApiStatusPENDING: "Erstellt",
    fibuFinApiStatusINPROGRESS: "In Verarbeitung",
    fibuFinApiStatusREADY: "Verbunden",
    fibuLocalBookingAccount: "Lokales Buchungskonto",
    fibuExportLexwareXml: "Lexware XML Export",
    fibuExportLexwareCsv: "Lexware CSV Export",
    fibuExportTotal: "Buchungen insgesamt",
    fibuExportNewBookings: "Neue Buchungen",
    fibuExportSelected: "Buchungen betroffen",
    fibuExportNotSelected: "Buchungen nicht betroffen",
    fibuRecurrence: "Tag der Ausführung",
    fibuBookedRecurring: "{{booking}} wurde erfolgreich in den Stapel übertragen",
    fibuSplitCredit: "Soll",
    fibuSplitDebit: "Haben",
    fibuBookingSource: "Quelle",
    fibuImportReceipts: "Belege importieren",
    bookingSourceManual: "Manuell",
    bookingSourceRecurring: "Buchungsvorlage",
    bookingSourceFinApi: "FinApi",
    bookingSourceEmail: "Email",
    bookingSourceLexware: "Lexware",
    bookingSourceOcrImport: "OcrImport",
    finApiCreated: "Erstellt",
    finApiPending: "Wartend",
    finApiConnected: "Verbunden",
    finApiFailure: "Fehler",
    finApiPaused: "Pausiert",
    generalExecutionDay: "Ausführungstag",
    generalInterval: "Interval",
    generalFormat: "Format",
    generalDateFrom: "Datum von",
    generalDateUntil: "Datum bis",
    generalCreatedBy: "Erstellt von",
    generalStatus: "Status",
    generalVouchers: "Belege",
    generalRegexExpressions: "Reguläre Ausdrücke",
    daily: "Täglich",
    weekly: "Wöchentlich",
    monthly: "Monatlich",
    semiAnnual: "Halbjährlich",
    annual: "Jährlich",
    datevFormatJournalBased: "DATEV Journal basiert",
    datevBookingBased: "DATEV Buchungs basiert",
    datevStammdaten: "DATEV Stammdaten basiert",
    standardNetto: "Netto",
    standardBrutto: "Brutto",
    verkaufsrechnung: "Verkaufsrechnung",
    einkaufsrechnung: "Einkaufsrechnung",
    verkaufsGutschrift: "VerkaufsGutschrift",
    einkaufsGutschrift: "EinkaufsGutschrift",
    verkaufsSchlussrechnung: "VerkaufsSchlussrechnung",
    einkaufsSchlussrechnung: "EinkaufsSchlussrechnung",
    gutschriftsanzeige: "Gutschriftsanzeige",
    ausgangsrechnung: "Ausgangsrechnung",
    ausgehendeGutschrift: "AusgehendeGutschrift",
    gutschriftanzeige: "Gutschriftanzeige",
    eingangsrechnung: "Eingangsrechnung",
    eingehendeGutschrift: "Eingehende Gutschrift",
    eingehendeZahlung: "Eingehende Zahlung",
    ausgehendeZahlung: "Ausgehende Zahlung",
    sachbuchung: "Sachbuchung",
    vortragsbuchung: "Vortragsbuchung",
    eingehendeManuelleErfassung: "Eingehende manuelle Erfassung",
    ausgehendeManuelleErfassung: "Ausgehende manuelle Erfassung",
    skr03: "Skr-03",
    skr04: "Skr-04",

    emailIntegrationFormularCreate: "Email-Client erstellen",
    emailIntegrationFormularUpdate: "Email-Client aktualisieren",
    emailIntegrationFormularHelpTextPre: "Erstellen Sie hier einen neuen globalen Email-Client. Füllen Sie mindestens alle Pflichtfelder aus.",
    emailIntegrationFormularHelpTextAfter: "Dieser kann für zahlreiche Features innerhalb der applikation verwendet werden.",
    emailIntegrationClientType: "Client Typ",
    emailIntegrationEmail: "Email",
    emailIntegrationHost: "Host",
    emailIntegrationPort: "Port",
    emailIntegrationUserName: "Username",
    emailIntegrationPassword: "Passwort",
    emailIntegrationUseSsl: "Ssl verwenden",
    emailIntegrationDescription: "Beschreibung",
    emailIntegrationLastUsed: "Zuletzt verwendet",
    emailConnectionStatus: "Verbindungsstatus",
    emailIntegrationTestReceiver: "Empfänger Test Email",
    emailTestConnection: "Verbindung Testen",
    connectionSuccessText: "Verbindung hergestellt",
    connectionFailedText: "Verbindung fehlgeschlagen",

    ///CRM WORKFLOW
    workflowUsedIn: 'Genutzt in {{count}} {{type}}',
    workflowNotUsed: 'keinem',
    workflowAdd: 'Workflow hinzufügen',
    workflowUpdate: 'Änderung übernehmen',
    workflowDiscard: 'Änderungen verwerfen',
    workflowAddStatus: 'Status hinzufügen',
    workflowAddTransition: 'Link hinzufügen',
    statusAdvanceTo: 'Aktuellen Projekt status auf {{status}} setzen',
    currentStatus: 'Aktueller Status',
    nextPossibleStatus: 'Nächsten Mögliche Status',
    toDo: 'To-Do',
    toDoPlu: 'To-Do´s',
    product: 'Produkt',
    productPlu: 'Produkten',
    project: 'Projekt',
    projectPlu: 'Projekten',
    noProject: 'Es liegen keine Projekte vor',
    recruitment: 'Rekrutierung',
    name: 'Name',
    color: 'Farbe',
    description: 'Beschreibung',
    label: 'Link Label',
    from: 'Von',
    to: 'Nach',
    save: 'Speichern',
    cancel: 'Abbrechen',
    workflowLinksToStates: 'Verbindungen zu anderen Status',
    fromStatus: 'von Status',
    toStatus: 'zu Status',
    transition: 'Übergang',
    statusFilterNone: 'Kein Status Ausgewählt',
    statusFilterAll: 'Alle Status ausgewählt',

    Daily: 'Tagesansicht',
    Weekly: 'Wochenansicht',
    Monthly: 'Monatsansicht',
    Yearly: 'Jährlich',
    recExpandAll: 'Alle ausklappen',
    recCollapseAll: 'Alle einklappen',
    recDateRangeSetting: 'Von - Bis Einstellung',

    plannedHour: 'Verplante Stunden',
    estimatedHour: 'Erwartete Stunden',
    usedTime: 'Genutzte Zeit',
    user: 'Nutzer',

    addInvoice: 'Rechnung hinzufügen',
    sendInvoice: 'Rechnung senden',
    paymentTarget: 'Rechnungsziel',
    paidOn: 'Bezahlt am',
    paid: 'Bezahlt',
    date: 'Datum',
    amount: 'Anzahl',
    price: 'Kosten',
    unit: 'Einheit',
    add: 'Hinzufügen',
    remaining: 'noch zu Zahlen',

    recDateOffset: '',

    recOpenDialog: 'Wiederkehrend',
    directiveStart: '',
    task: 'Aufgabe',
    recStart: 'Start',
    recDuration: 'Dauer',
    recFrequency: 'Frequence',
    recInterval: 'Interval',
    recEnd: 'Ende',
    recEndOption: 'End Option',
    recCount: 'Anzahl',
    recProjectView: 'Projektansicht',
    recUserView: 'Mitarbeiteransicht',
    addNewProject: 'Neues Projekt hinzufügen',
    addWorkflow: 'Workflow hinzufügen',
    workflowEditorShowEdgeLabel: 'Kanten Label anzeigen',
    workflowEditorStatusSettings: 'Status Einstellung',
    workflowEditorEdgeSettings: 'Link Einstellung',
    center: 'Ansicht zentrieren',
    humanResourcesInvalidTimeInput: 'Nicht zugelassener Wert',

    timeManagerHalfDay: 'Halben Tag',
    timeManagerFullDay: 'Ganzen Tag',
    timeManagerSubmit: 'Urlaub einreichen',
    timeManagerVacation: 'Urlaub Buchen',
    timeManagerBookedVacation: 'Gebuchter Urlaub',
    timeManagerApproved: 'Genemigt',
    timeManagerApprovalPending: 'Genemigung Austehend',
    Vacation: 'Urlaub',
    SickDay: 'Krank',
    Holiday: 'Feiertag',
    TimeCompensation: 'Zeitausgleich',

    timeManagerUsedHoursForYear: 'Gebuchte stunden für das jahr {{year}}',
    timeManagerOverTimeTargetHours: 'Soll Stunden',
    timeManagerCalendarWeek: 'KW',
    timeManagerOverTimeActualHours: 'Ist Stunden',
    timeManagerMonthBreakdown: 'Monats Ansicht',
    timeManagerOverTime: 'Überstunden',

    calendar_noEntries: "Keine Einträge für diesen Tag",
    calendar_event_type: "Eventtyp",
    calendarTypeWorkTime: "Arbeitszeit",
    calendarTypeVacation: "Urlaub",
    calendarTypeTimeOff: "Stundenausgleich",
    calendarTypeSick: "Krank",
    calendarTypeAppointment: "Termin",
    calendarTypeUnknown: "Eintrag",

    calendar_allDay: "Ganztägig",
    yearCalendar_month_missingEntry_tooltip: 'Zeiterfassung fehlt. Klicken öffnet den betreffenden Tag.',
    calendar_dayPart: "Tagesabschnitt",
    calendar_carryOver: "Übertrag",

    calendar_dayPartNone: "Kein Teil",
    calendar_dayPartMorning: "Vormittag",
    calendar_dayPartAfternoon: "Nachmittag",
    calendar_dayPartFullDay: "Ganzer Tag",

    calendar_halfDay_disabled_tooltip: "Halbtägige Einträge sind nur bei einem einzigen Tag möglich.",

    calendar_action_edit: "Bearbeiten",
    calendar_action_edit_tooltip: "Diesen Eintrag bearbeiten",
    calendar_action_withdraw: "Zurückziehen",
    calendar_action_withdraw_tooltip: "Diesen ausstehenden Antrag zurückziehen",
    calendar_action_cancel: "Stornieren",
    calendar_action_cancel_tooltip: "Diesen genehmigten Eintrag stornieren (mit Historie)",
    calendar_action_delete: "Löschen",
    calendar_action_delete_tooltip: "Diesen Eintrag endgültig entfernen",
    calendar_action_approve: "Genehmigen",
    calendar_action_approve_tooltip: "Diesen Antrag genehmigen",
    calendar_action_reject: "Ablehnen",
    calendar_action_reject_tooltip: "Diesen Antrag ablehnen",
    calendar_action_showHistory: "Verlauf anzeigen",
    calendar_action_showHistory_tooltip: "Entscheidungs- und Änderungsverlauf anzeigen",
    calendar_action_acceptInvitation: "Einladung annehmen",
    calendar_action_acceptInvitation_tooltip: "Diese Einladung annehmen",
    calendar_action_declineInvitation: "Einladung ablehnen",
    calendar_action_declineInvitation_tooltip: "Diese Einladung ablehnen",

    calendar_recurrence: "Wiederholung",
    calendar_recurrencePreset: "Wiederholungs Vorlage",

    calendar_recurrenceNone: "Keine Wiederholung",
    calendar_recurrenceDaily: "Täglich",
    calendar_recurrenceWeekly: "Wöchentlich",
    calendar_recurrenceWeekdays: "Wochentage Mo bis Fr",
    calendar_recurrenceMonthly: "Monatlich",

    calendar_recurrenceHintExample: "Beispiel FREQ=WEEKLY;BYDAY=MO,WE,FR",
    calendar_currentWeek: "Kalenderwoche",

    calendar_help_allDay: "Setzt Uhrzeit automatisch auf den ganzen Tag. Die Auswertung behandelt den Eintrag als Tagesereignis.",
    calendar_help_dayPart: "Legt fest, ob der Eintrag als halber oder ganzer Tag gewertet wird. Wird vor allem bei Abwesenheiten genutzt.",
    calendar_help_carryOver: "Markierung für Auswertung und Kontingente. Wird nur bei Urlaub und Stundenausgleich verwendet.",
    calendar_help_recurrence: "Erzeugt wiederkehrende Einträge. Für Arbeitszeit und Termine verfügbar.",

    calendar_summary_title: "Zusammenfassung",
    calendar_summary_range: "Zeitraum",
    calendar_summary_duration: "Zeitspanne",
    calendar_summary_counting: "Wertung",
    calendar_summary_recurrence: "Wiederholung",
    calendar_summary_carryOverFlag: "Übertrag aktiv",

    calendar_summary_counting_timeSpan: "Wird anhand der Zeitspanne ausgewertet.",
    calendar_summary_counting_allDay: "Wird als ganztägig ausgewertet.",
    calendar_summary_counting_dayPart: "Wird über den Tagesabschnitt ausgewertet.",

    calendar_section_required: "Pflichtangaben",
    calendar_recentTitles_label: "Zuletzt verwendet:",
    calendar_section_optional: "Optionale Angaben",
    calendar_section_advanced: "Erweitert",
    calendarEntryLabelShort_workTime: "AZ",
    calendarEntryLabelShort_vacation: "U",
    calendarEntryLabelShort_timeOff: "ZA",
    calendarEntryLabelShort_publicHoliday: "FT",
    calendarEntryLabelShort_sick: "K",
    calendarEntryLabelShort_appointment: "T",
    calendarEntryLabelShort_unknown: "E",
    calendarEntryLabel_workTime: "Arbeitszeit",
    calendarEntryLabel_vacation: "Urlaub",
    calendarEntryLabel_timeOff: "Zeitausgleich",
    calendarEntryLabel_sick: "Krank",
    calendarEntryLabel_appointment: "Termin",
    calendarEntryLabel_unknown: "Eintrag",

    validation_requiredTitle: "Titel ist erforderlich",
    validation_requiredProject: "Projekt ist erforderlich",
    validation_requiredDescription: "Beschreibung ist erforderlich",

    validation_rRuleMissing: "RRULE fehlt",
    validation_invalidRRule: "Ungültige Wiederholungsregel",
    validation_invalidTimeZoneId: "Ungültige Zeitzone",

    Monday: 'Montag',
    Tuesday: 'Dienstag',
    Wednesday: 'Mittwoch',
    Thursday: 'Donnerstag',
    Friday: 'Freitag',
    Saturday: 'Samstag',
    Sunday: 'Sonntag',

    // Contracting - general
    navContracting: 'Verträge und Lizenzen',
    navContractAssignment: 'Vertragsübersicht',

    // Contracting - LicenseAssignment - general
    navLicenseAssignment: 'Lizenzübersicht',
    tableLicenseAssignment: 'Tabelle Lizenzübersicht',
    emptyPageTextLicenseAssignment: 'Es sind noch keine Einträge für Lizenzen erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - LicenseAssignment - attributes
    contractingLicenseAssignmentGuid: "Guid",
    contractingLicenseAssignmentCreatedAt: "Erstellungsdatum",
    contractingLicenseAssignmentCreatedBy: "Erstellt durch",
    contractingLicenseAssignmentUpdatedAt: "Aktualisierungsdatum",
    contractingLicenseAssignmentUpdatedBy: "Aktualisiert durch",
    contractingLicenseAssignmentDeviceCount: "Anzahl Endgeräte",
    contractingLicenseAssignmentName: "Lizenzname",
    contractingLicenseAssignmentTitle: "Lizenztitel",
    contractingLicenseAssignmentDescription: "Beschreibung der Lizenz",

    // Contracting - LicenseAssignment - attributes tooltips
    contractingLicenseAssignmentGuidTooltip: "TODO Tooltip Guid",
    contractingLicenseAssignmentCreatedAtTooltip: "TODO Tooltip Erstellungsdatum",
    contractingLicenseAssignmentCreatedByTooltip: "TODO Tooltip Erstellt durch",
    contractingLicenseAssignmentUpdatedAtTooltip: "TODO Tooltip Aktualisierungsdatum",
    contractingLicenseAssignmentUpdatedByTooltip: "TODO Tooltip Aktualisiert durch",
    contractingLicenseAssignmentDeviceCountTooltip: "TODO Tooltip Anzahl Endgeräte",
    contractingLicenseAssignmentNameTooltip: "TODO Tooltip Lizenzname",
    contractingLicenseAssignmentTitleTooltip: "TODO Tooltip Lizenztitel",
    contractingLicenseAssignmentDescriptionTooltip: "TODO Tooltip Beschreibung der Lizenz",

    contractingCreateLicenseAssignment: "Neuen Eintrag einer Lizenz erstellen",
    contractingCreateLicenseAssignmentHelpTextPre: "Erstellen Sie hier einen neuen Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingCreateLicenseAssignmentHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht verfügbar.",

    contractingUpdateLicenseAssignment: "Bestehenden Eintrag einer Lizenz aktualisieren",
    contractingUpdateLicenseAssignmentHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingUpdateLicenseAssignmentHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht aktualisiert.",

    // Contracting - LicenseAssignment - ConfirmationDialogComponent
    contractingUpdateLicenseAssignmentCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen einer neuen Lizenz abbrechen wollen?",
    contractingUpdateLicenseAssignmentUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren einer bestehenden Lizenz ({{guid}}) abbrechen wollen?",
    contractingUpdateLicenseAssignmentDeleteConfirmation: "Sind Sie sicher, daß Sie die bestehende Lizenz ({{guid}}) löschen wollen?",

    // Contracting - LicenseAssignment - notifications
    contractingUpdateLicenseAssignmentNotificationCreateCancel: "Das Erstellen einer neuen Lizenz wurde abgebrochen.",
    contractingUpdateLicenseAssignmentNotificationCreateSuccess: "Die neue Lizenz wurde erfolgreich erstellt.",

    contractingUpdateLicenseAssignmentNotificationUpdateCancel: "Das Aktualisieren einer bestehenden Lizenz ({{guid}}) wurde abgebrochen.",
    contractingUpdateLicenseAssignmentNotificationUpdateSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateLicenseAssignmentNotificationDeleteSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich gelöscht.",


    // update starts here
    // Contracting - general
    // navContracting: 'Contracting',

    // Contracting - DeviceData - general
    navDeviceData: 'Geräteübersicht',
    tableDeviceData: 'Tabelle Geräteübersicht',
    emptyPageTextDeviceData: 'Es sind noch keine Einträge für Geräte erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - DeviceData - attributes label
    contractingDeviceDataGuidLabel: "Guid",
    contractingDeviceDataCreatedAtLabel: "CreatedAt",
    contractingDeviceDataUpdatedAtLabel: "UpdatedAt",
    contractingDeviceDataCreatedByLabel: "CreatedBy",
    contractingDeviceDataUpdatedByLabel: "UpdatedBy",
    contractingDeviceDataMachineUniqueIdLabel: "MachineUniqueId",
    contractingDeviceDataMachineHostNameLabel: "MachineHostName",
    contractingDeviceDataCpuArchitectureLabel: "CpuArchitecture",
    contractingDeviceDataKernelTypeLabel: "KernelType",
    contractingDeviceDataKernelVersionLabel: "KernelVersion",
    contractingDeviceDataPrettyProductNameLabel: "PrettyProductName",
    contractingDeviceDataProductTypeLabel: "ProductType",
    contractingDeviceDataProductVersionLabel: "ProductVersion",
    contractingDeviceDataInstallationDateLabel: "InstallationDate",
    contractingDeviceDataActiveLabel: "Active",
    contractingDeviceDataMachineUserLabel: "MachineUser",
    contractingDeviceDataIpV6Label: "IpV6",
    contractingDeviceDataIpV4Label: "IpV4",
    contractingDeviceDataNoteLabel: "Note",

    // Contracting - DeviceData - attributes tooltips
    contractingDeviceDataGuidToolTip: "Guid",
    contractingDeviceDataCreatedAtToolTip: "Created At",
    contractingDeviceDataUpdatedAtToolTip: "Updated At",
    contractingDeviceDataCreatedByToolTip: "Created By",
    contractingDeviceDataUpdatedByToolTip: "Updated By",
    contractingDeviceDataMachineUniqueIdToolTip: "Machine Unique Id",
    contractingDeviceDataMachineHostNameToolTip: "Machine Host Name",
    contractingDeviceDataCpuArchitectureToolTip: "Cpu Architecture",
    contractingDeviceDataKernelTypeToolTip: "Kernel Type",
    contractingDeviceDataKernelVersionToolTip: "Kernel Version",
    contractingDeviceDataPrettyProductNameToolTip: "Pretty Product Name",
    contractingDeviceDataProductTypeToolTip: "Product Type",
    contractingDeviceDataProductVersionToolTip: "Product Version",
    contractingDeviceDataInstallationDateToolTip: "Installation Date",
    contractingDeviceDataActiveToolTip: "Active",
    contractingDeviceDataMachineUserToolTip: "Machine User",
    contractingDeviceDataIpV6ToolTip: "Ip V6",
    contractingDeviceDataIpV4ToolTip: "Ip V4",
    contractingDeviceDataNoteToolTip: "Note",

    // Contracting - DeviceData - attributes placeholder
    contractingDeviceDataGuidPlaceholder: "Guid",
    contractingDeviceDataCreatedAtPlaceholder: "Created At",
    contractingDeviceDataUpdatedAtPlaceholder: "Updated At",
    contractingDeviceDataCreatedByPlaceholder: "Created By",
    contractingDeviceDataUpdatedByPlaceholder: "Updated By",
    contractingDeviceDataMachineUniqueIdPlaceholder: "Machine Unique Id",
    contractingDeviceDataMachineHostNamePlaceholder: "Machine Host Name",
    contractingDeviceDataCpuArchitecturePlaceholder: "Cpu Architecture",
    contractingDeviceDataKernelTypePlaceholder: "Kernel Type",
    contractingDeviceDataKernelVersionPlaceholder: "Kernel Version",
    contractingDeviceDataPrettyProductNamePlaceholder: "Pretty Product Name",
    contractingDeviceDataProductTypePlaceholder: "Product Type",
    contractingDeviceDataProductVersionPlaceholder: "Product Version",
    contractingDeviceDataInstallationDatePlaceholder: "Installation Date",
    contractingDeviceDataActivePlaceholder: "Active",
    contractingDeviceDataMachineUserPlaceholder: "Machine User",
    contractingDeviceDataIpV6Placeholder: "Ip V6",
    contractingDeviceDataIpV4Placeholder: "Ip V4",
    contractingDeviceDataNotePlaceholder: "Note",

    contractingCreateDeviceData: "Neuen Eintrag eines Geräts erstellen",
    contractingCreateDeviceDataHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Geräts für die Geräteübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Gerät an.",
    contractingCreateDeviceDataHelpTextAfter: "Nach dem Speichern ist das erstellte Gerät sofort in der Geräteübersicht verfügbar.",

    contractingUpdateDeviceData: "Bestehenden Eintrag einer DeviceData aktualisieren",
    contractingUpdateDeviceDataHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Geräts für die Geräteübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Gerät an.",
    contractingUpdateDeviceDataHelpTextAfter: "Nach dem Speichern ist das erstellte Gerät sofort in der Geräteübersicht aktualisiert.",

    // Contracting - DeviceData - ConfirmationDialogComponent
    contractingUpdateDeviceDataCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Geräts abbrechen wollen?",
    contractingUpdateDeviceDataUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Geräts ({{guid}}) abbrechen wollen?",
    contractingUpdateDeviceDataDeleteConfirmation: "Sind Sie sicher, daß Sie das bestehende Gerät ({{guid}}) löschen wollen?",

    // Contracting - DeviceData - notifications
    contractingUpdateDeviceDataNotificationCreateCancel: "Das Erstellen eines neuen Geräts wurde abgebrochen.",
    contractingUpdateDeviceDataNotificationCreateSuccess: "Das neue Gerät wurde erfolgreich erstellt.",

    contractingUpdateDeviceDataNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Geräts ({{guid}}) wurde abgebrochen.",
    contractingUpdateDeviceDataNotificationUpdateSuccess: "Das bestehende Gerät ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateDeviceDataNotificationDeleteSuccess: "Das bestehende Gerät ({{guid}}) wurde erfolgreich gelöscht.",

    // Contracting - LicenseData - general
    navLicenseData: 'Lizenzübersicht',
    tableLicenseData: 'Tabelle Lizenzübersicht',
    emptyPageTextLicenseData: 'Es sind noch keine Einträge für Lizenzen erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Contracting - LicenseData - attributes label
    contractingLicenseDataGuidLabel: "Guid",
    contractingLicenseDataCreatedAtLabel: "CreatedAt",
    contractingLicenseDataUpdatedAtLabel: "UpdatedAt",
    contractingLicenseDataCreatedByLabel: "CreatedBy",
    contractingLicenseDataUpdatedByLabel: "UpdatedBy",
    contractingLicenseDataLicenseIdLabel: "LicenseId",
    contractingLicenseDataLicenceValidLabel: "LicenceValid",
    contractingLicenseDataLicenseTypeLabel: "LicenseType",
    contractingLicenseDataLicensePeriodLabel: "LicensePeriod",
    contractingLicenseDataProductNameLabel: "ProductName",
    contractingLicenseDataProductVersionLabel: "ProductVersion",
    contractingLicenseDataProductDescriptionLabel: "ProductDescription",
    contractingLicenseDataLicenceStartLabel: "LicenceStart",
    contractingLicenseDataLicenceExpiresLabel: "LicenceExpires",
    contractingLicenseDataAutoRenewEnabledLabel: "AutoRenewEnabled",
    contractingLicenseDataUserAllowedLabel: "UserAllowed",
    contractingLicenseDataUserAssignedLabel: "UserAssigned",
    contractingLicenseDataUserLeftLabel: "UserLeft",
    contractingLicenseDataDevicesAllowedLabel: "DevicesAllowed",
    contractingLicenseDataDevicesAssignedLabel: "DevicesAssigned",
    contractingLicenseDataDevicesLeftLabel: "DevicesLeft",
    contractingLicenseDataLicenseKeyLabel: "LicenseKey",
    contractingLicenseDataFallbackProductVersionLabel: "FallbackProductVersion",
    contractingLicenseDataTerminationPeriodLabel: "TerminationPeriod",
    contractingLicenseDataTerminationDateLabel: "TerminationDate",
    contractingLicenseDataLicenseCostLabel: "LicenseCost",
    contractingLicenseDataLicenseCostPerUserYearLabel: "LicenseCostPerUserYear",
    contractingLicenseDataAttachmentListLabel: "AttachmentList",

    // Contracting - LicenseData - attributes tooltips
    contractingLicenseDataGuidToolTip: "Guid",
    contractingLicenseDataCreatedAtToolTip: "Created At",
    contractingLicenseDataUpdatedAtToolTip: "Updated At",
    contractingLicenseDataCreatedByToolTip: "Created By",
    contractingLicenseDataUpdatedByToolTip: "Updated By",
    contractingLicenseDataLicenseIdToolTip: "License Id",
    contractingLicenseDataLicenceValidToolTip: "Licence Valid",
    contractingLicenseDataLicenseTypeToolTip: "License Type",
    contractingLicenseDataLicensePeriodToolTip: "License Period",
    contractingLicenseDataProductNameToolTip: "Product Name",
    contractingLicenseDataProductVersionToolTip: "Product Version",
    contractingLicenseDataProductDescriptionToolTip: "Product Description",
    contractingLicenseDataLicenceStartToolTip: "Licence Start",
    contractingLicenseDataLicenceExpiresToolTip: "Licence Expires",
    contractingLicenseDataAutoRenewEnabledToolTip: "Auto Renew Enabled",
    contractingLicenseDataUserAllowedToolTip: "User Allowed",
    contractingLicenseDataUserAssignedToolTip: "User Assigned",
    contractingLicenseDataUserLeftToolTip: "User Left",
    contractingLicenseDataDevicesAllowedToolTip: "Devices Allowed",
    contractingLicenseDataDevicesAssignedToolTip: "Devices Assigned",
    contractingLicenseDataDevicesLeftToolTip: "Devices Left",
    contractingLicenseDataLicenseKeyToolTip: "License Key",
    contractingLicenseDataFallbackProductVersionToolTip: "Fallback Product Version",
    contractingLicenseDataTerminationPeriodToolTip: "Termination Period",
    contractingLicenseDataTerminationDateToolTip: "Termination Date",
    contractingLicenseDataLicenseCostToolTip: "License Cost",
    contractingLicenseDataLicenseCostPerUserYearToolTip: "License Cost Per User Year",
    contractingLicenseDataAttachmentListToolTip: "Attachment List",

    // Contracting - LicenseData - attributes placeholder
    contractingLicenseDataGuidPlaceholder: "Guid",
    contractingLicenseDataCreatedAtPlaceholder: "Created At",
    contractingLicenseDataUpdatedAtPlaceholder: "Updated At",
    contractingLicenseDataCreatedByPlaceholder: "Created By",
    contractingLicenseDataUpdatedByPlaceholder: "Updated By",
    contractingLicenseDataLicenseIdPlaceholder: "License Id",
    contractingLicenseDataLicenceValidPlaceholder: "Licence Valid",
    contractingLicenseDataLicenseTypePlaceholder: "License Type",
    contractingLicenseDataLicensePeriodPlaceholder: "License Period",
    contractingLicenseDataProductNamePlaceholder: "Product Name",
    contractingLicenseDataProductVersionPlaceholder: "Product Version",
    contractingLicenseDataProductDescriptionPlaceholder: "Product Description",
    contractingLicenseDataLicenceStartPlaceholder: "Licence Start",
    contractingLicenseDataLicenceExpiresPlaceholder: "Licence Expires",
    contractingLicenseDataAutoRenewEnabledPlaceholder: "Auto Renew Enabled",
    contractingLicenseDataUserAllowedPlaceholder: "User Allowed",
    contractingLicenseDataUserAssignedPlaceholder: "User Assigned",
    contractingLicenseDataUserLeftPlaceholder: "User Left",
    contractingLicenseDataDevicesAllowedPlaceholder: "Devices Allowed",
    contractingLicenseDataDevicesAssignedPlaceholder: "Devices Assigned",
    contractingLicenseDataDevicesLeftPlaceholder: "Devices Left",
    contractingLicenseDataLicenseKeyPlaceholder: "License Key",
    contractingLicenseDataFallbackProductVersionPlaceholder: "Fallback Product Version",
    contractingLicenseDataTerminationPeriodPlaceholder: "Termination Period",
    contractingLicenseDataTerminationDatePlaceholder: "Termination Date",
    contractingLicenseDataLicenseCostPlaceholder: "License Cost",
    contractingLicenseDataLicenseCostPerUserYearPlaceholder: "License Cost Per User Year",
    contractingLicenseDataAttachmentListPlaceholder: "Attachment List",

    contractingCreateLicenseData: "Neuen Eintrag einer Lizenz erstellen",
    contractingCreateLicenseDataHelpTextPre: "Erstellen Sie hier einen neuen Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingCreateLicenseDataHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht verfügbar.",

    contractingUpdateLicenseData: "Bestehenden Eintrag einer Lizenz aktualisieren",
    contractingUpdateLicenseDataHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag einer Lizenz für die Lizenzübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente der Lizenz an.",
    contractingUpdateLicenseDataHelpTextAfter: "Nach dem Speichern ist die erstellte Lizenz sofort in der Lizenzübersicht aktualisiert.",

    // Contracting - LicenseData - ConfirmationDialogComponent
    contractingUpdateLicenseDataCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen einer neuen Lizenz abbrechen wollen?",
    contractingUpdateLicenseDataUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren einer bestehenden Lizenz ({{guid}}) abbrechen wollen?",
    contractingUpdateLicenseDataDeleteConfirmation: "Sind Sie sicher, daß Sie die bestehende Lizenz ({{guid}}) löschen wollen?",

    // Contracting - LicenseData - notifications
    contractingUpdateLicenseDataNotificationCreateCancel: "Das Erstellen einer neuen Lizenz wurde abgebrochen.",
    contractingUpdateLicenseDataNotificationCreateSuccess: "Die neue Lizenz wurde erfolgreich erstellt.",

    contractingUpdateLicenseDataNotificationUpdateCancel: "Das Aktualisieren einer bestehenden Lizenz ({{guid}}) wurde abgebrochen.",
    contractingUpdateLicenseDataNotificationUpdateSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich aktualisiert.",

    contractingUpdateLicenseDataNotificationDeleteSuccess: "Die bestehende Lizenz ({{guid}}) wurde erfolgreich gelöscht.",

    // Inventory - Article - general
    navArticle: 'Artikelübersicht',
    tableArticle: 'Tabelle Artikelübersicht',
    emptyPageTextArticle: 'Es sind noch keine Einträge für Artikel erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Article - attributes label
    inventoryArticleGuidLabel: "Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtLabel: "Erstellungszeitpunkt",
    inventoryArticleUpdatedAtLabel: "Aktualisierungszeitpunkt",
    inventoryArticleCreatedByLabel: "Erstellt von",
    inventoryArticleUpdatedByLabel: "Aktualisiert von",
    inventoryArticleBrandLabel: "Marke",
    inventoryArticleProductImageLabel: "Produktbild",
    inventoryArticleModelLabel: "Modell",
    inventoryArticleModelNumberLabel: "Modellnummer",
    inventoryArticleModelCategoryLabel: "Kategorie",
    inventoryArticleWeightLabel: "Gewicht",
    inventoryArticleDimensionsLabel: "Abmessungen",
    inventoryArticleManufactureDateLabel: "Herstelldatum",
    inventoryArticleModelDescriptionLabel: "Beschreibung",
    inventoryArticleLinkLabel: "Link",
    inventoryArticleWarrantyLabel: "Garantie",

    // Inventory - Article - attributes tooltips
    inventoryArticleGuidToolTip: "Tooltip Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtToolTip: "Tooltip Erstellungszeitpunkt",
    inventoryArticleUpdatedAtToolTip: "Tooltip Aktualisierungszeitpunkt",
    inventoryArticleCreatedByToolTip: "Tooltip Erstellt von",
    inventoryArticleUpdatedByToolTip: "Tooltip Aktualisiert von",
    inventoryArticleBrandToolTip: "Tooltip Marke",
    inventoryArticleProductImageToolTip: "Tooltip Produktbild",
    inventoryArticleModelToolTip: "Tooltip Modell",
    inventoryArticleModelNumberToolTip: "Tooltip Modellnummer",
    inventoryArticleModelCategoryToolTip: "Tooltip Kategorie",
    inventoryArticleWeightToolTip: "Tooltip Gewicht",
    inventoryArticleDimensionsToolTip: "Tooltip Abmessungen",
    inventoryArticleManufactureDateToolTip: "Tooltip Herstelldatum",
    inventoryArticleModelDescriptionToolTip: "Tooltip Beschreibung",
    inventoryArticleLinkToolTip: "Tooltip Link",
    inventoryArticleWarrantyToolTip: "Tooltip Garantie",

    // Inventory - Article - attributes placeholder
    inventoryArticleGuidPlaceholder: "Placeholder Universell eindeutiger Identifikator",
    inventoryArticleCreatedAtPlaceholder: "Placeholder Erstellungszeitpunkt",
    inventoryArticleUpdatedAtPlaceholder: "Placeholder Aktualisierungszeitpunkt",
    inventoryArticleCreatedByPlaceholder: "Placeholder Erstellt von",
    inventoryArticleUpdatedByPlaceholder: "Placeholder Aktualisiert von",
    inventoryArticleBrandPlaceholder: "Placeholder Marke",
    inventoryArticleProductImagePlaceholder: "Placeholder Produktbild",
    inventoryArticleModelPlaceholder: "Placeholder Modell",
    inventoryArticleModelNumberPlaceholder: "Placeholder Modellnummer",
    inventoryArticleModelCategoryPlaceholder: "Placeholder Kategorie",
    inventoryArticleWeightPlaceholder: "Placeholder Gewicht",
    inventoryArticleDimensionsPlaceholder: "Placeholder Abmessungen",
    inventoryArticleManufactureDatePlaceholder: "Placeholder Herstelldatum",
    inventoryArticleModelDescriptionPlaceholder: "Placeholder Beschreibung",
    inventoryArticleLinkPlaceholder: "Placeholder Link",
    inventoryArticleWarrantyPlaceholder: "Placeholder Garantie",

    inventoryCreateArticle: "Neuen Eintrag eines Artikels erstellen",
    inventoryCreateArticleHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Artikels für die Artikelübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateArticleHelpTextAfter: "Nach dem Speichern ist der erstellte Artikel sofort in der Artikelübersicht verfügbar.",

    inventoryUpdateArticle: "Bestehenden Eintrag eines Artikels aktualisieren",
    inventoryUpdateArticleHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Artikels für die Artikelübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Artikel an.",
    inventoryUpdateArticleHelpTextAfter: "Nach dem Speichern ist der erstellte Artikel sofort in der Artikelübersicht aktualisiert.",

    // Inventory - Article - ConfirmationDialogComponent
    inventoryUpdateArticleCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Artikels abbrechen wollen?",
    inventoryUpdateArticleUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Artikel ({{title}} - {{guid}}) abbrechen wollen?",
    inventoryUpdateArticleDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Artikel ({{title}} - {{guid}}) löschen wollen?",

    // Inventory - Article - Import 
    inventoryImportCsvArticleListDialogText: "Import Artikel",
    inventoryImportCsvArticleListDialogSubText: "Bitte wählen Sie den Dateinamen der CSV-Datei für den Import neuer Artikeln aus.",

    inventoryImportExcelArticleListDialogText: "Import Artikel",
    inventoryImportExcelArticleListDialogSubText: "Bitte wählen Sie den Dateinamen der Excel-Datei für den Import neuer Artikeln aus.",

    // Inventory - Article - notifications - entry
    inventoryUpdateArticleNotificationCreateCancel: "Das Erstellen eines neuen Artikels wurde abgebrochen.",
    inventoryUpdateArticleNotificationCreateSuccess: "Der neue Artikel ({{title}} - {{guid}}) wurde erfolgreich erstellt.",
    inventoryUpdateArticleNotificationCreateError: "Der neue Artikel konnte nicht erstellt werden.",
    inventoryUpdateArticleNotificationCreateUndefinedError: "Der neue Artikel konnte nicht erstellt werden, da er nicht spezifiziert ist.",

    inventoryUpdateArticleNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Artikels ({{title}} - {{guid}}) wurde abgebrochen.",
    inventoryUpdateArticleNotificationUpdateSuccess: "Der bestehende Artikel ({{title}} - {{guid}}) wurde erfolgreich aktualisiert.",
    inventoryUpdateArticleNotificationUpdateError: "Der bestehende Artikel ({{title}} - {{guid}}) konnte nicht aktualisiert werden.",
    inventoryUpdateArticleNotificationUpdateUndefinedError: "Der bestehende Artikel konnte nicht aktualisiert werden, da er nicht spezifiziert ist.",

    inventoryUpdateArticleNotificationDeleteSuccess: "Der bestehende Artikel ({{title}} - {{guid}}) wurde erfolgreich gelöscht.",
    inventoryUpdateArticleNotificationDeleteError: "Der bestehende Artikel ({{title}} - {{guid}}) konnte nicht gelöscht werden.",
    inventoryUpdateArticleNotificationDeleteUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht spezifiziert ist.",

    // Inventory - Article - notifications - entry list
    inventoryUpdateArticleNotificationCreateListCancel: "Das Erstellen der neuen Artikel wurde abgebrochen.",
    inventoryUpdateArticleNotificationCreateListSuccess: "Die neuen Artikel wurden erfolgreich erstellt.",
    inventoryUpdateArticleNotificationCreateListError: "Die neuen Artikel konnten nicht erstellt werden.",
    inventoryUpdateArticleNotificationCreateListUndefinedError: "Die neuen Artikel konnte nicht erstellt werden, da keine spezifiziert wurden.",

    inventoryUpdateArticleNotificationUpdateListCancel: "Das Aktualisieren der bestehenden Artikels ({{guidList}}) wurde abgebrochen.",
    inventoryUpdateArticleNotificationUpdateListSuccess: "Die bestehenden Artikel ({{guidList}}) wurden erfolgreich aktualisiert.",
    inventoryUpdateArticleNotificationUpdateListError: "Die bestehenden Artikel ({{guidList}}) konnten nicht aktualisiert werden.",
    inventoryUpdateArticleNotificationUpdateListUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht definiert ist.",

    inventoryUpdateArticleNotificationDeleteListSuccess: "Die bestehenden Artikel ({{guidList}}) wurden erfolgreich gelöscht.",
    inventoryUpdateArticleNotificationDeleteListError: "Die bestehenden Artikel ({{guidList}}) konnten nicht gelöscht werden.",
    inventoryUpdateArticleNotificationDeleteListUndefinedError: "Der bestehende Artikel konnte nicht gelöscht werden, da er nicht definiert ist.",

    // Inventory - Computer - general
    navComputer: 'Computerübersicht',
    tableComputer: 'Tabelle Computerübersicht',
    emptyPageTextComputer: 'Es sind noch keine Einträge für Computer erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Computer - attributes label
    inventoryComputerTypeLabel: "Typ",
    inventoryComputerWLANLabel: "WLAN",
    inventoryComputerBluetoothLabel: "Bluetooth",
    inventoryComputerCellularLabel: "Mobilfunk",
    inventoryComputerDisplayLabel: "Monitor",
    inventoryComputerPowerConsumptionIdleLabel: "Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullLabel: "Leistungsaufnahme Volllast",
    inventoryComputerConnectionListLabel: "Anschlüsse",

    // Inventory - Computer - attributes tooltips
    inventoryComputerTypeToolTip: "Tooltip Typ",
    inventoryComputerWLANToolTip: "Tooltip WLAN",
    inventoryComputerBluetoothToolTip: "Tooltip Bluetooth",
    inventoryComputerCellularToolTip: "Tooltip Mobilfunk",
    inventoryComputerDisplayToolTip: "Tooltip Monitor",
    inventoryComputerPowerConsumptionIdleToolTip: "Tooltip Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullToolTip: "Tooltip Leistungsaufnahme Volllast",
    inventoryComputerConnectionListToolTip: "Tooltip Anschlüsse",

    // Inventory - Computer - attributes placeholder
    inventoryComputerTypePlaceholder: "Placeholder Typ",
    inventoryComputerWLANPlaceholder: "Placeholder WLAN",
    inventoryComputerBluetoothPlaceholder: "Placeholder Bluetooth",
    inventoryComputerCellularPlaceholder: "Placeholder Mobilfunk",
    inventoryComputerDisplayPlaceholder: "Placeholder Monitor",
    inventoryComputerPowerConsumptionIdlePlaceholder: "Placeholder Leistungsaufnahme im Leerlauf",
    inventoryComputerPowerConsumptionFullPlaceholder: "Placeholder Leistungsaufnahme Volllast",
    inventoryComputerConnectionListPlaceholder: "Placeholder Anschlüsse",

    inventoryCreateComputer: "Neuen Eintrag eines Computers erstellen",
    inventoryCreateComputerHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Computers für die Computerübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateComputerHelpTextAfter: "Nach dem Speichern ist der erstellte Computer sofort in der Computerübersicht verfügbar.",

    inventoryUpdateComputer: "Bestehenden Eintrag eines Computers aktualisieren",
    inventoryUpdateComputerHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Computers für die Computerübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Computer an.",
    inventoryUpdateComputerHelpTextAfter: "Nach dem Speichern ist der erstellte Computer sofort in der Computerübersicht aktualisiert.",

    // Inventory - Computer - ConfirmationDialogComponent
    inventoryUpdateComputerCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Computers abbrechen wollen?",
    inventoryUpdateComputerUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Computer ({{guid}}) abbrechen wollen?",
    inventoryUpdateComputerDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Computer ({{guid}}) löschen wollen?",

    // Inventory - Computer - notifications
    inventoryUpdateComputerNotificationCreateCancel: "Das Erstellen eines neuen Computers wurde abgebrochen.",
    inventoryUpdateComputerNotificationCreateSuccess: "Der neue Computer wurde erfolgreich erstellt.",

    inventoryUpdateComputerNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Computers ({{guid}}) wurde abgebrochen.",
    inventoryUpdateComputerNotificationUpdateSuccess: "Der bestehende Computer ({{guid}}) wurde erfolgreich aktualisiert.",

    inventoryUpdateComputerNotificationDeleteSuccess: "Der bestehende Computer ({{guid}}) wurde erfolgreich gelöscht.",

    // Inventory - Display - general
    navDisplay: 'Monitorübersicht',
    tableDisplay: 'Tabelle Monitorübersicht',
    emptyPageTextDisplay: 'Es sind noch keine Einträge für Monitor erstellt worden. Wählen Sie unter folgenden Optionen:',

    // Inventory - Display - attributes label
    inventoryDisplayColorLabel: "Farbe",
    inventoryDisplayDiagonalLabel: "Diagonale",
    inventoryDisplayImageFormatLabel: "Bildformat",
    inventoryDisplayResolutionLabel: "Auflösung",
    inventoryDisplayRefreshRateLabel: "Bildwiederholfrequenz",
    inventoryDisplayResponseTimeLabel: "Reaktionszeit",
    inventoryDisplayContrastLabel: "Kontrast",
    inventoryDisplayBrightnessLabel: "Helligkeit",
    inventoryDisplayShapeLabel: "Form",
    inventoryDisplayPanelLabel: "Panel",
    inventoryDisplayViewingAngleLabel: "Blickwinkel",
    inventoryDisplayPowerConsumptionLabel: "Leistungsaufnahme",
    inventoryDisplayConnectionListLabel: "Anschlüsse",

    // Inventory - Display - attributes tooltips
    inventoryDisplayColorToolTip: "Tooltip Farbe",
    inventoryDisplayDiagonalToolTip: "Tooltip Diagonale",
    inventoryDisplayImageFormatToolTip: "Tooltip Bildformat",
    inventoryDisplayResolutionToolTip: "Tooltip Auflösung",
    inventoryDisplayRefreshRateToolTip: "Tooltip Bildwiederholfrequenz",
    inventoryDisplayResponseTimeToolTip: "Tooltip Reaktionszeit",
    inventoryDisplayContrastToolTip: "Tooltip Kontrast",
    inventoryDisplayBrightnessToolTip: "Tooltip Helligkeit",
    inventoryDisplayShapeToolTip: "Tooltip Form",
    inventoryDisplayPanelToolTip: "Tooltip Panel",
    inventoryDisplayViewingAngleToolTip: "Tooltip Blickwinkel",
    inventoryDisplayPowerConsumptionToolTip: "Tooltip Leistungsaufnahme",
    inventoryDisplayConnectionListToolTip: "Tooltip Anschlüsse",

    // Inventory - Display - attributes placeholder
    inventoryDisplayColorPlaceholder: "Placeholder Farbe",
    inventoryDisplayDiagonalPlaceholder: "Placeholder Diagonale",
    inventoryDisplayImageFormatPlaceholder: "Placeholder Bildformat",
    inventoryDisplayResolutionPlaceholder: "Placeholder Auflösung",
    inventoryDisplayRefreshRatePlaceholder: "Placeholder Bildwiederholfrequenz",
    inventoryDisplayResponseTimePlaceholder: "Placeholder Reaktionszeit",
    inventoryDisplayContrastPlaceholder: "Placeholder Kontrast",
    inventoryDisplayBrightnessPlaceholder: "Placeholder Helligkeit",
    inventoryDisplayShapePlaceholder: "Placeholder Form",
    inventoryDisplayPanelPlaceholder: "Placeholder Panel",
    inventoryDisplayViewingAnglePlaceholder: "Placeholder Blickwinkel",
    inventoryDisplayPowerConsumptionPlaceholder: "Placeholder Leistungsaufnahme",
    inventoryDisplayConnectionListPlaceholder: "Placeholder Anschlüsse",

    inventoryCreateDisplay: "Neuen Eintrag eines Monitors erstellen",
    inventoryCreateDisplayHelpTextPre: "Erstellen Sie hier einen neuen Eintrag eines Monitors für die Monitorübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem inventory an.",
    inventoryCreateDisplayHelpTextAfter: "Nach dem Speichern ist der erstellte Monitor sofort in der Monitorübersicht verfügbar.",

    inventoryUpdateDisplay: "Bestehenden Eintrag eines Monitors aktualisieren",
    inventoryUpdateDisplayHelpTextPre: "Aktualisieren Sie hier einen bestehenden Eintrag eines Monitors für die Monitorübersicht. Füllen Sie mindestens alle Pflichtfelder aus, hängen Sie bestmöglich die Dokumente dem Monitor an.",
    inventoryUpdateDisplayHelpTextAfter: "Nach dem Speichern ist der erstellte Monitor sofort in der Monitorübersicht aktualisiert.",

    // Inventory - Display - ConfirmationDialogComponent
    inventoryUpdateDisplayCreateConfirmation: "Sind Sie sicher, daß Sie das Erstellen eines neuen Monitors abbrechen wollen?",
    inventoryUpdateDisplayUpdateConfirmation: "Sind Sie sicher, daß Sie das Aktualisieren eines bestehenden Monitor ({{guid}}) abbrechen wollen?",
    inventoryUpdateDisplayDeleteConfirmation: "Sind Sie sicher, daß Sie den bestehenden Monitor ({{guid}}) löschen wollen?",

    // Inventory - Display - notifications
    inventoryUpdateDisplayNotificationCreateCancel: "Das Erstellen eines neuen Monitors wurde abgebrochen.",
    inventoryUpdateDisplayNotificationCreateSuccess: "Der neue Monitor wurde erfolgreich erstellt.",

    inventoryUpdateDisplayNotificationUpdateCancel: "Das Aktualisieren eines bestehenden Monitors ({{guid}}) wurde abgebrochen.",
    inventoryUpdateDisplayNotificationUpdateSuccess: "Der bestehende Monitor ({{guid}}) wurde erfolgreich aktualisiert.",

    inventoryUpdateDisplayNotificationDeleteSuccess: "Der bestehende Monitor ({{guid}}) wurde erfolgreich gelöscht.",

    // update ends here

    //TimeManager
    timeManagerTaskListFav: 'Markiert',
    timeManagerTaskListProj: 'Projekte',
    timeManagerTaskListRecent: 'Zuletzt verwendet',
    timeManagerTaskListAssigned: 'Zuweisung',
    timeManagerTaskListAll: 'Alle',
    timeManagerFavourite: 'Markierte Aufgaben',
    timeManagerNotFavourite: 'Unmarkierte Aufgaben',
    timeManagerLow: 'Niedrig',
    timeManagerModerate: 'Moderat',
    timeManagerHigh: 'Hoch',
    timeManagerNone: 'Keine',
    timeManagerAssignedToMe: 'An mich zugeteilt',
    timeManagerNotAssignedToMe: 'nicht an mich zugeteilt',
    timeManagerAll: 'Alle',
    timeManagerDisplayedCw: 'Angezeigte Kalender Woche:',
    timeManagerResetDate: 'Zur aktuellen Woche',
    timeManagerDndTable: 'Wochen Tabelle',
    timeManagerWeeklyTables: 'Erweiterte Wochen Tabelle',
    timeManagerWorkTime: 'Arbeitszeit',
    resetPermissionTooltip: "Setzt alle Berechtigungen auf Standardwerte zurück",
    notifyResetDone: "Standardberechtigungen wurden widerhergestellt",
    roleProjectManager: "PJM",
    roleProjectManagerTip: "Projekt-Manager",
    roleUser: "Benutzer",
    roleUserTip: "Standardbenutzer",
    roleHr: "HR",
    roleHrTip: "Human Resource - Manager",
    roleBookkeeper: "Bh",
    roleBookkeeperTip: "Buchhalter",
    roleFinancier: "FM",
    roleFinancierTip: "Finanz-Manager",
    roleOrderAndLicensing: "BLM",
    roleOrderAndLicensingTip: "Bestellung- & Lizenzierungs-Manager",
    roleInventoryManager: "Inv",
    roleInventoryManagerTip: "Inventar-Manager",
    roleProductManager: "PDM",
    roleAcquisitionManager: 'Akquise',
    roleBillingManager: 'Abrechnung',
    roleProductManagerTip: "Produkt-Manager",
    userDetailsView: "Benutzer: {{username}}",
    userDetailsInfo: "Hier können Sie alle Benutzerinformationen einsehen und bearbeiten. Auch eine Rechtezuweisung ist möglich. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userDetailsInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in Übersicht aktualisiert.",
    userSecurityInfo: "Hier können Sie alle Sicherheitsrelevanten Funktionen einsehen und ausführen. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userSecurityInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in Übersicht aktualisiert.",
    userSecurityResetPw: "Passwort zurücksetzen",
    userSecurityLastPasswordChange: "Letzte Passwortänderung",
    userSecurityLockoutEnd: "Gesperrt bis",
    userSecurityLastLogin: "Letztes Login",
    userSecurityRegisteredSince: "Registriert seit",
    userSecurityIsActive: "Aktiv",
    general: "Allgemein",
    generalActive: "Aktiv",
    userSecurityPwSetSuccess: "Passwort erfolgreich gesetzt.",
    userSecurityRequirePasswordChange: "Benutzer muss Passwort nach der Anmeldung ändern",
    userSecurityGenerateTempPw: "Temporäres Passwort generieren",
    userSecurityGenerateTempPwText: "Erstellt ein neues temporäres Passwort, entsperrt den Benutzer und erzwingt nach der nächsten Anmeldung eine Passwortänderung.",
    userSecurityGenerateAndSendPw: "Generieren und senden",
    userSecurityTemporaryPwGeneratedSuccess: "Temporäres Passwort wurde erstellt und versendet.",
    userSecurityLockUser: "Benutzer sperren",
    userSecurityLockAndUnlock: "Sperren & Freischalten",
    userSecurityUnlockUser: "Benutzer freischalten",
    userSecurityLockoutUserSuccess: "Benutzer erfolgreich gesperrt",
    userSecurityUnlockUserSuccess: "Benutzer erfolgreich freigeschaltet",
    userRolesInfo: "Hier können Sie alle Rechte einsehen und ändern. Seien Sie sich über die möglichen Konsequenzen von Änderungen für den jeweiligen Benutzer bewusst.",
    userRolesInfoTextAfter: "Nach dem Speichern wird der Benutzer sofort in der Übersicht aktualisiert.",
    userUpdatedSuccess: "Benutzer erfolgreich aktualisiert",
    paymentEditTitle: "Bankverbindung bearbeiten",
    paymentEditHelpTextPre: "Hier können Sie Ihre Bankverbindung einsehen und ändern. Auch Sicherheitsgründen werden nicht alle Informationen gezeigt. Sie können Die Bankverbindung dennoch aktualisieren.",
    paymentEditHelpTextAfter: "Nach dem Speichern wird die Bankverbindung sofort in der Übersicht aktualisiert.",
    projectHelpTextPre: "Hier können Sie Ihre Projektdetails einsehen und ändern.",
    projectHelpTextAfter: "Nach dem Speichern wird das Project sofort in der Übersicht aktualisiert.",
    projectTeamHelpTextPre: "Hier können Sie Ihr Projektteam einsehen und ändern. Seien Sie sich bewusst, dass Benutzern bei fehlzuweisung Zugriff auf sensitive Daten gewährt werden kann.",
    projectTeamHelpTextAfter: "Nach dem Speichern wird das Project sofort in der Übersicht aktualisiert.",
    sendInvoiceHelpTextPre: "Hier können Sie eine ausgewählte Rechnung <strong>{{InvoiceNum}}</strong> versenden und neben dem Kontakt <strong>{{ContactMail}}</strong> noch optionale Empänger hinzufügen.",
    sendInvoiceHelpTextAfter: "Stellen Sie zudem sicher, dass die eingetragenen Empfänger auch berechtigt sind Rechnungsinformationen einzusehen",
    sendInvoiceSuccess: "Die Rechnung '{{InvoiceNum}}' wurde erfolgreich gesendet.",
    helpTextBugTitle: "Hier einen sprechenden Titel für den Fehler vergeben",
    helpTextFrontendRoute: "Auf welcher Seite ist der Fehler aufgereten z.B. (/cp/home)",
    helpTextTicketType: "Was genau wird angemerkt?",
    helpTextDescription: "Beschreiben das konkrete Fehlerbild und deren Auswirkungen wenn möglich",
    helpTextStepToReproduce: "Schritt zum Reproduzieren (z.B. Klicke A, Sehe B)",
    stepsToReproduce: "Schritte zum Reproduzieren",
    stepToReproduceNr: "Schritt {{stepNo}}",
    bugTicketCreationSucceeded: "Ihr Ticket wurde erfolgreich erstellt",
    bugTicketCreationFailed: "Fehler beim erstellen Ihres Bugtickets. Bitte versuchen Sie es später erneut",
    userChangeRoleHint: "Benutzer können Ihre Rollen nicht selbst ändern. Kontaktieren Sie jemanden mit höheren Befugnissen.",
    ticketTypeBug: "Fehler",
    ticketTypeImprovement: "Optimierung",
    ticketTypeFeatureRequest: "Feature-Request",
    changeNewsPreviewImage: "Anzeigebild ändern",
    variableContextEnum: {
        Theme: 'Theme',
        Database: 'Datenbank',
        Core: 'Kernsystem',
        Bookkeeping: 'Buchhaltung',
    },
    variableMutabilityEnum: {
        ReadOnly: 'Nur lesen',
        WriteOnly: 'Nur schreiben',
        ReadAndWrite: 'Lesen und schreiben',
    },
    variableTypeEnum: {
        String: 'Text',
        Integer: 'Ganzzahl',
        Color: 'Farbe',
        File: 'Datei',
        ComputedRuntimeInteger: 'Berechnet (Ganzzahl)',
        ComputedRuntimeString: 'Berechnet (Text)',
    },
    variableComposerHint: 'Tippe {, um eine Variable oder einen verfügbaren Baustein einzufügen.',
    variableComposerDocumentToken: 'Belegwert',
    variableComposerGroupDocumentValues: 'Belegwerte',
    variableComposerGroupVariables: 'Variablen',
    variableComposerDocumentHelpTitle: 'Belegnummer zusammensetzen',
    variableComposerDocumentHint: 'Verwende {number} für die nächste freie Belegnummer, {revision} für die Revision und {yy} für das zweistellige Belegjahr. invoice_last_receipt_no ist nur ein Informationswert und darf die neue Belegnummer nicht ersetzen. Tippe { für weitere Bausteine oder Variablen.',
    variableComposerRecommendedFormat: 'Empfohlenes Format',
    variableTokenNumber: 'Nächste Belegnummer',
    variableTokenNumberDescription: 'Die nächste freie, beim Finalisieren vergebene Belegnummer',
    variableTokenNumberPadded: 'Belegnummer vierstellig',
    variableTokenNumberPaddedDescription: 'Nächste Belegnummer mit führenden Nullen',
    variableTokenRevision: 'Revision',
    variableTokenRevisionDescription: 'Revision des konkreten Belegs',
    variableTokenRevisionPadded: 'Revision zweistellig',
    variableTokenRevisionPaddedDescription: 'Revision mit führenden Nullen',
    variableTokenYearLong: 'Jahr vierstellig',
    variableTokenYearLongDescription: 'Jahr des Belegdatums, z. B. 2026',
    variableTokenYearShort: 'Jahr zweistellig',
    variableTokenYearShortDescription: 'Jahr des Belegdatums, z. B. 26',
    variableTokenMonth: 'Monat',
    variableTokenMonthDescription: 'Monat des Belegdatums, z. B. 09',
    variableTokenDay: 'Tag',
    variableTokenDayDescription: 'Tag des Belegdatums, z. B. 12',
    variableName: {
        core_current_year: 'Aktuelles Jahr',
        core_current_month: 'Aktueller Monat',
        core_current_day: 'Aktueller Tag',
        customer_start_index: 'Startnummer Kunden',
        invoice_start_index: 'Startnummer Rechnungen',
        offer_start_index: 'Startnummer Angebote',
        billing_invoice_number_format: 'Rechnungsnummernformat',
        billing_offer_number_format: 'Angebotsnummernformat',
        invoice_last_receipt_no: 'Letzte Rechnungsnummer',
    },
    variableDescription: {
        billing_invoice_number_format: 'Legt fest, wie neue Rechnungsnummern aufgebaut werden. Die nächste freie Nummer wird mit {number} transaktionssicher eingesetzt; normale Variablen können zusätzlich über {var:name} referenziert werden.',
        billing_offer_number_format: 'Legt fest, wie neue Angebotsnummern aufgebaut werden. Die nächste freie Nummer wird mit {number} eingesetzt; normale Variablen können zusätzlich über {var:name} referenziert werden.',
    },
    variableContext: "Kontext",
    variableValue: "Variablenwert",
    variableResolveFailed: 'Konnte nicht aufgelöst werden',
    variableResolvedValue: 'Aufgelöster Wert',
    variableNameLabel: "Variable Name",
    variableNameToolTip: "Name der Variablen",
    variableNamePlaceholder: "Name der Variablen",
    variableContextLabel: "Variablen-Kontext",
    variableContextToolTip: "Kontext (Gruppe) der Variablen",
    variableContextPlaceholder: "Kontext (Gruppe) der Variablen",
    variableValueLabel: "Variablen-Wert",
    variableValueToolTip: "Wert (value) der Variablen",
    variableValuePlaceholder: "Wert (value) der Variablen",
    variableTypeLabel: "Variablen-Typ",
    variableTypeToolTip: "Datentyp der Variablen",
    variableTypePlaceholder: "Datentyp der Variablen",
    variableHelpTextPre: "In dem folgenden Formular können Sie den Wert einer einzelnen Variablen aktualisieren.",
    variableHelpTextAfter: "Variablen sind vom System vorgegeben und könnne nur eingesehen und aktualisiert werden. Das erstellen einer Varaiblen wird nur von den Entwicklern vorgenommen.",

    ///After this point adhere to the described standard!!!!!
    /// Translation keys shall conform to the specified format:
    /// {{module Name}}_{{component Name}}_{{meaning}}_{{usage}}
    /// module Name: name of the module in which the key will be used
    /// component Name: name of the component in which the key will be used
    /// meaning: what the key is intended to represent(e.g. login)
    /// usage: what the key will be used as (e.g. label, header, button)
    /// example: auth_login_resetPassword_link
    /// Exception:
    /// general use translation keys (e.g. save, cancel, continue, password,.....) shall fall under the module general and
    /// do not require a component
    /// example: general_save_button

    general_title:'Titel',
    general_name:'Name',
    general_user:'Nutzer',
    general_employee:'Mitarbeiter',
    general_firstName:'Vorname',
    general_lastName:'Nachname',
    general_email:'E-Mail',
    general_phone:'Telefon',
    general_mobile:'Mobil',
    general_address:'Adresse',
    general_country:'Land',
    general_federalState:'Bundesland',
    general_city:'Stadt',
    general_zipCodeShort:'PLZ',
    general_zipCode:'Postleitzahl',
    general_streetName:'Straßen Name',
    general_streetNumber:'Haus Nr.',
    general_company:'Firma',
    general_salutation:'Anrede',
    general_description:'Beschreibung',
    general_website:'Website',
    general_department:'Abteilung',
    general_save:'Speichern',
    general_delete:'Löschen',
    general_edit: "Bearbeiten",
    general_chooseState:'Wählen Sie den Status aus',
    general_create:'Erstellen',
    general_empty:'-- leer --',
    general_role:'Rolle',
    general_currentStatus:'Aktueller Status',
    general_contact:'Kontakte',
    general_project:'Projekt',
    general_excelImport:'Excel Importieren',
    general_index:'Index',
    general_startDate:'Startdatum',
    general_startTime:'Startzeit',
    general_endDate:'Enddatum',
    general_endTime:'Endzeit',
    general_hrsShort: "Std",
    general_clockSuffix: "Uhr",
    general_duration: "Dauer",
    general_none:'',
    general_pending:'Ausstehend',
    general_accepted:'Angenommen',
    general_rejected:'Abgelehnt',
    general_canceled:'Storniert',
    general_vacation:'Urlaub',
    general_sick:'Krank',
    general_timeOff:'Stundenausgleich',
    general_publicHolidays: 'Feiertage',
    general_publicHoliday: 'Feiertag',
    general_workTime:'Arbeitszeit',
    general_appointment:'Termin',
    general_specialLeave: 'Sonderurlaub',
    general_days: "Tage",
    general_day: "Tag",
    general_currentWorkflow: "Aktueller Workflow",
    general_backendId:'Backend Id',
    general_customerNumber: 'Kundennummer',
    general_phone_hint: 'Internationales Format: +49 123 456789',


    ///Controller
    //General
    controller_general_delete_success:'{{number}} {{entity}} erfolgreich gelöscht.',

    //Task
    controller_task_deleteSingleText_Label:'Sind sie sicher, dass sie eine Aufgabe löschen möchten?',
    controller_task_deleteMultiText_Label:'Sind sie sicher, dass sie {{number}} Aufgaben löschen möchten?',

    ///App
    //Navigation
    app_navigation_timeManagement_label:'Zeiterfassung',
    app_navigation_task_label:'Aufgaben',
    app_navigation_vacationManagement_label:'Abwesenheiten',
    app_navigation_vacationApproval_label:'Genehmigungsanträge',

    ///crm
    //Company
    crm_company_basicInfo_tabLabel:'Grundlegende Infos',
    crm_company_basicInfo_description:'Stammdaten, Kontaktinformationen und steuerliche Zuordnung der Firma.',
    crm_company_addressInfo_description:'Postanschriften der Firma verwalten und Standardadressen festlegen.',
    crm_company_bankAccounts_description:'Bankverbindungen der Firma verwalten.',

    crm_company_departments_tabLabel:'Abteilungen',
    crm_company_departments_description:'Abteilungen der Firma verwalten und für Zuordnungen verfügbar machen.',
    crm_company_resource_description:'Zugeordnete Kontakte anzeigen. Kontakte werden in der Kontaktverwaltung bearbeitet.',
    crm_contact_basicInfo_tabLabel:'Kontakt',
    crm_contact_basicInfo_description:'Personendaten und die zugehörige Firma verwalten.',
    crm_company_addressInfo_tabLabel:'Adressen',
    crm_company_bankAccounts_tabLabel:'Bankkonten',
    crm_company_resource_tabLabel:'Ressourcen',
    crm_company_toResources_button:'Zu Ansicht Kontakte wechseln',

    //Task
    crm_task_taskName_label:'Aufgabe',
    crm_contract_customerFacingId_label:'Gesetzte ID',
    crm_contract_taskRisks_label:'Risiken',
    crm_contract_taskClarifications_label:'Klarstellungen',
    crm_contract_taskBudget_label:'Budget',
    crm_contract_taskCurrentEstimated_label:'Est.',
    crm_contract_connectedContacts_label:'Kontakte',
    crm_contract_taskCurrentStart_label:'Start',
    crm_contract_taskCurrentEnd_label:'Ende',
    crm_contract_taskEstimatedEffortSum_label:'Est. Aufwand Dauer',
    crm_contract_taskActualEffortSum_label:'Aufwand Dauer',
    crm_contract_category_label:'Kategorie',
    crm_task_currentStart_label:'Aktueller start',
    crm_task_currentEnd_label:'Aktuelles Ende',
    crm_task_currentEst_label:'Aktuell Abgeschätzt',
    crm_task_currentPlanned_label:'Aktuell Geplant',
    crm_task_effortTypes_label:'Aufwand Typen',
    crm_task_duration_label:'Est. Dauer',
    crm_task_actualDuration_label:'Dauer',
    crm_task_entityName:'Aufgaben',
    crm_task_details_sectionTitle:'Aufgaben Details',
    crm_task_id_label:'ID',
    crm_task_taskId_label:'Aufgaben-ID',
    crm_task_taskType_label:'Aufgabentyp',
    crm_task_mockup_label:'Mockups',
    crm_task_contact_label:'Kontakt',
    crm_task_references_label:'Referenzen',
    crm_task_originalStart_label:'Ursprünglicher Beginn',
    crm_task_originalEnd_label:'Ursprüngliches Ende',
    crm_task_originalEstimated_label:'Ursprüngliche Schätzung',
    crm_task_recentAppointments_label:'Letzte Termine',
    crm_contract_referencedTasks_label:'Referenzierte Aufgaben',
    crm_contract_referencedByTasks_label:'Referenziert Von',
    crm_contract_taskEffort_label:'Aufwände',

    //TaskEffort
    crm_taskEffort_effortName_label:'Aufwand',


    //Address Info
    crm_addressInfo_table_header:'Gespeicherte Adressen',
    crm_addressInfo_multiDelete_text:'Sind sie sicher ,dass sie {{number}} Kontakte löschen möchten?',

    //Projects
    crm_projects_addTeamMember_header:'Team-Mitglied hinzufügen',
    crm_projects_nextBill_tableHeader:'Nächste Rechnung',

    //Contacts
    crm_contacts_multiDelete_text:'Sind sie sicher dass sie {{number}} Kontakte löschen möchten?',
    crm_basicContactInfo_header_header:'Kontaktinformationen',
    crm_basicContactInfo_description_label:'Hier können sie Kontakt Informationen einsehen und ändern.',

    //Company
    crm_company_multiDelete_text:'Sind sie sicher dass sie {{number}} Firmen löschen möchten?',

    ///Resource Manager
    //Human Resources
    resourceManager_humanResources_noTaskOnProject_label:'Diesem Projekt wurden bisher keine Aufgaben zugwiesen.',
    resourceManager_humanResources_addTask_label:'Neue Aufgaben für dieses Projekt erstellen',

    partialViews_dialog_calendarExport_header: "Leistungsnachweis Exportieren",
    resourceManager_calendarExport_users_label:'Benutzer auswählen',
    resourceManager_calendarExport_summary_title:'Export Zusammenfassung',
    resourceManager_calendarExport_currentUserFallback_label:'Aktueller Benutzer',
    resourceManager_calendarExport_usersSelected_label:'Benutzer ausgewählt',
    resourceManager_calendarExport_invalidRange_label:'Das Enddatum muss nach dem Startdatum liegen.',
    resourceManager_calendarExport_missingCustomerAddress_label:'Für den Kunden ist keine Adresse hinterlegt.',
    resourceManager_calendarExport_project_label:'Projekt',
    resourceManager_calendarExport_separateFiles_label:'Einzelne PDF-Dateien je Benutzer erstellen',
    resourceManager_calendarExport_invoiceSplitByMember_label:'Rechnungspositionen nach Mitarbeitern aufteilen',
    resourceManager_calendarExport_invoiceSplitByMember_hint:'Erstellt im Rechnungsentwurf eine eigene Stundenposition je ausgewähltem Mitarbeiter. Ohne Auswahl werden die Stunden zu einer Position summiert.',
    resourceManager_calendarExport_createInvoice_label:'Rechnungsentwurf erstellen',
    resourceManager_calendarExport_createInvoice_hint:'Bitte mindestens einen Mitarbeiter auswählen. Projekt, Zeitraum und Auswahl werden direkt in die Rechnung übernommen. Die Leistungsnachweise können dort ebenfalls exportiert werden.',
    resourceManager_calendarExport_separateFiles_hint:'Wenn mehrere Benutzer ausgewählt sind, wird pro Benutzer ein eigener Leistungsnachweis erstellt.',
    resourceManager_calendarExport_outputMode_label:'Ausgabe',
    resourceManager_calendarExport_outputMode_singleFile_label:'Eine gemeinsame PDF-Datei',
    resourceManager_calendarExport_outputMode_separateFiles_label:'Mehrere PDF-Dateien',
    users:'Benutzer',


    //TimeTracker
    resourceManager_timeTracker_onPageLeave_label:'Sie haben ungespeicherte einträge!',
    resourceManager_timeTracker_dismiss_label:'Änderungen Verwerfen',
    resourceManager_timeTracker_saveUnused_label:'Ungespeicherte einträge Speichern',
    resourceManager_timeTracker_returnToCurrentWeek_button:'Zur aktuellen Woche',
    resourceManager_timeTracker_currentWeek_label:'Kalender Woche',
    resourceManager_timeTracker_currentViewed_label:'Aktueller Mitarbeiter',
    resourceManager_timeTracker_taskListAll_label:'Alle',
    resourceManager_timeTracker_openOvertime_label:'Überstunden',

    //CalendarStatistics
    resourceManager_calendarStatistic_yearStats_tabHeader: 'Jährliche Statistiken',
    resourceManager_calendarStatistic_weekStats_tabHeader: 'Wöchentliche Statistiken',
    resourceManager_calendarStatistic_monthStats_tabHeader: 'Monatliche Statistiken',
    resourceManager_calendarStatistic_monthSection_label: 'Monat',
    resourceManager_calendarStatistic_monthForecastHours_label: 'Prognose Monatsstunden',
    resourceManager_calendarStatistic_monthAverageHours_label: 'Durchschnitt pro Arbeitstag',
    resourceManager_calendarStatistic_monthPreviousAverageHours_label: 'Durchschnitt Vormonat',
    resourceManager_calendarStatistic_monthAverageDelta_label: 'Vergleich zum Vormonat',
    resourceManager_calendarStatistic_yearAverageHours_label: 'Durchschnitt pro verfügbarem Arbeitstag',
    resourceManager_calendarStatistic_yearAverageWeekHours_label: 'Durchschnitt pro verfügbarer Arbeitswoche',
    resourceManager_calendarStatistic_workTimeSection_label: 'Arbeitszeit',
    resourceManager_calendarStatistic_overtimeSection_label: 'Überstunden',
    resourceManager_calendarStatistic_absencesCreditsSection_label: 'Abwesenheiten & Gutschriften',
    resourceManager_calendarStatistic_vacationSection_label: 'Urlaub',

    resourceManager_calendarStatistic_weeklyTargetHours_label: 'Wochenstunden',

    resourceManager_calendarStatistic_vacationDaysEntitled_label: 'Urlaubstage pro Jahr',
    resourceManager_calendarStatistic_vacationDaysTaken_label: 'Genommene Urlaubstage bisher',
    resourceManager_calendarStatistic_vacationDaysPlanned_label: 'Geplante Urlaubstage',
    resourceManager_calendarStatistic_vacationDaysAvailableNow_label: 'Urlaub aktuell verfügbar',
    resourceManager_calendarStatistic_vacationCarryOver_label: 'Urlaubübertrag aktuell verfügbar',
    resourceManager_calendarStatistic_vacationCarryOverDeadlineNext_label: 'Nächstes Verfallsdatum Urlaubübertrag',
    resourceManager_calendarStatistic_vacationCurrentYearUsed_label: 'Vom Anspruch des ausgewählten Jahres verbraucht',
    resourceManager_calendarStatistic_vacationCurrentYearPlanned_label: 'Vom Anspruch des ausgewählten Jahres geplant',
    resourceManager_calendarStatistic_vacationCurrentYearRemaining_label: 'Restanspruch aus dem ausgewählten Jahr',
    resourceManager_calendarStatistic_vacationCarryOverFromPreviousYear_label: 'Übertrag aus dem Vorjahr zu Jahresbeginn',
    resourceManager_calendarStatistic_vacationCarryOverUsed_label: 'Davon bereits genommen',
    resourceManager_calendarStatistic_vacationCarryOverPlanned_label: 'Davon bereits geplant',
    resourceManager_calendarStatistic_vacationCarryOverExpired_label: 'Davon verfallen',
    resourceManager_calendarStatistic_vacationBalanceExplanation_text: 'Gesamt verfügbar ist die Summe aus dem noch offenen Anspruch des ausgewählten Jahres und dem noch nicht verbrauchten, nicht verfallenen Übertrag aus dem Vorjahr. Übertrag wird zuerst verbraucht.',

    resourceManager_calendarStatistic_sickDaysTaken_label: 'Krankheitstage bisher',

    resourceManager_calendarStatistic_overtimeAvailableNow_label: 'Überstundenstand aktuell',
    resourceManager_calendarStatistic_overtimeRawCurrentYear_label: 'Überstunden dieses Jahr',
    resourceManager_calendarStatistic_overtimeCarryOver_label: 'Überstundenübertrag aktuell verfügbar',
    resourceManager_calendarStatistic_overtimeCarryOverDeadlineNext_label: 'Nächstes Verfallsdatum Überstundenübertrag',

    resourceManager_calendarStatistic_expectedHours_label: 'Sollstunden',
    resourceManager_calendarStatistic_availableWorkingHours_label: 'Verfügbare Arbeitszeit',
    resourceManager_calendarStatistic_adjustedExpectedHours_label:'Sollstunden mit Überstundenstand',
    resourceManager_calendarStatistic_overtimeBalanceBeforeWeek_label:'Überstundenstand vor Wochenbeginn',
    resourceManager_calendarStatistic_overtimeBalanceAfterWeek_label:'Überstundenstand zum Wochenende',
    resourceManager_calendarStatistic_overtimeBalanceBeforeMonth_label:'Überstundenstand zu Monatsbeginn',
    resourceManager_calendarStatistic_overtimeBalanceAfterMonth_label:'Überstundenstand zum Monatsende',
    resourceManager_calendarStatistic_workedHours_label: 'Geleistete Stunden',
    resourceManager_calendarStatistic_creditablePerformanceHours_label: 'Anrechenbare Iststunden',
    resourceManager_calendarStatistic_sickDays_label: 'Krankheitstage',
    resourceManager_calendarStatistic_absenceCreditHours_label: 'Abwesenheitsgutschrift in Stunden',
    resourceManager_calendarStatistic_publicHolidayCreditHours_label: 'Feiertagsgutschrift in Stunden',
    resourceManager_calendarStatistic_overtimeHours_label: 'Überstunden',
    resourceManager_calendarStatistic_remainingHours_label: 'Verbleibende Stunden',
    resourceManager_calendarStatistic_publicHolidayDays_label: 'Feiertage',
    resourceManager_calendarStatistic_possibleWorkingDays_label: 'Mögliche Arbeitstage',

    resourceManager_projectStatistics_budget_tabTitle: "Budget",
    resourceManager_projectStatistics_budget_tabName: "Budget",
    resourceManager_projectStatistics_years_tabTitle: "Zeitverlauf",
    resourceManager_projectStatistics_years_tabName: "Zeitverlauf",
    resourceManager_projectStatistics_users_tabTitle: "Mitarbeiter",
    resourceManager_projectStatistics_users_tabName: "Mitarbeiter",
    resourceManager_projectStatistics_filter_label: "Anzeige",
    resourceManager_projectStatistics_refresh_button: "Aktualisieren",
    resourceManager_projectStatistics_projects_statLabel: "Projekte",
    resourceManager_projectStatistics_totalBudget_statLabel: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_statLabel: "Budget offen",
    resourceManager_projectStatistics_plannedHours_statLabel: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_statLabel: "Ist Stunden",
    resourceManager_projectStatistics_deltaHours_statLabel: "Delta",
    resourceManager_projectStatistics_filter_all_option: "Alle Projekte",
    resourceManager_projectStatistics_filter_open_option: "Nur offenes Budget",
    resourceManager_projectStatistics_filter_worked_option: "Nur mit Ist Stunden",
    resourceManager_projectStatistics_totalBudget_label: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_label: "Budget offen",
    resourceManager_projectStatistics_usedBudget_label: "Verbraucht",
    resourceManager_projectStatistics_plannedHours_label: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_label: "Ist Stunden",
    resourceManager_projectStatistics_deltaHours_label: "Delta",
    resourceManager_projectStatistics_budgetUsage_label: "Budgetverbrauch",
    resourceManager_projectStatistics_userName_header: "Name",
    resourceManager_projectStatistics_userPlannedHours_header: "Geplante Stunden",
    resourceManager_projectStatistics_userActualHours_header: "Ist Stunden",
    resourceManager_projectStatistics_year_header: "Jahr",
    resourceManager_projectStatistics_appointments_header: "Appointments",
    resourceManager_projectStatistics_worklogs_header: "Worklogs",
    resourceManager_projectStatistics_yearPlannedHours_header: "Geplant",
    resourceManager_projectStatistics_yearActualHours_header: "Ist",
    resourceManager_projectStatistics_yearDeltaHours_header: "Delta",
    resourceManager_projectStatistics_customer_columnLabel: "Kunde",
    resourceManager_projectStatistics_project_columnLabel: "Projekt",
    resourceManager_projectStatistics_totalBudget_columnLabel: "Budget gesamt",
    resourceManager_projectStatistics_openBudget_columnLabel: "Budget offen",
    resourceManager_projectStatistics_plannedHours_columnLabel: "Geplante Stunden",
    resourceManager_projectStatistics_actualHours_columnLabel: "Ist Stunden",
    resourceManager_projectStatistics_workedInPeriod_columnLabel: "Geleistet im Zeitraum",
    resourceManager_projectStatistics_workedOverall_columnLabel: "Geleistet gesamt",
    resourceManager_projectStatistics_budgetConsumedTotal_columnLabel: "Budgetverbrauch gesamt",
    resourceManager_projectStatistics_deltaHours_columnLabel: "Delta",
    resourceManager_projectStatistics_teamMembers_columnLabel: "Teammitglieder",
    resourceManager_projectStatistics_tasks_columnLabel: "Tasks",
    resourceManager_projectStatistics_coverageFrom_columnLabel: "Abdeckung von",
    resourceManager_projectStatistics_coverageTo_columnLabel: "Abdeckung bis",
    resourceManager_projectStatistics_table_label: "Projektstatistik",
    resourceManager_projectStatistics_noYears_label: "Keine Jahresstatistik verfügbar",
    resourceManager_projectStatistics_noUsers_label: "Keine Mitarbeiterstatistiken verfügbar",
    resourceManager_projectStatistics_period_label: "Zeitraum",
    resourceManager_projectStatistics_period_all_option: "Gesamt",
    resourceManager_projectStatistics_period_year_option: "Jahr",
    resourceManager_projectStatistics_projectsOverview_tabLabel: "Projekte",
    resourceManager_projectStatistics_projectsOverview_title: "Projektübersicht",
    resourceManager_projectStatistics_projectsOverview_description: "Alle Projektbudgets über den gesamten Zeitraum. Ein Projekt öffnen, um das Gesamtbudget zu prüfen oder die Nutzung gezielt nach Jahr, Monat oder freiem Zeitraum zu analysieren.",
    resourceManager_projectStatistics_personProjectYear_tabLabel: "Mitarbeiter",
    resourceManager_projectStatistics_personProjectYear_title: "Budgetnutzung je Mitarbeiter",
    resourceManager_projectStatistics_personProjectYear_description: "Zeigt die Budgetnutzung je Mitarbeiter für den ausgewählten Zeitraum.",
    resourceManager_projectStatistics_personProjectYear_tableLabel: "Budgetnutzung je Mitarbeiter",
    resourceManager_projectStatistics_personProjectYear_empty: "Für den gewählten Zeitraum sind keine erfassten Projektarbeitszeiten vorhanden.",
    resourceManager_projectStatistics_employees_statLabel: "Mitarbeiter",
    resourceManager_projectStatistics_worklogs_statLabel: "Buchungen",
    resourceManager_projectStatistics_totalWorkedHours_statLabel: "Stunden gesamt",
    resourceManager_projectStatistics_employee_columnLabel: "Mitarbeiter",
    resourceManager_projectStatistics_firstBooking_columnLabel: "Erste Buchung",
    resourceManager_projectStatistics_lastBooking_columnLabel: "Letzte Buchung",
    resourceManager_projectStatistics_orderedBudgetHours_statLabel: "Beauftragte Stunden",
    resourceManager_projectStatistics_budgetConsumedHours_statLabel: "Geleistete Stunden",
    resourceManager_projectStatistics_budgetRemainingHours_statLabel: "Restbudget",
    resourceManager_projectStatistics_invoicedHours_statLabel: "In Rechnung gestellt",
    resourceManager_projectStatistics_unassignedHours_statLabel: "Ohne Budget",
    resourceManager_projectStatistics_coveredHours_statLabel: "Budgetgedeckt",
    resourceManager_projectStatistics_uncoveredHours_statLabel: "Ohne Budget",
    resourceManager_projectStatistics_orderedBudgetHours_columnLabel: "Beauftragt h",
    resourceManager_projectStatistics_budgetConsumedHours_columnLabel: "Geleistet h",
    resourceManager_projectStatistics_budgetRemainingHours_columnLabel: "Rest h",
    resourceManager_projectStatistics_invoicedHours_columnLabel: "In Rechnung gestellt h",
    resourceManager_projectStatistics_unassignedHours_columnLabel: "Ohne Budget h",
    resourceManager_projectStatistics_legacyProjectVolume_columnLabel: "Projektvolumen €",
    resourceManager_projectStatistics_coveredHours_header: "Budgetgedeckt",
    resourceManager_projectStatistics_uncoveredHours_header: "Ohne Budget",
    resourceManager_projectStatistics_assignedBudgetHours_header: "Beauftragt h",
    resourceManager_projectStatistics_remainingAssignedBudgetHours_header: "Rest h",
    resourceManager_projectStatistics_orderedBudgetHours_label: "Beauftragte Stunden",
    resourceManager_projectStatistics_budgetConsumedHours_label: "Geleistete Stunden im Budget",
    resourceManager_projectStatistics_budgetRemainingHours_label: "Noch verfügbare Stunden",
    resourceManager_projectStatistics_invoicedHours_label: "In Rechnung gestellt",
    resourceManager_projectStatistics_unbilledWorkedHours_label: "Noch nicht in Rechnung gestellt",
    resourceManager_projectStatistics_unassignedHours_label: "Arbeitszeit ohne Budgetzuordnung",
    resourceManager_projectStatistics_contractValue_label: "Vertragswert netto",
    resourceManager_projectStatistics_consumedValue_label: "Wert der geleisteten Stunden",
    resourceManager_projectStatistics_employeeBudgetSummary_title: "Budget je Mitarbeiter",
    resourceManager_projectStatistics_employeeBudgetSummary_description: "Kumulierte Sicht über alle persönlichen Budgettöpfe. Offene Folgebudgets werden als gemeinsame Budgetkette verrechnet.",
    resourceManager_projectStatistics_employeeBudgetCurrent_title: "Mitarbeiterbudgets aktuell",
    resourceManager_projectStatistics_employeeBudgetCurrent_description: "Tagesaktueller Stand der persönlichen Budgets für dieses Projekt.",
    resourceManager_projectStatistics_employeeBudgetMonthEnd_title: "Mitarbeiterbudgets zum letzten Monatsende",
    resourceManager_projectStatistics_employeeBudgetMonthEnd_description: "Stand der persönlichen Budgets für dieses Projekt zum {{date}}.",
    resourceManager_projectStatistics_budgetLines_title: "Budgetpositionen",
    resourceManager_projectStatistics_budgetLines_description: "Verträge und Budgettöpfe mit Zeitraum, Mitarbeiter, geleisteten Stunden und Abrechnungsstand.",
    resourceManager_projectStatistics_sharedBudget_label: "Gemeinsamer Projekttopf",
    resourceManager_projectStatistics_openEnded_label: "offen",
    resourceManager_projectStatistics_sourceOffer_label: "Angebot",
    resourceManager_projectStatistics_orderedShort_label: "Beauftragt",
    resourceManager_projectStatistics_actualShort_label: "Geleistet",
    resourceManager_projectStatistics_budgetConsumedShort_label: "Verbraucht",
    resourceManager_projectStatistics_employeeShort_label: "Mitarbeiter",
    resourceManager_projectStatistics_startShort_label: "Start",
    resourceManager_projectStatistics_endShort_label: "Ende",
    resourceManager_projectStatistics_remainingShort_label: "Rest",
    resourceManager_projectStatistics_invoicedShort_label: "In Rechnung gestellt",
    resourceManager_projectStatistics_unbilledShort_label: "Noch abzurechnen",
    resourceManager_projectStatistics_hourlyRateShort_label: "Stundensatz",
    resourceManager_projectStatistics_preStartAssigned_suffix: "vor Budgetstart zugeordnet",
    resourceManager_projectStatistics_noContractBudget_label: "Für dieses Projekt ist noch kein Stundenbudget hinterlegt. Erfasste Zeiten werden deshalb als Arbeitszeit ohne Budgetzuordnung ausgewiesen.",
    resourceManager_projectStatistics_overview_tabTitle: "Übersicht",
    resourceManager_projectStatistics_overview_tabName: "Übersicht",
    resourceManager_projectStatistics_employees_tabTitle: "Mitarbeiter",
    resourceManager_projectStatistics_employees_tabName: "Mitarbeiter",
    resourceManager_projectStatistics_timeline_tabTitle: "Zeitverlauf",
    resourceManager_projectStatistics_timeline_tabName: "Zeitverlauf",
    resourceManager_projectStatistics_statistics_tabTitle: "Statistik",
    resourceManager_projectStatistics_statistics_tabName: "Statistik",
    resourceManager_projectStatistics_statistics_title: "Projektanalyse",
    resourceManager_projectStatistics_statistics_description: "Analysiert ausschließlich das ausgewählte Projekt. Standardmäßig wird der gesamte Projektverlauf gezeigt; Jahr, Monat und freier Zeitraum filtern nur die Nutzung, nicht das beauftragte Gesamtbudget.",
    resourceManager_projectStatistics_analysisLoading_label: "Projektstatistik wird geladen …",
    resourceManager_projectStatistics_period_month_option: "Ein Monat",
    resourceManager_projectStatistics_period_range_option: "Freier Zeitraum",
    resourceManager_projectStatistics_customRange_label: "Zeitraum",
    resourceManager_projectStatistics_rangeFrom_placeholder: "Von",
    resourceManager_projectStatistics_rangeTo_placeholder: "Bis",
    resourceManager_projectStatistics_applyRange_button: "Anwenden",
    resourceManager_projectStatistics_workedInPeriod_statLabel: "Geleistet im Zeitraum",
    resourceManager_projectStatistics_workedOverall_statLabel: "Geleistet gesamt",
    resourceManager_projectStatistics_employees_tabLabel: "Mitarbeiter",
    resourceManager_projectStatistics_employees_title: "Budget und Arbeitszeit je Mitarbeiter",
    resourceManager_projectStatistics_employees_description: "Zeigt je Mitarbeiter, wie viele Stunden beauftragt, geleistet, durch Budget gedeckt und in Rechnung gestellt wurden. Reststunden sind der aktuell verfügbare Stand der zugeordneten Mitarbeiterbudgets.",
    resourceManager_projectStatistics_employees_empty: "Für den gewählten Zeitraum sind keine Mitarbeiter mit Projektarbeitszeit oder Budget vorhanden.",
    resourceManager_projectStatistics_timeline_tabLabel: "Zeitverlauf",
    resourceManager_projectStatistics_timeline_title: "Arbeitszeit und Budgetverbrauch im Zeitverlauf",
    resourceManager_projectStatistics_timeline_description: "Monatliche Sicht auf geleistete, budgetgedeckte und in Rechnung gestellte Stunden. Das Budget wird nicht künstlich auf Monate verteilt; gezeigt wird der tatsächliche Verbrauch.",
    resourceManager_projectStatistics_timeline_empty: "Für den gewählten Zeitraum sind keine Projektarbeitszeiten vorhanden.",
    resourceManager_projectStatistics_month_columnLabel: "Monat",
    resourceManager_projectStatistics_utilization_columnLabel: "Auslastung",
    resourceManager_projectStatistics_projectEmployees_title: "Mitarbeiter im Projekt",
    resourceManager_projectStatistics_projectEmployees_description: "Arbeitszeit und Budgetstand der Mitarbeiter für den aktuell gewählten Zeitraum.",
    resourceManager_projectStatistics_projectTimeline_title: "Zeitverlauf im Projekt",
    resourceManager_projectStatistics_projectTimeline_description: "Monatliche Arbeitszeit dieses Projekts, getrennt nach Mitarbeiter und Budgetabdeckung.",
    resourceManager_projectStatistics_manageBudget_button: "Budget verwalten",
    resourceManager_projectStatistics_projectNotFound_error: "Projekt konnte nicht geladen werden.",

    resourceManager_projectStatistics_snapshotAsOf_label: "Stand {{date}}",
    resourceManager_projectStatistics_budgetExport_button: "Budget exportieren",
    resourceManager_projectStatistics_budgetExport_title: "Budgetexport",
    resourceManager_projectStatistics_budgetExport_description: "Exportiert den Budgetverlauf bis heute. Die Kumulierung erfolgt chronologisch in Monaten oder Wochen; ausgeblendete Budgets beeinflussen die Zuordnung der Stunden nicht.",
    resourceManager_projectStatistics_budgetExport_accumulation_label: "Kumulierung",
    resourceManager_projectStatistics_budgetExport_monthly_option: "Monatlich",
    resourceManager_projectStatistics_budgetExport_weekly_option: "Wöchentlich",
    resourceManager_projectStatistics_budgetExport_includeRates_label: "Stundensätze und Budgetwerte einbeziehen",
    resourceManager_projectStatistics_budgetExport_budgets_label: "Budgets",
    resourceManager_projectStatistics_budgetExport_budgets_hint: "Nur ausgewählte Budgets werden in die Datei aufgenommen.",
    resourceManager_projectStatistics_budgetExport_selectAll_label: "Alle auswählen",
    resourceManager_calendarStatistic_importantValues_label: "Wichtig auf einen Blick",
    resourceManager_calendarStatistic_advancedDetails_label: "Weitere Details",
    resourceManager_projectStatistics_personalBudgetHours_columnLabel: "Persönlich beauftragt h",
    resourceManager_projectStatistics_personalRemainingHours_columnLabel: "Persönlicher Rest h",
    resourceManager_projectStatistics_sharedPoolUsed_columnLabel: "Aus Projektpool h",

    //bannerItem
    resourceManager_bannerItem_halfDay_label:'1/2 {{type}}',

    //VacationManagement
    resourceManager_vacationManager_vacationStats_header:'Bisherige Abwesenheiten im gewählten Jahr',
    resourceManager_vacationManager_addNewEntry_header:'Neue Abwesenheit hinzufügen',
    resourceManager_vacationManager_filterView_label: 'Typ',
    resourceManager_vacationManager_save_tooltip: 'Abwesenheit speichern',
    resourceManager_vacationManager_save_disabled_tooltip: 'Bitte Start, Ende und Typ prüfen, bevor gespeichert werden kann.',
    resourceManager_vacationManager_save_success: 'Die Abwesenheit wurde gespeichert.',
    resourceManager_vacationManager_save_error: 'Die Abwesenheit konnte nicht gespeichert werden. Bitte erneut versuchen.',

    //AbsenceManager
    resourceManager_absenceManager_personalView_lable:'Einzelansicht',
    resourceManager_absenceManager_generalView_lable:'Firmenansicht',
    resourceManager_absenceOverview_resetYear_label:'Zum Aktuellen Jahr',
    resourceManager_absenceOverview_currentYear_label:'Aktuelles Jahr',

    //VacationApproved
    resourceManager_vacationApproved_application_header:'Genehmigungsanträge',
    resourceManager_vacationApproved_application_description: 'Genehmigungsanträge aller Typen und ihre Bearbeitungsstände anzeigen.',
    resourceManager_vacationApproved_revert_button: 'Entscheidung zurücksetzen',
    resourceManager_vacationApproved_revert_text: 'Soll die Entscheidung wirklich zurückgesetzt und der Antrag wieder auf offen gesetzt werden?',
    resourceManager_vacationApproved_pending_label:'Offen',
    resourceManager_vacationApproved_history_label:'Historie',
    resourceManager_vacationApproved_viewSelect_label:'Ansicht Auswahl',
    resourceManager_vacationApproved_rejectAll_button:'Alle ausgewählte Anfragen ablehnen',
    resourceManager_vacationApproved_approveAll_button:'Alle ausgewählte Anfragen annehmen',
    resourceManager_vacationApproved_durationInDay_label:'Dauer in Tagen',
    resourceManager_vacationApproved_decisionStatus_label:'Entscheidungsstatus',
    resourceManagerCalendarApprovalEntryType: {
        WorkTime: 'Arbeitszeit',
        Vacation: 'Urlaub',
        Sick: 'Krank',
        TimeOff: 'Stundenausgleich',
        Appointment: 'Termin',
        Training: 'Schulung',
        BusinessTrip: 'Dienstreise',
        ProjectStart: 'Projektstart',
        ProjectEnd: 'Projektende',
        PublicHoliday: 'Feiertag',
        SpecialLeave: 'Sonderurlaub',
        TeamsStatus: 'Teams Status',
        Birthday: 'Geburtstag',
    },
    resourceManagerVacationApprovalDecisionStatus: {
        None: 'Kein Status',
        Pending: 'Ausstehend',
        Accepted: 'Angenommen',
        Rejected: 'Abgelehnt',
        Cancelled: 'Storniert',
    },
    resourceManager_vacationApproved_reason_label:'Grund',
    resourceManager_vacationApproved_withdraw_text:'Soll der ausstehende Antrag wirklich zurückgezogen werden?',
    resourceManager_vacationApproved_cancel_text:'Soll der genehmigte Eintrag wirklich storniert werden? Die Historie bleibt erhalten.',
    resourceManager_vacationApproved_decidedBy_label:'Entschieden von',
    resourceManager_vacationApproved_decidedAt_label:'Entschieden am',
    resourceManager_vacationApproved_decisionComment_label:'Entscheidungskommentar',
    resourceManager_vacationApproved_multiDelete_text:'Sind sie sicher dass sie {{number}} Anträge ablehnen möchten?',
    resourceManager_vacationApproved_delete_text: "Sind sie sicher dass sie den Antrag löschen möchten?",

    ///Partial Views
    //Dialog
    //Confirmation
    partialViews_dialog_confirmationDefaultText_label:'Sind sie sicher?',
    partialViews_dialog_confirmationDefaultNo_button:'Nein',
    partialViews_dialog_confirmationDefaultYes_button:'Ja',

    //TimeManagerEntry
    partialViews_dialog_addTimeEntry_header:'Arbeitszeit buchen',

    ///Formulars
    //Project Team Formular
    formular_projectTeam_helpText_text:'Hier können Sie Ihr Projektteam einsehen und ändern. Seien Sie sich bewusst, dass Benutzern bei Fehlzuweisung Zugriff auf sensitive Daten gewährt werden kann.\nNach dem Speichern wird das Project sofort in der Übersicht aktualisiert.',

    //Bank Account Formular
    formular_bankAccount_table_title:'Gespeicherte Bank Konten',
    formular_bankAccount_accountOwner_label:'Konto Besitzer',
    formular_bankAccount_bankName_label:'Bankname',
    formular_bankAccount_iban_label:'IBan',
    formular_bankAccount_bic_label:'BIC',
    formular_bankAccount_billingAccountOnly_label:'Nur Rechnungskonto',
    formular_bankAccount_default_label:'Standard Konto',
    formular_bankAccount_multiDelete_text:'Sind sie sicher dass sie {{number}} Konten löschen möchten?',
    formular_bankAccount_iban_hint: 'z.B. DE89 3704 0044 0532 0130 00',
    formular_bankAccount_bic_hint: 'z.B. COBADEFFXXX',


    general_save_button: 'Speichern',
    general_cancel_button: 'Abbrechen',
    general_comingSoon_label: 'Demnächst verfügbar',

    account_account_eyebrow_label: 'Konto',
    account_account_title_header: 'Mein Konto',
    account_account_description_text: 'Persönliche Einstellungen, Sicherheit, Integrationen und individuelle Arbeitsbereich Optionen.',

    account_account_profileStat_label: 'Profil',
    account_account_profileStat_complete_value: 'Vollständig',
    account_account_profileStat_incomplete_value: 'Unvollständig',
    account_account_profileStat_complete_hint: 'Ihr Profil ist vollständig ausgefüllt.',
    account_account_profileStat_incomplete_hint: 'Ihr Profil ist noch nicht vollständig ausgefüllt.',
    account_account_profileStat_hint: 'Stammdaten gepflegt',

    account_account_integrationsStat_label: 'Integrationen',
    account_account_integrationsStat_value: '{{count}} aktiv',
    account_account_integrationsStat_hint: 'Aktive Verbindungen',

    account_account_securityStat_label: 'Sicherheit',
    account_account_securityStat_value: '{{count}} Hinweis',
    account_account_securityStat_hint: 'Empfohlene Prüfungen',

    account_account_accountSection_header: 'Konto',
    account_account_accountSection_text: 'Persönliche Daten und grundlegende Kontoinformationen',

    account_account_personalData_header: 'Persönliche Daten',
    account_account_personalData_text: 'Name, Kontakt und Stammdaten bearbeiten',
    account_account_personalData_status_badge: 'Aktuell',
    account_accountPersonalData_recommendations_header: 'Profil Hinweise',
    account_accountPersonalData_recommendations_text: '{{count}} Punkte sollten ergänzt werden.',

    account_accountSecurity_recommendations_header: 'Sicherheit Hinweise',
    account_accountSecurity_recommendations_text: '{{count}} Empfehlungen sind offen.',

    account_account_companyRole_header: 'Firma und Rolle',
    account_account_companyRole_text: 'Zugeordnete Firma und Rollenübersicht ansehen',

    account_account_securitySection_header: 'Sicherheit',
    account_account_securitySection_text: 'Zugriff, Authentifizierung und persönliche Tokens',

    account_account_passwordLogin_header: 'Passwort und Anmeldung',
    account_account_passwordLogin_text: 'Passwort ändern und aktive Sitzungen prüfen',
    account_account_passwordLogin_status_badge: 'Empfehlung',

    account_account_apiTokens_header: 'API Tokens',
    account_account_apiTokens_text: 'Persönliche API Zugriffe verwalten',
    account_account_apiTokens_status_badge: 'Deaktiviert',

    account_account_integrationsSection_header: 'Integrationen',
    account_account_integrationsSection_text: 'Persönliche Verbindungen mit externen Diensten',

    account_account_calendar_header: 'Kalender',
    account_account_calendar_text: 'Google, Outlook oder ICS verbinden',
    account_account_calendar_status_badge: 'Verbunden',
    account_account_calendar_meta: '{{count}} aktiv',

    account_account_mail_header: 'E Mail',
    account_account_mail_text: 'Persönliche Mail Integrationen verwalten',

    account_accountPersonalData_eyebrow_label: 'Konto',
    account_accountPersonalData_title_header: 'Persönliche Daten',
    account_accountPersonalData_description_text: 'Pflege deine persönlichen Stammdaten und Kontaktdetails.',
    account_accountPersonalData_back_button: 'Zurück zu Mein Konto',
    account_accountPersonalData_masterData_header: 'Stammdaten',
    account_accountPersonalData_masterData_text: 'Name, Kontakt und weitere persönliche Angaben',

    // account security
    account_accountSecurity_eyebrow_label: 'Konto',
    account_accountSecurity_title_header: 'Passwort und Sicherheit',
    account_accountSecurity_description_text: 'Verwalten Sie Ihr Passwort und prüfen Sie sicherheitsrelevante Einstellungen Ihres Kontos.',
    account_accountSecurity_back_button: 'Zurück zu Mein Konto',

    account_accountSecurity_changePassword_button: 'Passwort ändern',

    account_accountSecurity_passwordPanel_header: 'Passwort ändern',
    account_accountSecurity_passwordPanel_text: 'Ändern Sie Ihr aktuelles Passwort für dieses Konto.',

    account_accountSecurity_email_label: 'E-Mail',
    account_accountSecurity_currentPassword_label: 'Aktuelles Passwort',
    account_accountSecurity_newPassword_label: 'Neues Passwort',
    account_accountSecurity_newPasswordConfirm_label: 'Neues Passwort bestätigen',

    account_accountSecurity_currentPasswordRequired_error: 'Bitte geben Sie Ihr aktuelles Passwort ein.',
    account_accountSecurity_newPasswordRequired_error: 'Bitte geben Sie ein neues Passwort ein.',
    account_accountSecurity_newPasswordLength_error: 'Das neue Passwort muss mindestens 8 Zeichen lang sein.',
    account_accountSecurity_newPasswordConfirmRequired_error: 'Bitte bestätigen Sie das neue Passwort.',
    account_accountSecurity_passwordMismatch_error: 'Die neuen Passwörter stimmen nicht überein.',

    account_accountSecurity_success_text: 'Ihr Passwort wurde erfolgreich geändert.',
    account_accountSecurity_error_text: 'Das Passwort konnte nicht geändert werden. Bitte prüfen Sie Ihre Eingaben.',

    account_accountSecurity_notesPanel_header: 'Hinweise',
    account_accountSecurity_notesPanel_text: 'Wichtige Informationen zur Passwortänderung.',
    account_accountSecurity_noteOne_text: 'Nach einer erfolgreichen Änderung erhalten Sie eine Bestätigungs-E-Mail.',
    account_accountSecurity_noteTwo_text: 'Falls Sie Ihr aktuelles Passwort nicht mehr kennen, verwenden Sie den Passwort-zurücksetzen-Workflow auf der Anmeldeseite.',

    // account calendar integrations
    general_refresh_button: 'Aktualisieren',
    general_test_button: 'Testen',
    general_disconnect_button: 'Trennen',
    general_connect_button: 'Verbinden',

    account_accountCalendar_eyebrow_label: 'Integrationen',
    account_accountCalendar_title_header: 'Kalender',
    account_accountCalendar_description_text: 'Verbinden Sie externe Kalender und verwalten Sie Synchronisationen.',
    account_accountCalendar_back_button: 'Zurück zu Mein Konto',

    account_accountCalendar_overview_header: 'Übersicht',
    account_accountCalendar_overview_text: 'Status der Kalender Integrationen auf einen Blick.',
    account_accountCalendar_overviewIntegrations_label: 'Integrationen',
    account_accountCalendar_overviewSources_label: 'Ausgewählte Quellen',
    account_accountCalendar_overviewProviders_label: 'Anbieter',

    account_accountCalendar_existing_header: 'Verbundene Kalender',
    account_accountCalendar_existing_text: 'Bestehende Integrationen testen, synchronisieren oder bearbeiten.',
    account_accountCalendar_noIntegrations_text: 'Es sind aktuell keine Kalender Integrationen verbunden.',
    account_accountCalendar_connectedSources_text: '{{count}} Quellen verbunden',
    account_accountCalendar_lastSync_text: 'Letzte Synchronisation',

    account_accountCalendar_newIntegration_button: 'Neue Integration',
    account_accountCalendar_sync_button: 'Synchronisieren',
    account_accountCalendar_manageSources_button: 'Quellen verwalten',

    account_accountCalendar_providerSelection_header: 'Anbieter wählen',
    account_accountCalendar_providerSelection_text: 'Wählen Sie zuerst den Kalenderanbieter und vervollständigen Sie anschließend die jeweilige Einrichtung.',
    account_accountCalendar_supported_badge: 'Unterstützt',

    account_accountCalendar_providerIcs_header: 'ICS',
    account_accountCalendar_providerIcs_text: 'Kalender über eine ICS URL verbinden.',
    account_accountCalendar_providerIcsSetup_text: 'Geben Sie die ICS URL und optional Zugangsdaten an.',
    account_accountCalendar_providerIcsAbo: 'ICS abonnieren',
    account_accountCalendar_providerIcsUpload: 'ICS Datei importieren',

    account_accountCalendar_providerMicrosoft_header: 'Microsoft',
    account_accountCalendar_providerMicrosoft_text: 'Microsoft Kalender per OAuth verbinden.',
    account_accountCalendar_providerMicrosoftSetup_text: 'Richten Sie die Microsoft Verbindung ein und starten Sie anschließend den OAuth Flow.',

    account_accountCalendar_providerGoogle_header: 'Google',
    account_accountCalendar_providerGoogle_text: 'Google Kalender per OAuth verbinden.',
    account_accountCalendar_providerGoogleSetup_text: 'Richten Sie die Google Verbindung ein und starten Sie anschließend den OAuth Flow.',

    account_accountCalendar_providerUnknown_label: 'Kalenderanbieter',

    account_accountCalendar_displayName_label: 'Anzeigename',
    account_accountCalendar_icsUrl_label: 'ICS URL',
    account_accountCalendar_icsUsername_label: 'Benutzername',
    account_accountCalendar_icsPassword_label: 'Passwort',
    account_accountCalendar_tenantHint_label: 'Tenant Hinweis',
    account_accountCalendar_oAuthClientId_label: 'OAuth Client Id',
    account_accountCalendar_oAuthClientSecret_label: 'OAuth Client Secret',

    account_accountCalendar_importAppointments_label: 'Termine importieren',
    account_accountCalendar_importAbsences_label: 'Abwesenheiten importieren',
    account_accountCalendar_exportAbsences_label: 'Abwesenheiten exportieren',

    account_accountCalendar_createIntegration_button: 'Integration erstellen',

    account_accountCalendar_sources_header: 'Kalenderquellen',
    account_accountCalendar_sources_text: 'Wählen Sie die Kalender aus, die für diese Integration verwendet werden sollen.',
    account_accountCalendar_noSources_text: 'Es wurden keine Kalenderquellen gefunden.',
    account_accountCalendar_refreshSources_button: 'Quellen neu laden',
    account_accountCalendar_saveSources_button: 'Auswahl speichern',
    account_accountCalendar_sourcesSaved_text: 'Die Quellenauswahl wurde gespeichert.',
    account_accountCalendar_readOnly_label: 'Nur Lesen',
    account_accountCalendar_primary_label: 'Primärer Kalender',
    account_accountCalendar_unsubscribeSource_button: 'Quelle abbestellen',
    account_accountCalendar_removeSource_button: 'Quelle entfernen',

    account_accountCalendar_oAuthSuccess_text: 'Die OAuth Verbindung wurde erfolgreich abgeschlossen.',
    account_accountCalendar_oAuthStateMismatch_text: 'Die OAuth Anmeldung konnte nicht verifiziert werden.',
    account_accountCalendar_oAuthProviderMissing_text: 'Der Anbieter für die OAuth Rückkehr konnte nicht bestimmt werden.',
    account_accountCalendar_icsCreateSuccess_text: 'Die ICS Integration wurde erstellt.',
    account_accountCalendar_genericError_text: 'Die Kalender Integration konnte nicht verarbeitet werden.',

    account_accountCalendar_providerIcsUploadInfo_text: 'Einmaliger ICS Dateiimport. Dieser Flow erstellt keine permanente Kalender Integration.',
    account_accountCalendar_providerIcsUploadFile_label: 'ICS Datei auswählen',
    account_accountCalendar_providerIcsUploadNoFile_text: 'Noch keine Datei gewählt',
    account_accountCalendar_skipDuplicates_label: 'Duplikate überspringen',
    account_accountCalendar_splitOverlappingEntries_label: 'Überlappungen aufteilen',
    account_accountCalendar_dryRun_label: 'Nur simulieren, nichts speichern',
    account_accountCalendar_resetSelection_button: 'Auswahl zurücksetzen',
    account_accountCalendar_previewLoad_button: 'Vorschau laden',
    account_accountCalendar_importExecute_button: 'Import ausführen',
    account_accountCalendar_importFile_label: 'Datei',
    account_accountCalendar_importEntries_label: 'Einträge',
    account_accountCalendar_importWarnings_label: 'Warnungen',
    account_accountCalendar_importPreview_header: 'ICS Vorschau',
    account_accountCalendar_importPreview_text: 'Zusammenfassung aus dem Preview Endpoint',
    account_accountCalendar_importPeriod_label: 'Zeitraum',
    account_accountCalendar_importFrom_label: 'Von',
    account_accountCalendar_importTo_label: 'Bis',
    account_accountCalendar_importCreated_label: 'Erstellt',
    account_accountCalendar_importUpdated_label: 'Aktualisiert',
    account_accountCalendar_importSkipped_label: 'Übersprungen',
    account_accountCalendar_importConflicts_label: 'Konflikte',
    account_accountCalendar_importHints_header: 'Import Hinweise',
    account_accountCalendar_importHints_text: 'Rückmeldungen aus dem Commit Endpoint',
    account_accountCalendar_importFileMissing_text: 'Bitte zuerst eine ICS Datei auswählen.',
    account_accountCalendar_importPreviewSuccess_text: 'ICS Vorschau erfolgreich geladen.',
    account_accountCalendar_importCommitSuccess_text: 'ICS Datei erfolgreich importiert.',
    account_accountCalendar_importDryRunSuccess_text: 'ICS Import Dry Run erfolgreich ausgeführt.',

    rmCalendarNoTasksInProject: "Dieses Projekt erfordert Aufgaben, hat aber noch keine. Bitte legen Sie zunächst Aufgaben für das Projekt an",
    rmCalendarNoTasksSelect: "Für dieses Projekt ist eine Aufgabe erforderlich. Bitte wählen Sie einen Task aus",


    // administration page
    administration_eyebrow_label: 'Administration',
    administration_title_header: 'Verwaltung',
    administration_description_text: 'Zentrale Übersicht für Kontodaten, Zugriffe, Servereinstellungen, Variablen und Integrationen.',
    administration_back_button: 'Zurück zum Dashboard',

    administration_sectionsStat_label: 'Bereiche',
    administration_sectionsStat_hint: 'Verfügbare Verwaltungsbereiche',
    administration_routesStat_label: 'Ziele',
    administration_routesStat_value: '{{count}} Einträge',
    administration_routesStat_hint: 'Direkt erreichbare Verwaltungsseiten',
    administration_comingSoonStat_label: 'Geplant',
    administration_comingSoonStat_value: '{{count}} offen',
    administration_comingSoonStat_hint: 'Bereiche mit geplanter Erweiterung',

    administration_sectionAccount_text: 'Stammdaten, Adressen und Zahlungsinformationen verwalten.',
    administration_sectionDiagnostics_text: 'Systemzustand, Logs und spätere Monitoring Bereiche.',
    administration_sectionAccess_text: 'Rollen, Rechte und Benutzerzuordnungen steuern.',
    administration_sectionServer_text: 'Umgebung und datenbankbezogene Servereinstellungen.',
    administration_sectionVariables_text: 'Systemweite Variablen und Konfigurationen verwalten.',
    administration_sectionIntegrations_text: 'Externe Systeme und Kommunikationswege anbinden.',

    administration_company_text: 'Unternehmensstammdaten und Kontoinformationen.',
    administration_addresses_text: 'Standorte, Rechnungs und Kontaktadressen verwalten.',
    administration_payment_text: 'Zahlungswege und Abrechnungsinformationen bearbeiten.',

    administration_logs_label: 'Logs',
    administration_logs_text: 'Protokolle, Ereignisse und technische Fehlerausgaben.',
    administration_health_label: 'Health',
    administration_health_text: 'Überblick über Systemzustand und Verfügbarkeiten.',
    administration_stats_label: 'Statistiken',
    administration_stats_text: 'Servermetriken, Nutzung und Diagnosewerte.',

    administration_roles_text: 'Rollen definieren und administrieren.',
    administration_permissions_text: 'Rechte und Rollenzuweisungen verwalten.',
    administration_userRoles_text: 'Benutzer, Rollen und Zuständigkeiten abstimmen.',
    adminUserOnboardButton: 'Benutzer anlegen',
    adminUserOnboardTitle: 'Benutzer anlegen',
    adminUserOnboardSuccess: 'Benutzer wurde angelegt',
    userDeletedSuccess: 'Benutzer wurde gelöscht',
    adminUserOnboardStepProfile: 'Profil',
    adminUserOnboardStepAccess: 'Zugang und Rollen',
    adminUserOnboardStepEmployment: 'Vertrag und Zeiterfassung',
    adminUserEmploymentInfo: 'Hier werden Beschäftigungszeitraum und Vertragsdaten gepflegt.',
    adminUserEmploymentInfoTextAfter: 'Neue Vertragsdaten werden als neue Vertragsversion gespeichert, damit Zeittracking und Urlaubsberechnung historisch nachvollziehbar bleiben.',
    adminUserEmploymentLoading: 'Beschäftigungsdaten werden geladen',
    calendarNoEmploymentPeriodWeek: 'Für den ausgewählten Zeitraum besteht kein Beschäftigungsverhältnis. Zeitbuchungen sind deshalb deaktiviert.',
    calendarTimeTrackingYearClosed: 'Das Geschäftsjahr ist für die Zeitwirtschaft geschlossen. Buchungen in diesem Jahr können nicht mehr erstellt, geändert oder gelöscht werden.',
    adminFiscalYears: 'Geschäftsjahre',
    administration_fiscalYears_text: 'Geschäftsjahre verwalten und einzelne Bereiche wie Zeitwirtschaft oder Finanzbuchhaltung nach dem Jahresabschluss sperren.',
    adminFiscalYearPolicies: 'Jahresabschluss und Sperren',
    adminFiscalYear: 'Geschäftsjahr',
    adminFiscalYearTimeTrackingClosed: 'Zeitwirtschaft geschlossen',
    adminFiscalYearAccountingClosed: 'Finanzbuchhaltung geschlossen',
    adminUserSpecialPayments: 'Sonderzahlungen',
    adminUserSpecialPaymentDate: 'Auszahlungsdatum',
    adminUserSpecialPaymentAmount: 'Betrag',
    adminUserSpecialPaymentType: 'Art der Sonderzahlung',
    adminUserSpecialPaymentOvertimeHours: 'Ausgezahlte Überstunden',
    adminUserSpecialPaymentReason: 'Grund / Ereignis',
    adminUserSpecialPaymentNote: 'Notiz',
    specialPaymentType: {
        Bonus: 'Bonuszahlung',
        YearEndParticipation: 'Jahresendbeteiligung',
        ManagingDirectorParticipation: 'Geschäftsführerbeteiligung',
        ShareholderParticipation: 'Gesellschafterbeteiligung',
        OvertimePayout: 'Überstundenauszahlung',
        Other: 'Sonstige Sonderzahlung',
    },
    calendarNoEmploymentPeriodYear: 'Für dieses Jahr besteht kein Beschäftigungsverhältnis. Abwesenheiten und Zeitbuchungen sind für diesen Zeitraum deaktiviert.',
    adminUserNoticeDate: 'Kündigungsdatum',
    adminUserContractVersions: 'Vertragsversionen',
    adminUserContractEditor: 'Vertragsdaten',
    adminUserContractValidFrom: 'Vertrag gültig ab',
    adminUserContractValidTo: 'Vertrag gültig bis',
    adminUserContractCurrent: 'aktuell',
    adminUserContractOpenEnded: 'offen',
    adminUserNoContractVersions: 'Noch keine Vertragsversion hinterlegt.',
    adminUserAddContractVersion: 'Neue Vertragsversion anlegen',
    adminUserAddContractVersionInfo: 'Beim Speichern wird die bisher aktuelle Vertragsversion automatisch am Vortag des neuen Gültig-ab-Datums beendet.',
    adminUserCreateInitialContractVersionInfo: 'Erfasse die ersten Vertragsdaten für diese Beschäftigung. Das Gültig-ab-Datum wird als Eintrittsdatum verwendet.',
    adminUserCorrectCurrentContractVersion: 'Aktuelle Vertragsversion korrigieren',
    adminUserCorrectCurrentContractVersionInfo: 'Diese Änderung korrigiert die aktuelle Vertragsversion direkt und wirkt rückwirkend auf den bestehenden Zeitraum.',
    adminUserIsTemporary: 'Befristeter Vertrag',
    adminUserTemporaryUntil: 'Befristet bis',
    adminUserProbePeriodUntil: 'Probezeit bis',
    adminUserContractNote: 'Notiz zur Vertragsversion',
    adminUserEmploymentType: 'Beschäftigungsart',
    adminUserEmploymentTypeHint: 'Die Beschäftigungsart steuert automatisch, welche Vertragsangaben in dieser Maske relevant sind.',
    adminUserContractSectionEmployment: 'Beschäftigungsverhältnis',
    adminUserContractSectionValidity: 'Laufzeit und Vertragsstatus',
    adminUserContractSectionWorkingTime: 'Arbeitszeit und Urlaub',
    adminUserContractSectionCompensation: 'Vergütung',
    adminUserContractSectionAdditional: 'Weitere Angaben',
    adminUserWeeklyHours: 'Wochenstunden',
    adminUserWeeklyWorkingDays: 'Arbeitstage pro Woche',
    adminUserWorkScheduleType: 'Arbeitszeitmodell',
    adminUserWorkScheduleCycleWeeks: 'Rhythmus in Wochen',
    adminUserWorkScheduleAnchorDate: 'Startdatum des Rhythmus',
    adminUserWorkScheduleRules: 'Arbeitstage und Zeitfenster',
    adminUserWorkScheduleRulesHint: 'Pro Arbeitstag die Sollstunden und optional das zulässige lokale Zeitfenster festlegen. Mehrere Einträge pro Tag ermöglichen geteilte Schichten. Liegt das Ende vor dem Start, gilt es als Folgetag.',
    adminUserWorkScheduleRulesEmpty: 'Noch keine Arbeitstage definiert.',
    adminUserWorkScheduleDay: 'Wochentag',
    adminUserWorkScheduleWeekIndex: 'Woche',
    adminUserWorkScheduleTargetHours: 'Sollstunden',
    adminUserWorkScheduleAllowedStart: 'Erlaubt ab',
    adminUserWorkScheduleAllowedEnd: 'Erlaubt bis',
    adminUserAllowWorkTimeOutsideSchedule: 'Buchungen außerhalb des Arbeitsplans erlauben',
    adminUserNotifyMissingTimeEntries: 'Bei fehlenden Zeitbuchungen benachrichtigen',
    adminUserVacationDaysPerYear: 'Urlaubstage pro Jahr',
    adminUserCompensationType: 'Vergütungsart',
    adminUserCompensationAmount: 'Vergütung',
    adminUserMonthlySalary: 'Monatsgehalt',
    adminUserHourlyRate: 'Stundensatz',
    adminUserCurrency: 'Währung',
    permanent: 'Unbefristet',
    temporary: 'Befristet',
    workingStudent: 'Werkstudent',
    intern: 'Praktikant',
    freelancer: 'Freelancer',
    miniJob: 'Minijob',
    ausbildung: 'Ausbildung',
    dualStudent: 'Duales Studium',
    midiJob: 'Midijob',
    shortTermEmployment: 'Kurzfristige Beschäftigung',
    seasonalEmployment: 'Saisonbeschäftigung',
    temporaryAgencyEmployment: 'Arbeitnehmerüberlassung',
    managingDirectorEmployment: 'Geschäftsführung',
    voluntaryService: 'Freiwilligendienst',
    workScheduleType: {
        StandardWeek: 'Standardwoche',
        FixedWeekly: 'Fester Wochenplan',
        RotatingWeeks: 'Rotierender Mehrwochenplan',
    },
    monthlySalary: 'Monatsgehalt',
    hourlyRate: 'Stundensatz',
    compensationType: {
        MonthlySalary: 'Monatsgehalt',
        HourlyRate: 'Stundensatz',
    },
    administration_api_label: 'API',
    administration_api_text: 'Technische Schnittstellen und Zugriffstoken.',

    administration_environment_text: 'Umgebungswerte und technische Konfiguration prüfen.',
    administration_backup_text: 'Sicherung, Wiederherstellung und Datenbankoperationen.',
    administration_variables_text: 'Systemvariablen zentral verwalten.',
    administration_mailClients_label: 'E Mail Clients',
    administration_mailClients_text: 'Mail Anbindungen und Versandkanäle konfigurieren.',

    "company_oauthSettings_title_header": "OAuth Einstellungen",
    "company_oauthSettings_description_text": "OAuth Zugänge für Google und Microsoft auf Firmenebene verwalten",

    "company_oauthSettings_providerGoogle_header": "Google Kalender",
    "company_oauthSettings_providerGoogle_text": "OAuth Daten für Google Kalender Verbindungen",
    "company_oauthSettings_providerGoogle_hint": "Diese Daten werden als Standard für Google Kalender Integrationen der Firma verwendet.",

    "company_oauthSettings_providerMicrosoft_header": "Microsoft 365 Kalender",
    "company_oauthSettings_providerMicrosoft_text": "OAuth Daten für Microsoft 365 Kalender Verbindungen",
    "company_oauthSettings_providerMicrosoft_hint": "Diese Daten werden als Standard für Microsoft Kalender Integrationen der Firma verwendet.",

    "company_oauthSettings_enabled_label": "Provider aktiv",
    "company_oauthSettings_allowOverride_label": "Benutzer Override erlauben",

    "company_oauthSettings_tenant_label": "Tenant oder Tenant Hint",
    "company_oauthSettings_tenant_placeholder": "z. B. common oder Tenant ID",

    "company_oauthSettings_clientId_label": "Client ID",
    "company_oauthSettings_clientId_placeholder": "OAuth Client ID",

    "company_oauthSettings_clientSecret_label": "Client Secret",
    "company_oauthSettings_clientSecret_placeholder": "OAuth Client Secret",
    "company_oauthSettings_clientSecretKeep_placeholder": "Leer lassen, um das vorhandene Secret zu behalten",

    "company_oauthSettings_redirectUri_label": "Redirect URI",
    "company_oauthSettings_redirectUri_placeholder": "https://app.example.com/oauth/callback",
    "company_oauthSettings_microsoftRedirectUri_hint": "Die Microsoft Redirect URI kann leer bleiben. Das Backend verwendet account/integrations/calendar und kombiniert den Pfad mit der aktuellen Frontend URL.",

    "administration_oauthSettings_label": "OAuth Einstellungen",
    "administration_oauthSettings_text": "Google und Microsoft OAuth Konfiguration für Integrationen verwalten",

    // Homologation platform
    general_guid: 'ID',
    general_status: 'Status',
    general_currentVersion: 'Aktuelle Version',
    general_updatedAt: 'Aktualisiert am',
    general_createdAt: 'Erstellt am',
    general_revision: 'Revision',
    navHomologationPlatform: 'Homologationsplattform',
    navVehicle: 'Fahrzeuge',
    general_vehicle: 'Fahrzeug',
    general_vehicle_base_data: 'Fahrzeugdaten',
    homologationPlatformVehicleManufacturerLabel: 'Hersteller',
    homologationPlatformVehicleModelLabel: 'Modell',
    homologationPlatformVehicleVersionLabel: 'Version',
    homologationPlatformVehicleStatusLabel: 'Status',

    general_id: 'ID',
    general_comment: 'Kommentar',
    general_required: 'Erforderlich',
    homologationPlatformVehicleVinLabel: 'FIN',
    homologationPlatformVehicleTypeLabel: 'Fahrzeugtyp',
    homologationPlatformVehicleFuelTypeLabel: 'Kraftstoffart',
    homologationPlatformVehicleApprovalNumberLabel: 'Genehmigungsnummer',
    homologationPlatformVehicleResponsibleCompanyLabel: 'Verantwortliches Unternehmen',
    homologationPlatformVehicleNextInspectionDueAtLabel: 'Nächste Prüfung fällig am',
    homologationPlatformVehicleTechnicalDataSection: 'Technische Daten',
    homologationPlatformVehicleHomologationSection: 'Homologation',
    homologationPlatformVehicleResponsiblePartySection: 'Verantwortliche Stelle',
    homologationPlatformVehicleInspectionChecklistSection: 'Prüfcheckliste',
    homologationPlatformVehicleDocumentsSection: 'Dokumente',
    homologationPlatformVehicleProductionYearLabel: 'Baujahr',
    homologationPlatformVehicleAxleCountLabel: 'Achsen',
    homologationPlatformVehicleGrossWeightLabel: 'Zulässiges Gesamtgewicht kg',
    homologationPlatformVehicleEnginePowerLabel: 'Motorleistung kW',
    homologationPlatformVehicleCo2Label: 'CO₂ g/km',
    homologationPlatformVehicleElectricRangeLabel: 'Elektrische Reichweite km',
    homologationPlatformVehicleEmissionClassLabel: 'Emissionsklasse',
    homologationPlatformVehicleTrailerCouplingLabel: 'Anhängerkupplung',
    homologationPlatformVehicleAuthorityLabel: 'Behörde',
    homologationPlatformVehicleCountryCodeLabel: 'Ländercode',
    homologationPlatformVehicleValidFromLabel: 'Gültig ab',
    homologationPlatformVehicleValidUntilLabel: 'Gültig bis',
    homologationPlatformVehicleLastInspectionAtLabel: 'Letzte Prüfung am',
    homologationPlatformVehicleContactNameLabel: 'Kontaktperson',
    homologationPlatformVehicleRequirementLabel: 'Anforderung',
    homologationPlatformVehicleDueDateLabel: 'Fällig am',
    homologationPlatformVehicleCheckedLabel: 'Geprüft',
    homologationPlatformVehicleDocumentTypeLabel: 'Dokumenttyp',
    homologationPlatformVehicleFileNameLabel: 'Dateiname',
    homologationPlatformVehicleNotesLabel: 'Notizen',

    homologationPlatformVehicleStatus: {
        Draft: 'Entwurf',
        InReview: 'In Prüfung',
        Published: 'Veröffentlicht',
        Archived: 'Archiviert',
    },
    homologationPlatformVehicleType: {
        Tractor: 'Sattelzugmaschine',
        RigidTruck: 'LKW',
        Trailer: 'Anhänger',
        Van: 'Transporter',
        Bus: 'Bus',
    },
    homologationPlatformVehicleFuel: {
        Diesel: 'Diesel',
        Electric: 'Elektrisch',
        Hydrogen: 'Wasserstoff',
        Hybrid: 'Hybrid',
        Cng: 'CNG',
        Lng: 'LNG',
    },
    homologationPlatformVehicleInspection: {
        Open: 'Offen',
        InProgress: 'In Bearbeitung',
        Passed: 'Bestanden',
        Failed: 'Nicht bestanden',
        NotRequired: 'Nicht erforderlich',
    },
    homologationPlatformVehicleDocument: {
        Missing: 'Fehlt',
        Uploaded: 'Hochgeladen',
        Approved: 'Freigegeben',
        Expired: 'Abgelaufen',
    },
    homologationPlatformVehicleDocumentType: {
        TypeApproval: 'Typgenehmigung',
        CertificateOfConformity: 'Certificate of Conformity',
        InspectionReport: 'Prüfbericht',
        EmissionCertificate: 'Emissionsnachweis',
        Insurance: 'Versicherung',
    },
    auditChangeType: {
        Created: 'Erstellt',
        Updated: 'Aktualisiert',
        Deleted: 'Gelöscht',
        Restored: 'Wiederhergestellt',
        Imported: 'Importiert',
        SystemUpdated: 'Systemaktualisierung',
    },
    entityStatus: {
        Draft: 'Entwurf',
        Active: 'Aktiv',
        Inactive: 'Inaktiv',
        Archived: 'Archiviert',
        Deleted: 'Gelöscht',
    },
    documentCategory: {
        Personnel: 'Personal',
        Application: 'Bewerbung',
        CustomerContract: 'Kundenvertrag',
        SupplierContract: 'Lieferantenvertrag',
        Accounting: 'Buchhaltung',
        Tax: 'Steuer',
        Project: 'Projekt',
        Marketing: 'Marketing',
        Support: 'Support',
        Technical: 'Technisch',
        Other: 'Sonstiges',
    },
    gdprLawfulBasis: {
        Consent: 'Einwilligung',
        Contract: 'Vertrag',
        LegalObligation: 'Rechtliche Verpflichtung',
        VitalInterests: 'Lebenswichtige Interessen',
        PublicTask: 'Öffentliche Aufgabe',
        LegitimateInterest: 'Berechtigtes Interesse',
    },
    deletionTrigger: {
        PurposeFulfilled: 'Zweck erfüllt',
        RetentionPeriodExpired: 'Aufbewahrungsfrist abgelaufen',
        ApplicationProcessFinished: 'Bewerbungsprozess abgeschlossen',
        ContractEnded: 'Vertrag beendet',
        ConsentWithdrawn: 'Einwilligung widerrufen',
        ManualReviewRequired: 'Manuelle Prüfung erforderlich',
        LegalHoldReleased: 'Sperrvermerk aufgehoben',
    },
    storageLocation: {
        HrSystem: 'HR System',
        Email: 'E Mail',
        ApplicationPortal: 'Bewerbungsportal',
        Crm: 'CRM',
        Erp: 'ERP',
        ProjectDrive: 'Projektablage',
        FinanceSystem: 'Finanzsystem',
        Dms: 'DMS',
        Archive: 'Archiv',
        Database: 'Datenbank',
        Other: 'Sonstiges',
    },

    Core: {
        AuditChangeType: {
            Created: 'Erstellt',
            Updated: 'Aktualisiert',
            Deleted: 'Gelöscht',
            Restored: 'Wiederhergestellt',
            Imported: 'Importiert',
            SystemUpdated: 'Systemaktualisierung',
        },
        EntityStatus: {
            Draft: 'Entwurf',
            Active: 'Aktiv',
            Inactive: 'Inaktiv',
            Archived: 'Archiviert',
            Deleted: 'Gelöscht',
        },
    },
    'enum': {
        auditChangeType: {
            Created: 'Erstellt',
            Updated: 'Aktualisiert',
            Deleted: 'Gelöscht',
            Restored: 'Wiederhergestellt',
            Imported: 'Importiert',
            SystemUpdated: 'Systemaktualisierung',
        },
        entityStatus: {
            Draft: 'Entwurf',
            Active: 'Aktiv',
            Inactive: 'Inaktiv',
            Archived: 'Archiviert',
            Deleted: 'Gelöscht',
        },
        documentCategory: {
            Personnel: 'Personal',
            Application: 'Bewerbung',
            CustomerContract: 'Kundenvertrag',
            SupplierContract: 'Lieferantenvertrag',
            Accounting: 'Buchhaltung',
            Tax: 'Steuer',
            Project: 'Projekt',
            Marketing: 'Marketing',
            Support: 'Support',
            Technical: 'Technisch',
            Other: 'Sonstiges',
        },
        gdprLawfulBasis: {
            Consent: 'Einwilligung',
            Contract: 'Vertrag',
            LegalObligation: 'Rechtliche Verpflichtung',
            VitalInterests: 'Lebenswichtige Interessen',
            PublicTask: 'Öffentliche Aufgabe',
            LegitimateInterest: 'Berechtigtes Interesse',
        },
        deletionTrigger: {
            PurposeFulfilled: 'Zweck erfüllt',
            RetentionPeriodExpired: 'Aufbewahrungsfrist abgelaufen',
            ApplicationProcessFinished: 'Bewerbungsprozess abgeschlossen',
            ContractEnded: 'Vertrag beendet',
            ConsentWithdrawn: 'Einwilligung widerrufen',
            ManualReviewRequired: 'Manuelle Prüfung erforderlich',
            LegalHoldReleased: 'Sperrvermerk aufgehoben',
        },
        storageLocation: {
            HrSystem: 'HR System',
            Email: 'E Mail',
            ApplicationPortal: 'Bewerbungsportal',
            Crm: 'CRM',
            Erp: 'ERP',
            ProjectDrive: 'Projektablage',
            FinanceSystem: 'Finanzsystem',
            Dms: 'DMS',
            Archive: 'Archiv',
            Database: 'Datenbank',
            Other: 'Sonstiges',
        },
    },

    general_displayName: 'Anzeigename',
    general_entityMetadata: 'Metadaten',
    general_lifecycle: 'Lebenszyklus',
    general_lifecycleStatus: 'Lebenszyklusstatus',
    general_versionMetadata: 'Versionierung',
    general_semanticVersion: 'Semantische Version',
    general_versionChange: 'Versionsänderung',
    general_auditTrail: 'Audit Übersicht',
    general_auditEntries: 'Audit Einträge',
    general_auditEntry: 'Audit Eintrag',
    general_auditFieldChange: 'Feldänderung',
    general_complianceMetadata: 'Compliance',
    general_gdprMetadata: 'DSGVO',
    general_retentionPolicy: 'Aufbewahrung',
    general_legalHold: 'Rechtliche Sperre',
    general_customProperties: 'Benutzerdefinierte Felder',
    general_customProperty: 'Benutzerdefiniertes Feld',
    general_systemSections: 'Systeminformationen',
    entitySystemInfoSection: 'System und Audit',
    entityMetadataSection: 'Metadaten',
    entityLifecycleSection: 'Statusverlauf',
    entityLifecycleChangedAt: 'Status geändert am',
    entityLifecycleChangedBy: 'Status geändert von',
    entityVersionSection: 'Version',
    entityVersionReleasedAt: 'Version veröffentlicht am',
    entityVersionReleasedBy: 'Version veröffentlicht von',
    entityVersionReleaseNotes: 'Versionshinweise',
    entityComplianceSection: 'Compliance und DSGVO',
    entityComplianceClassification: 'Klassifizierung',
    entityComplianceClassificationCode: 'Klassifizierungscode',
    entityComplianceLawfulBasis: 'Rechtsgrundlage',
    entityComplianceProcessingPurpose: 'Verarbeitungszweck',
    entityComplianceContainsPersonalData: 'Enthält personenbezogene Daten',
    entityComplianceDataOwner: 'Datenverantwortlicher',
    entityComplianceDeletionTrigger: 'Löschgrund',
    entityComplianceRetentionUntil: 'Aufbewahren bis',
    entityCompliancePrimaryStorageLocation: 'Primärer Speicherort',
    entityComplianceAuditRequired: 'Audit erforderlich',
    entityComplianceLegalHoldActive: 'Rechtliche Sperre aktiv',
    entityAuditTrailSection: 'Audit Einträge',
    entityAuditChangeType: 'Änderungstyp',
    entityAuditChangedAt: 'Geändert am',
    entityAuditChangedBy: 'Geändert von',
    general_createdBy: 'Erstellt von',
    general_updatedBy: 'Geändert von',
    general_changedAt: 'Geändert am',
    general_changedBy: 'Geändert von',
    general_reason: 'Grund',
    general_major: 'Major',
    general_minor: 'Minor',
    general_patch: 'Patch',
    general_label: 'Label',
    general_version: 'Version',
    general_releasedAt: 'Veröffentlicht am',
    general_releasedBy: 'Veröffentlicht von',
    general_releaseNotes: 'Release Notes',
    general_field: 'Feld',
    general_oldValue: 'Alter Wert',
    general_newValue: 'Neuer Wert',
    general_changeType: 'Änderungstyp',
    general_lastChangeType: 'Letzter Änderungstyp',
    general_lastChangedAt: 'Zuletzt geändert am',
    general_lastChangedBy: 'Zuletzt geändert von',
    general_active: 'Aktiv',
    general_activatedAt: 'Aktiviert am',
    general_activatedBy: 'Aktiviert von',
    general_category: 'Kategorie',
    general_retentionPeriodMonths: 'Aufbewahrungsfrist Monate',
    general_retentionUntil: 'Aufbewahren bis',
    general_deletionTrigger: 'Löschgrund',
    general_lawfulBasis: 'Rechtsgrundlage',
    general_processingPurpose: 'Verarbeitungszweck',
    general_containsPersonalData: 'Enthält personenbezogene Daten',
    general_dataOwner: 'Datenverantwortlicher',
    general_lastPrivacyReviewAt: 'Letzte Datenschutzprüfung',
    general_nextPrivacyReviewAt: 'Nächste Datenschutzprüfung',
    general_classification: 'Klassifizierung',
    general_classificationCode: 'Klassifizierungscode',
    general_auditRequired: 'Audit erforderlich',
    general_key: 'Schlüssel',
    general_type: 'Typ',
    general_value: 'Wert',
    general_editable: 'Editierbar',
    homologationPlatformVehicleCustomPropertyMarketSegment: 'Marktsegment',
    homologationPlatformVehicleCustomPropertyRiskScore: 'Interner Risikowert',
    homologationPlatformVehicleCustomPropertyWorkflowCode: 'Backend Workflow Code',
    homologationPlatformVehicleCustomPropertyValueLongHaul: 'Fernverkehr',
    homologationPlatformVehicleCustomPropertyValueUrbanDelivery: 'Stadtlieferung',
    homologationPlatformVehicleCustomPropertyValueBackendReviewRequired: 'Backend Prüfung erforderlich',
    homologationPlatformVehicleCustomPropertyValueFastTrack: 'Schnellfreigabe',
    customPropertyValueType: {
        Text: 'Text',
        Number: 'Nummer',
        Decimal: 'Dezimalzahl',
        Boolean: 'Ja Nein',
        Date: 'Datum',
        DateTime: 'Datum und Uhrzeit',
        EnumKey: 'Enum Schlüssel',
    },
    validation: {
        dateNotBeforeToday: '{{field}} darf nicht in der Vergangenheit liegen',
        dateNotAfterToday: '{{field}} darf nicht in der Zukunft liegen',
    },

    calendar_history_title: 'Verlauf',
    calendar_history_start: 'Beginn',
    calendar_history_end: 'Ende',
    calendar_history_status: 'Status',
    calendar_history_createdAt: 'Erstellt am',
    calendar_history_updatedAt: 'Zuletzt geändert am',
    calendar_history_decidedBy: 'Entschieden von',
    calendar_history_decidedAt: 'Entschieden am',
    calendar_history_decisionComment: 'Entscheidungskommentar',
    calendar_history_reason: 'Grund oder Beschreibung',
    calendar_history_noValue: 'Keine Angabe',
    calendar_entry_edit_title: 'Kalendereintrag bearbeiten',
    calendar_entry_edit_save: 'Änderungen speichern',
    calendar_entry_dialog_close: 'Schließen',
    navButtonEmployeeTimeOverview: 'Mitarbeiterzeiten',
    resourceManager_employeeTimeOverview_title: 'Mitarbeiterzeiten',
    resourceManager_employeeTimeOverview_heading: 'Zeiterfassung im Überblick',
    resourceManager_employeeTimeOverview_description: 'Arbeitszeiten eines Mitarbeiters projektübergreifend für Woche, Monat, Jahr oder freien Zeitraum auswerten und als Leistungsnachweis exportieren.',
    resourceManager_employeeTimeOverview_week: 'Woche',
    resourceManager_employeeTimeOverview_month: 'Monat',
    resourceManager_employeeTimeOverview_year: 'Jahr',
    resourceManager_employeeTimeOverview_employees: 'Mitarbeiter',
    resourceManager_employeeTimeOverview_employeeSelect: 'Mitarbeiter auswählen',
    resourceManager_employeeTimeOverview_selectedEmployees: 'Ausgewählte Mitarbeiter',
    resourceManager_employeeTimeOverview_selectedEmployee: 'Ausgewählter Mitarbeiter',
    resourceManager_employeeTimeOverview_employee: 'Mitarbeiter',
    resourceManager_employeeTimeOverview_calendarYear: 'Jahr',
    resourceManager_employeeTimeOverview_calendarWeek: 'KW',
    resourceManager_employeeTimeOverview_openWeek: 'Woche im Kalender öffnen',
    resourceManager_employeeTimeOverview_entries: 'Buchungen',
    resourceManager_employeeTimeOverview_bookedDays: 'Tage mit Buchungen',
    resourceManager_employeeTimeOverview_hours: 'Gebuchte Stunden',
    resourceManager_employeeTimeOverview_averagePerBookedDay: 'Ø pro Buchungstag',
    resourceManager_employeeTimeOverview_refresh: 'Aktualisieren',
    resourceManager_employeeTimeOverview_export: 'Excel exportieren',
    resourceManager_employeeTimeOverview_exportExcel: 'Leistungsnachweis Excel',
    resourceManager_employeeTimeOverview_exportPdf: 'Leistungsnachweis PDF',
    resourceManager_employeeTimeOverview_customRange: 'Zeitraum',
    resourceManager_employeeTimeOverview_invalidRange: 'Das Enddatum muss nach dem Startdatum liegen.',
    resourceManager_employeeTimeOverview_includeEntryText: 'Titel oder Projektname im PDF anzeigen',
    resourceManager_employeeTimeOverview_includeEntryTextHint: 'Wenn deaktiviert, enthält die PDF Tabelle nur Tag und Stunden.',
    resourceManager_employeeTimeOverview_noData: 'Für den ausgewählten Zeitraum sind keine Mitarbeiter ausgewählt.',
    resourceManager_employeeTimeOverview_noEmployeeSelected: 'Bitte zuerst einen Mitarbeiter auswählen.',
    resourceManager_employeeTimeOverview_noEntries: 'Für den ausgewählten Mitarbeiter wurden im Zeitraum keine Arbeitszeiten gefunden.',
    resourceManager_employeeTimeOverview_loadFailed: 'Die Mitarbeiterzeiten konnten nicht geladen werden.',
    resourceManager_employeeTimeOverview_overtimeHeading: 'Überstunden Report',
    resourceManager_employeeTimeOverview_overtimeDescription: 'Wochenübersicht mit dem kumulierten Überstundenstand am Ende jeder KW und der Veränderung innerhalb der jeweiligen Woche.',
    resourceManager_employeeTimeOverview_overtimeDay: 'Tage',
    resourceManager_employeeTimeOverview_overtimeWeek: 'Wochen',
    resourceManager_employeeTimeOverview_overtimePositiveOnly: 'Nur Zeiträume mit Überstunden',
    resourceManager_employeeTimeOverview_overtimePeriod: 'Zeitraum',
    resourceManager_employeeTimeOverview_overtimeStart: 'Start',
    resourceManager_employeeTimeOverview_overtimeEnd: 'Ende',
    resourceManager_employeeTimeOverview_overtimeExpected: 'Sollstunden',
    resourceManager_employeeTimeOverview_overtimeWorked: 'Arbeitsstunden',
    resourceManager_employeeTimeOverview_overtimeCreditable: 'Anrechenbare Leistung',
    resourceManager_employeeTimeOverview_overtime: 'Überstunden',
    resourceManager_employeeTimeOverview_overtimeBalance: 'Überstunden Stand',
    resourceManager_employeeTimeOverview_overtimeExportCsv: 'CSV exportieren',
    resourceManager_employeeTimeOverview_overtimeExportExcel: 'Excel exportieren',
    resourceManager_employeeTimeOverview_overtimeNoPositiveRows: 'Im ausgewählten Zeitraum wurden keine positiven Überstunden gefunden.',
    resourceManager_employeeTimeOverview_overtimeNoRows: 'Für den ausgewählten Zeitraum wurden keine relevanten Beschäftigungswochen gefunden.',
    resourceManager_employeeTimeOverview_overtimeLoadFailed: 'Der Überstunden Report konnte nicht geladen werden.',
    resourceManager_absenceOverview_day_label: 'Tag',
    resourceManager_absenceOverview_month_label: 'Monat',
    billingOfferSendTitle: 'Angebot versenden',
    billingInvoiceSendTitle: 'Rechnung versenden',
    billingSendDescription: '{{number}} wird als PDF angehängt. Die Versandadresse ist unabhängig vom Ansprechpartner im Dokument.',
    billingSendRecipientLabel: 'Empfänger',
    billingSendRecipientPlaceholder: 'rechnung@kunde.de',
    billingSendRecipientHint: 'Kontakt auswählen oder eine beliebige E-Mail-Adresse eingeben.',
    billingSendAdditionalRecipientsLabel: 'Weitere Empfänger',
    billingSendAdditionalRecipientsPlaceholder: 'buchhaltung@kunde.de; projektleitung@kunde.de',
    billingSendAdditionalRecipientsHint: 'Optional. Mehrere Adressen mit Komma oder Semikolon trennen.',
    billingSendInvalidAdditionalRecipient: 'Mindestens eine zusätzliche E-Mail-Adresse ist ungültig.',
    billingInvoiceSendAttachmentsHint: 'PDF-Rechnung und E-Rechnung werden automatisch angehängt.',
    billingOfferSendAttachmentsHint: 'Das finalisierte Angebot wird automatisch als PDF angehängt.',
    billingOfferSendAction: 'Angebot senden',
    billingInvoiceSendAction: 'Rechnung senden',
    resourceManager_projectStatistics_filter_budget_option: 'Nur mit hinterlegtem Budget',
    billingDefaultPaymentTermsDays: 'Standard Zahlungsziel in Tagen',
    billingDefaultDiscountPercent: 'Standard Skonto in %',
    billingDefaultDiscountDays: 'Standard Skontofrist in Tagen',
    billingDefaultPaymentTermsCustomerHint: 'Optional. Leer bedeutet: Systemstandard verwenden. Sobald ein Zahlungsziel gesetzt ist, bilden Zahlungsziel und Skonto den Kundenstandard für neue Rechnungen.',
    billingProjectPaymentTermsDays: 'Zahlungsziel Projekt in Tagen',
    billingProjectPaymentTermsHint: 'Optional. Leer bedeutet: Zahlungsbedingungen des Kunden übernehmen. Sobald ein Zahlungsziel gesetzt ist, gilt die komplette Projektregel inklusive Skonto.',
    projectTimesheetCustomer: 'Leistungsnachweis Kunde / Endkunde',
    projectTimesheetCustomerHint: 'Optional. Rechnung und Angebot bleiben beim Projektkunden; Leistungsnachweise werden für diesen Endkunden erzeugt.',
    resourceManager_calendarExport_timesheetRecipient_label: 'Leistungsnachweis für',
    fibu_unsavedChangesConfirm_title: 'Ungespeicherte Änderungen',
    fibu_unsavedChangesConfirm_message: 'Die aktuellen Änderungen wurden noch nicht gespeichert. Wirklich verwerfen und schließen?',
    fibu_unsavedChangesDiscard_button: 'Verwerfen',
    fibu_invoiceFinalizeConfirm_title: 'Rechnung finalisieren',
    fibu_invoiceFinalizeConfirm_message: 'Die Rechnung wird verbindlich finalisiert und erhält ihre Rechnungsnummer. Danach ist sie nur noch über Storno und Revision korrigierbar.',
    fibu_invoiceFinalizeConfirm_button: 'Finalisieren',
    fibu_invoiceRevisionConfirm_title: 'Neue Rechnungsrevision',
    fibu_invoiceRevisionConfirm_message: 'Eine neue bearbeitbare Revision wird angelegt. Die bisherige Rechnung bleibt gültig, bis die neue Revision finalisiert wird, und wird dann automatisch storniert.',
    fibu_invoiceRevisionConfirm_button: 'Revision anlegen',
    fibu_invoiceCancelConfirm_title: 'Rechnung stornieren',
    fibu_invoiceCancelConfirm_message: 'Die Rechnung wird storniert. Dieser Schritt ändert ihren buchhalterischen Status.',
    fibu_invoiceCancelConfirm_button: 'Stornieren',
    fibu_invoiceDeleteConfirm_title: 'Rechnung endgültig löschen',
    fibu_invoiceDeleteConfirm_message: 'Der Entwurf beziehungsweise die bereits stornierte Rechnung wird endgültig gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    fibu_offerCancelConfirm_title: 'Angebot stornieren',
    fibu_offerCancelConfirm_message: 'Das Angebot wird storniert. Fortfahren?',
    fibu_offerCancelConfirm_button: 'Stornieren',
    fibu_offerDeleteConfirm_title: 'Angebot endgültig löschen',
    fibu_offerDeleteConfirm_message: 'Der Entwurf beziehungsweise das stornierte Angebot wird endgültig gelöscht. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    account_accountPersonalData_language_header: 'Sprache',
    account_accountPersonalData_language_text: 'Die ausgewählte Sprache wird für die Oberfläche, API-Meldungen, Benachrichtigungen und E-Mails verwendet.',
    account_accountPersonalData_language_label: 'Sprache',
    resourceManager_vacationManager_addNewEntry_label: 'Neuen Urlaubseintrag hinzufügen',
    validation_endAfterStart: 'Das Ende muss nach dem Start liegen.',
    validation_singleCalendarDay: 'Dieser Eintragstyp darf nur an einem einzelnen Kalendertag liegen.',
    validation_workTimeMaxHours: 'Arbeitszeit darf maximal {{maxHours}} Stunden betragen.',
    validation_absenceMaxHours: 'Abwesenheit darf maximal {{maxHours}} Stunden betragen.',

    // Translation audit: keys referenced by frontend UI/metadata.
    ContactDetailHeader: 'Kontaktdetails',
    NoStatus: 'Kein Status',
    acquise: 'Akquise',
    alignmentHorizontal: 'Horizontal ausrichten',
    alignmentVertical: 'Vertikal ausrichten',
    account_accountCalendar_advancedOAuthSettings_label: 'Erweiterte OAuth Einstellungen',
    account_accountCalendar_advancedOAuthSettings_text: 'Optionale erweiterte OAuth Einstellungen für diese Kalenderintegration.',
    calendar_contextMenu_untilThisPoint_title: 'Stand bis zu diesem Tag',
    calendar_contextMenu_overtimeUntil: 'Überstunden bis zu diesem Tag',
    calendar_contextMenu_sickDaysUntil: 'Krankheitstage bis zu diesem Tag',
    calendar_contextMenu_vacationUntil: 'Urlaubstage bis zu diesem Tag',
    calendar_action_openDay: 'Tag öffnen',
    calendar_action_cancelVacation: 'Urlaub stornieren',
    calendar_action_cancelSick: 'Krankheit stornieren',
    calendar_noContractInPeriod: 'Für diesen Zeitraum ist kein Beschäftigungsvertrag hinterlegt.',
    crm_effortTypes_formHeader_header: 'Aufwandstypen',
    crm_task_taskEfforts_label: 'Aufwände',
    generalWarning: 'Warnung',
    generalInfo: 'Information',
    generalFilter: 'Filter',
    generalDownload: 'Herunterladen',
    adminUserVisibleInApplication: 'In der Anwendung sichtbar',
    generalUpdated: 'Aktualisiert',
    general_customer: 'Kunde',
    general_nr: 'Nr.',
    crm_project_createOffer_tooltip: 'Angebot für dieses Projekt erstellen',
    crm_project_createInvoice_tooltip: 'Rechnung für dieses Projekt erstellen',
    crm_project_merge_tooltip: 'Dieses Projekt zusammenführen',
    crm_project_merge_title: 'Projekte zusammenführen',
    crm_project_merge_description: 'Wähle das doppelte Projekt und das Projekt aus, das bestehen bleiben soll.',
    crm_project_merge_source_label: 'Zu ersetzendes Projekt',
    crm_project_merge_target_label: 'Zielprojekt',
    crm_project_merge_confirm_button: 'Projekte zusammenführen',
    crm_project_merge_warning: 'Das Quellprojekt wird entfernt, nachdem alle Referenzen erfolgreich verschoben wurden. Dieser Vorgang kann nicht rückgängig gemacht werden.',
    crm_project_merge_success_title: 'Projekte zusammengeführt',
    crm_project_merge_success_text: '{{movedReferences}} Referenzen verschoben. {{removedDuplicateReferences}} doppelte Referenzen entfernt.',
    general_inactive: 'Inaktiv',
    general_logout_button: 'Abmelden',
    notFound_description: 'Die gesuchte Seite konnte nicht gefunden werden.',
    notFound_back_button: 'Zurück',
    billing_action_preview: 'Vorschau',
    billing_action_previewFullscreen_tooltip: 'Vorschau im Vollbild öffnen',
    general_print_button: 'Drucken',
    fibu_offer_downloadFinalPdf_tooltip: 'Finales Angebots PDF herunterladen',
    fibu_offer_deleteDraft_tooltip: 'Angebotsentwurf löschen',
    fibu_offer_cancel_tooltip: 'Angebot stornieren',
    billing_action_finalize: 'Finalisieren',
    fibu_offer_invoiceDraft_action: 'Rechnungsentwurf',
    fibu_offer_invoiceDraft_tooltip: 'Einmaligen vollständigen Rechnungsentwurf aus dem Angebot erstellen',
    billing_position_manual_label: 'Freie Position',
    general_downloadPdf_tooltip: 'PDF herunterladen',
    general_moreActions_tooltip: 'Weitere Aktionen',
    general_edit_button: 'Bearbeiten',
    fibu_offer_send_action: 'Angebot versenden',
    fibu_offer_markAccepted_action: 'Als angenommen markieren',
    fibu_offer_markRejected_action: 'Als abgelehnt markieren',
    billing_position_projectCalculation_label: 'Projektkalkulation',
    fibu_invoice_exportPdf_action: 'Export als PDF',
    fibu_invoice_exportXRechnung_action: 'Export als XRechnung XML',
    fibu_invoice_exportZugferd_action: 'Export als ZUGFeRD XML',
    fibu_invoice_exportEdifact_action: 'Export als EDIFACT INVOIC D.07A',
    fibu_invoice_exportVda_action: 'Export als Volkswagen VDA 4938 T2',
    fibu_invoice_downloadOriginal_action: 'Originaldokument herunterladen',
    general_duplicate_button: 'Duplizieren',
    fibu_invoice_newRevision_action: 'Korrigieren / neue Revision',
    fibu_invoice_send_action: 'Rechnung versenden',
    fibu_invoice_markPaid_action: 'Als bezahlt markieren',
    general_close_button: 'Schließen',
    fibu_invoice_exportInvoiceAndTimesheet_action: 'Rechnung + Leistungsnachweis',
    fibu_invoice_exportInvoiceAndTimesheet_tooltip: 'Aktuelle Rechnung und zugehörigen Leistungsnachweis herunterladen',
    fibu_invoice_downloadCurrent_tooltip: 'Aktuelle Rechnung herunterladen',
    fibu_invoice_timesheet_label: 'Leistungsnachweis',
    fibu_invoice_downloadTimesheet_tooltip: 'Leistungsnachweis der aktuellen Rechnung herunterladen',
    fibu_invoice_exportAllInvoicesAndTimesheets_action: 'Alle Rechnungen + Leistungsnachweise',
    fibu_invoice_exportAllInvoicesAndTimesheets_tooltip: 'Alle geöffneten Rechnungen und zugehörigen Leistungsnachweise herunterladen',
    general_export_button: 'Export',
    fibu_invoice_export_tooltip: 'Rechnung und Leistungsnachweise exportieren',
    fibu_invoice_deleteDraft_tooltip: 'Rechnungsentwurf löschen',
    fibu_invoice_newRevision_shortAction: 'Neue Revision',
    fibu_invoice_newRevision_tooltip: 'Neue Rechnungsrevision erstellen',
    fibu_invoice_cancel_tooltip: 'Rechnung stornieren',
    fibu_invoice_deleteCancelled_tooltip: 'Stornierte Rechnung endgültig löschen',
    fibu_invoice_projectRemainingBudget_label: 'Projekt Restbudget',
    fibu_invoice_assignmentSection_description: 'Kunde, Ansprechpartner, Rechnungsanschrift und Projekt eindeutig zuordnen.',
    fibu_invoice_createContact_action: 'Ansprechpartner anlegen',
    fibu_invoice_createContact_tooltip: 'Neuen Ansprechpartner direkt für diesen Kunden anlegen',
    fibu_invoice_createAddress_action: 'Anschrift anlegen',
    fibu_invoice_createAddress_tooltip: 'Neue Rechnungsanschrift direkt für diesen Kunden anlegen',
    fibu_invoice_detailsSection_description: 'Datum, Leistungszeitraum, Fälligkeit und Betreff der Rechnung.',
    fibu_invoice_scopeSection_description: 'Projektleistungen, Budgets oder ein Angebot als Grundlage für die Rechnungspositionen verwenden.',
    fibu_invoice_positionsSection_description: 'Positionen erfassen, sortieren und Preise sowie Umsatzsteuer prüfen.',
    fibu_invoice_textsSection_description: 'Textbausteine, Zahlungsbedingungen, Bankverbindung, Abschlusstext und interne Notiz.',
    billing_position_duplicated_label: 'Duplizierte Position',
    fibu_offer_projectLoading_text: 'Projekt und Kundendaten werden für das neue Angebot geladen …',
    billing_drafts_label: 'Entwürfe',
    fibu_offer_finalOrSent_label: 'Final / versendet',
    fibu_offer_accepted_label: 'Angenommen',
    billing_selectedVolume_label: 'Volumen der Auswahl',
    general_search_label: 'Suche',
    general_allStatuses: 'Alle Status',
    fibu_offer_loading_text: 'Angebote werden geladen …',
    billing_net_label: 'Netto',
    billing_gross_label: 'Brutto',
    fibu_offer_validUntil_label: 'Gültig bis',
    billing_assignment_label: 'Zuordnung',
    fibu_offer_details_label: 'Angebotsdaten',
    billing_calculation_label: 'Kalkulation',
    billing_positions_label: 'Positionen',
    billing_texts_label: 'Texte',
    billing_beforeFinalizeCheck_label: 'Vor der Finalisierung noch prüfen',
    billing_recipientAssignment_header: 'Empfänger und Zuordnung',
    billing_recipientAssignment_description: 'Kunde, Ansprechpartner und Projekt eindeutig zuordnen.',
    fibu_offer_address_label: 'Angebotsanschrift',
    billing_noAddress_hint: 'Noch keine Anschrift hinterlegt.',
    fibu_offer_details_description: 'Datum, Gültigkeit und Betreff des Angebots.',
    fibu_offer_projectSource_header: 'Positionsquelle aus Projekt',
    fibu_offer_projectSource_description: 'Optional: Budget oder Planstunden einmalig als editierbare Positionen übernehmen. Danach arbeitest du nur noch im Abschnitt Positionen weiter.',
    billing_basis_label: 'Grundlage',
    billing_projectBudget_label: 'Projektbudget',
    billing_totalHours_label: 'Gesamtstunden',
    billing_hoursPerTask_label: 'Stunden je Aufgabe',
    billing_hoursPerMember_label: 'Stunden je Mitarbeiter',
    billing_projectFlatRate_label: 'Projektpauschale (Preis manuell)',
    billing_allTasksIfNone_hint: 'Keine Auswahl bedeutet: alle Aufgaben verwenden.',
    billing_allMembersIfNone_hint: 'Keine Auswahl bedeutet: alle Mitarbeiter verwenden.',
    fibu_offer_generatePositions_button: 'Positionen aus Projekt erzeugen',
    billing_positionsPrices_header: 'Positionen und Preise',
    billing_positionsPrices_description: 'Beschreibung, Menge, Einheit, Preis und Umsatzsteuer direkt bearbeiten. Summen werden automatisch berechnet.',
    billing_textPayment_header: 'Textbausteine und Zahlungsbedingungen',
    billing_templatePriority_description: 'Projektstandard vor Kundenstandard vor letztem Beleg vor Firmenstandard. Die Texte bleiben anschließend frei editierbar.',
    billing_intro_label: 'Einleitung',
    fibu_offer_intro_description: 'Wird vor den Positionen im Angebot ausgegeben.',
    billing_paymentTerms_header: 'Zahlungsbedingungen',
    fibu_offer_paymentTerms_description: 'Zahlungsziel steuert die Fälligkeit; der Text erscheint auf dem Angebot.',
    billing_discount_enable_label: 'Skonto gewähren',
    billing_bankAccount_label: 'Bankverbindung für Zahlungseingang',
    billing_noBankAccount_hint: 'Keine Bankverbindung in den Firmendaten hinterlegt.',
    billing_closingInternal_header: 'Abschluss und interne Notiz',
    fibu_offer_closingInternal_description: 'Der Abschlusstext erscheint im Angebot. Die interne Notiz bleibt ausschließlich im System und wird nicht auf dem Beleg ausgegeben.',
    billing_closingText_label: 'Abschlusstext',
    billing_closingText_description: 'Optionaler Text nach Zahlungsbedingung und Positionen.',
    billing_internalNote_label: 'Interne Notiz',
    fibu_offer_internalNote_description: 'Nur für interne Hinweise. Dieser Inhalt wird niemals im Angebot gedruckt.',
    fibu_offer_pageSubtitle: 'Angebote erstellen, aus Projekten kalkulieren, finalisieren und bis zur Rechnung weiterführen.',
    fibu_offer_new_button: 'Neues Angebot',
    fibu_offer_search_placeholder: 'Nummer, Kunde, Projekt oder Betreff',
    fibu_offer_sections_ariaLabel: 'Abschnitte im Angebot',
    billing_customerSearch_placeholder: 'Kunde suchen',
    billing_projectOptionalSearch_placeholder: 'Projekt suchen oder leer lassen',
    billing_buyerContact_label: 'Ansprechpartner Kunde',
    billing_contactSearch_placeholder: 'Ansprechpartner suchen',
    billing_createCustomerContact_tooltip: 'Ansprechpartner direkt für diesen Kunden anlegen',
    billing_createCustomerAddress_tooltip: 'Anschrift direkt für diesen Kunden anlegen',
    billing_sellerContact_label: 'Interner Ansprechpartner',
    billing_employeeSearch_placeholder: 'Mitarbeiter suchen',
    billing_customerReference_label: 'Kundenreferenz',
    billing_customerReference_placeholder: 'z. B. Bestellnummer oder Ansprechpartner',
    fibu_offer_date_label: 'Angebotsdatum',
    billing_subject_label: 'Betreff',
    fibu_offer_subject_placeholder: 'Worum geht es in diesem Angebot?',
    billing_hourlyRateNet_label: 'Stundensatz netto',
    billing_plannedHours_label: 'Planstunden',
    billing_paymentTargetDays_label: 'Zahlungsziel in Tagen',
    billing_discountPercent_label: 'Skonto in %',
    billing_discountDays_label: 'Skontofrist in Tagen',
    billing_paymentTerms_label: 'Zahlungsbedingung',
    fibu_offer_draftFallback: 'Angebotsentwurf',
    billing_customerNotAssigned: 'Kunde nicht zugeordnet',
    fibu_offer_freeOffer: 'Freies Angebot',
    fibu_offer_edit_title: 'Angebot bearbeiten',
    fibu_offer_create_title: 'Angebot erstellen',
    billing_draft_label: 'Entwurf',
    fibu_invoice_projectLoading_text: 'Projekt, Kunde und Rechnungspositionen werden vorbereitet …',
    fibu_invoice_openInvoices_label: 'Offene Rechnungen',
    fibu_invoice_overdue_label: 'Überfällig',
    fibu_invoice_openAmount_label: 'Offener Betrag',
    fibu_invoice_paymentStatus_label: 'Zahlungsstatus',
    general_all: 'Alle',
    general_open: 'Offen',
    fibu_invoice_paid_label: 'Bezahlt',
    fibu_invoice_imported_label: 'Importiert ·',
    fibu_invoice_delivery_label: 'Versand',
    fibu_invoice_pageSubtitle: 'Ausgangsrechnungen erstellen, prüfen, finalisieren und nachvollziehbar verwalten.',
    fibu_invoice_new_button: 'Neue Rechnung',
    general_import_button: 'Importieren',
    fibu_invoice_search_placeholder: 'Nummer, Kunde, Projekt oder Bestellung',
    fibu_invoice_customerFilter_placeholder: 'Alle Kunden oder suchen',
    fibu_invoice_projectFilter_placeholder: 'Alle Projekte oder suchen',
    fibu_invoice_draftFallback: 'Rechnungsentwurf',
    fibu_invoice_freeInvoice: 'Freie Rechnung',
    fibu_offer_status_draft: 'Entwurf',
    fibu_offer_status_finalized: 'Finalisiert',
    fibu_offer_status_sent: 'Versendet',
    fibu_offer_status_accepted: 'Angenommen',
    fibu_offer_status_rejected: 'Abgelehnt',
    fibu_offer_status_expired: 'Abgelaufen',
    fibu_offer_status_cancelled: 'Storniert',
    fibu_invoice_status_draft: 'Entwurf',
    fibu_invoice_status_finalized: 'Finalisiert',
    fibu_invoice_status_readyToSend: 'Versandbereit',
    fibu_invoice_status_sent: 'Versendet',
    fibu_invoice_status_partiallyPaid: 'Teilweise bezahlt',
    fibu_invoice_status_paid: 'Bezahlt',
    fibu_invoice_status_overdue: 'Überfällig',
    fibu_invoice_status_cancelled: 'Storniert',

    fibu_invoice_batchDrafts_ariaLabel: 'Rechnungsentwürfe im Stapel',
    general_previous_button: 'Vorherige',
    general_next_button: 'Nächste',
    fibu_invoice_batchPosition_label: 'Rechnung {{current}} von {{total}}',
    fibu_invoice_freeInvoice_hint: 'Positionen können direkt im nächsten Abschnitt erfasst werden.',
    fibu_invoice_offerPositionsImported_hint: 'Die Positionen wurden aus {{offerNumber}} übernommen. Sie können im Entwurf noch angepasst werden.',
    fibu_invoice_sourceOfferFallback: 'dem Quellangebot',
    fibu_invoice_positionsFromOffer_label: 'Positionen aus {{offerNumber}}',
    fibu_invoice_serviceDataPeriod_label: 'Leistungsdaten vom {{from}} bis {{to}}',
    fibu_invoice_billingBasis_label: 'Abrechnungsgrundlage',
    fibu_invoice_billingBasis_projectTime: 'Projektzeit zusammenfassen',
    fibu_invoice_billingBasis_entries: 'Zeitbuchungen einzeln',
    fibu_invoice_billingBasis_tasks: 'Zeit nach Aufgaben gruppieren',
    fibu_invoice_billingBasis_members: 'Zeit nach Mitarbeitern gruppieren',
    fibu_invoice_billingBasis_projectBudget: 'Projektbudget / Vertrag abrechnen',
    fibu_invoice_billingBasis_remainingBudget: 'Fixpreis / offene Projektsumme',
    fibu_invoice_fromOfferNumber_label: 'Aus Angebot {{offerNumber}}',
    fibu_invoice_fromOffer_label: 'Aus Angebot übernommen',
    fibu_invoice_allTasksIfNone_hint: 'Keine Auswahl bedeutet: alle Aufgaben abrechnen.',
    general_useAll_button: 'Alle verwenden',
    fibu_invoice_noProjectTasks_hint: 'Für dieses Projekt wurden keine Aufgaben gefunden.',
    fibu_invoice_splitByMembers_header: 'Nach Mitarbeitern aufteilen',
    fibu_invoice_limitMembers_header: 'Mitarbeiter einschränken',
    fibu_invoice_splitByMembers_hint: 'Die Rechnung erhält eine eigene Position je Mitarbeiter. Keine Auswahl bedeutet: alle Projektmitarbeiter.',
    fibu_invoice_limitMembers_hint: 'Die ausgewählten Mitarbeiter werden zu einer gemeinsamen Rechnungsposition summiert. Keine Auswahl bedeutet: alle Projektmitarbeiter.',
    fibu_invoice_noProjectMembers_hint: 'Für dieses Projekt wurden keine Mitarbeiter gefunden.',
    fibu_invoice_projectBudgetsContracts_header: 'Projektbudgets und Verträge',
    fibu_invoice_projectBudgetsContracts_hint: 'Wähle den Budgettopf, gegen den die geleisteten Stunden fakturiert werden.',
    general_clearSelection_button: 'Auswahl aufheben',
    fibu_invoice_noActiveHourBudgets_hint: 'Für dieses Projekt sind noch keine aktiven Stundenbudgets hinterlegt.',
    fibu_invoice_offerPositionsEditable_hint: 'Die Positionen wurden aus dem Angebot übernommen und können im Entwurf noch bearbeitet werden. Für eine Teilrechnung können nicht benötigte Angebotspositionen entfernt oder mengenmäßig angepasst werden.',
    fibu_invoice_serviceEntries_label: 'Leistungsbuchungen',
    fibu_invoice_alreadyInvoicedExcluded_label: 'bereits fakturiert ausgeschlossen',
    fibu_invoice_remainingSelectedBudget_label: 'Rest im gewählten Budget',
    fibu_invoice_outsideRemainingBudget_label: 'außerhalb des Restbudgets',
    fibu_invoice_timesheetPerMember_hint: 'Leistungsnachweise getrennt je Mitarbeiter ausgeben. Ohne Auswahl entsteht ein gemeinsamer Leistungsnachweis.',
    fibu_invoice_applyRemainingProjectAmount_button: 'Offene Projektsumme als Position übernehmen',
    fibu_invoice_applyBudgetTimes_button: 'Budgetzeiten als Positionen übernehmen',
    fibu_invoice_applyServiceData_button: 'Leistungsdaten als Positionen übernehmen',
    fibu_invoice_intro_description: 'Wird vor den Positionen auf der Rechnung ausgegeben.',
    fibu_invoice_paymentTerms_description: 'Zahlungsziel steuert die Fälligkeit; der Text erscheint auf der Rechnung.',
    fibu_invoice_restoreDefault_button: 'Standard wiederherstellen',
    fibu_invoice_preferredFormat_hint: 'wird für Versand und Export vorausgewählt',
    fibu_invoice_internalNote_description: 'Nur für interne Hinweise. Dieser Inhalt wird niemals auf der Rechnung gedruckt.',

    fibu_offer_previewZoom_ariaLabel: 'Zoom der Angebotsvorschau',
    fibu_invoice_previewZoom_ariaLabel: 'Zoom der Rechnungsvorschau',
    general_zoomOut_tooltip: 'Verkleinern',
    general_zoomIn_tooltip: 'Vergrößern',
    general_resetZoom_tooltip: 'Auf {{zoom}} % zurücksetzen',
    general_closeFullscreen_tooltip: 'Vollbild schließen',
    billing_selectCustomer_hint: 'Kunde auswählen',
    fibu_offer_selectAddress_hint: 'Angebotsanschrift auswählen',
    fibu_offer_documentTitle: 'Angebot',
    billing_subjectMissing_hint: 'Betreff fehlt',
    billing_position_shortLabel: 'Pos.',
    billing_description_label: 'Bezeichnung',
    billing_quantity_label: 'Menge',
    billing_unitPrice_label: 'Einzelpreis',
    billing_totalPrice_label: 'Gesamtpreis',
    billing_descriptionMissing_hint: 'Beschreibung fehlt',
    billing_subtotalCurrency_label: 'Zwischensumme in {{currency}}',
    billing_grandTotalCurrency_label: 'Gesamtsumme in {{currency}}',
    billing_documentNumber_label: 'Belegnummer',
    billing_customerNumber_label: 'Ihre Kunden-Nr.',
    general_selectPlease: 'Bitte auswählen',
    billing_yourContact_label: 'Ihr Ansprechpartner',
    billing_managingDirectors_label: 'Geschäftsführer',
    billing_bankDetails_label: 'Bankverbindung',
    billing_taxOffice_label: 'Finanzamt',
    billing_taxNumber_label: 'Steuernummer',
    billing_registryCourt_label: 'Registergericht',
    general_pageOf_label: 'Seite {{page}} von {{total}}',
    billing_previewUpdating_label: 'Vorschau wird aktualisiert',
    billing_previewStale_label: 'Vorschau ist nicht aktuell',
    fibu_invoice_date_label: 'Rechnungsdatum',
    fibu_invoice_servicePeriod_label: 'Leistungszeitraum',
    fibu_invoice_orderNumber_label: 'Bestellung Nr.',
    billing_extension_label: 'Durchwahl',

    billing_textTemplate_save_title: 'Textbaustein speichern',
    billing_textTemplate_scope_label: 'Gültigkeit',
    billing_textTemplate_scope_company: 'Firmenstandard',
    billing_textTemplate_scope_customer: 'Kundenstandard',
    billing_textTemplate_scope_project: 'Projektstandard',
    billing_textTemplate_preferredDefault_label: 'Als bevorzugten Standard verwenden',
    billing_textTemplate_empty_error: 'Der aktuelle Text ist leer und kann nicht als Baustein gespeichert werden.',
    billing_textTemplate_saved_message: '{{scope}} gespeichert.',
    billing_textTemplate_save_error: 'Textbaustein konnte nicht gespeichert werden.',
    billing_textTemplate_template_label: 'Vorlage',
    billing_textTemplate_default_label: 'Standard',
    billing_textTemplate_defaultIntro_name: 'Standard Einleitung',
    billing_textTemplate_defaultPaymentTerms_name: 'Standard Zahlungsbedingung',
    billing_textTemplate_defaultClosing_name: 'Standard Abschlusstext',
    billing_textTemplate_header: 'Vorlagen und Standards',
    billing_textTemplate_priority_hint: 'Projektstandard hat Vorrang vor Kundenstandard, letztem Beleg und Firmenstandard.',
    billing_textTemplate_applyIntro_label: 'Einleitung übernehmen',
    billing_textTemplate_saveIntro_tooltip: 'Aktuelle Einleitung als Vorlage speichern',
    billing_textTemplate_applyPaymentTerms_label: 'Zahlungsbedingung übernehmen',
    billing_textTemplate_savePaymentTerms_tooltip: 'Aktuelle Zahlungsbedingung als Vorlage speichern',
    billing_textTemplate_applyClosing_label: 'Abschlusstext übernehmen',
    billing_textTemplate_saveClosing_tooltip: 'Aktuellen Abschlusstext als Vorlage speichern',
    billing_textTemplate_bookmark_hint: 'Mit dem Lesezeichen kannst du den aktuellen Text als Firmen-, Kunden- oder Projektstandard speichern.',

    resourceManager_calendarExport_timesheets_header: 'Leistungsnachweise',
    resourceManager_calendarExport_timesheets_description: 'Unabhängig von der Rechnung festlegen, ob und wie Leistungsnachweise ausgegeben werden.',
    resourceManager_calendarExport_timesheetOutput_label: 'Ausgabe Leistungsnachweise',
    resourceManager_calendarExport_timesheetNone_option: 'Keine Leistungsnachweise',
    resourceManager_calendarExport_timesheetCombined_option: 'Ein gemeinsames Dokument',
    resourceManager_calendarExport_timesheetSeparate_option: 'Getrennt je Mitarbeiter',
    resourceManager_calendarExport_timesheetSeparate_summary: 'Leistungsnachweise getrennt je Mitarbeiter',
    resourceManager_calendarExport_timesheetCombined_summary: 'Ein gemeinsamer Leistungsnachweis',
    resourceManager_calendarExport_invoiceCreation_header: 'Rechnungserstellung',
    resourceManager_calendarExport_invoiceCreation_description: 'Eine gemeinsame Rechnung oder je ausgewähltem Mitarbeiter einen eigenen Entwurf erzeugen.',
    resourceManager_calendarExport_invoiceNone_option: 'Keine Rechnung erstellen',
    resourceManager_calendarExport_invoiceSingle_option: 'Eine gemeinsame Rechnung',
    resourceManager_calendarExport_invoicePerMember_option: 'Eine Rechnung je Mitarbeiter',
    resourceManager_calendarExport_invoicePositions_label: 'Rechnungspositionen',
    resourceManager_calendarExport_positionsSummary_option: 'Zeiten gemeinsam summieren',
    resourceManager_calendarExport_positionsMember_option: 'Zeiten je Mitarbeiter summieren',
    resourceManager_calendarExport_matchingBudgets_label: '{{count}} passende Projektbudgets werden berücksichtigt.',
    resourceManager_calendarExport_budgetRates_hint: 'Die Rechnungspositionen verwenden die jeweils im Budget hinterlegten Stundensätze. Unterschiedliche Stundensätze werden nicht künstlich zu einem Mischpreis zusammengezogen.',
    resourceManager_calendarExport_summary_header: 'Ausgabeübersicht',
    resourceManager_calendarExport_invoiceNone_summary: 'Keine Rechnung',
    resourceManager_calendarExport_invoicePerMember_summary: '{{count}} getrennte Rechnungsentwürfe',
    resourceManager_calendarExport_invoiceBudget_summary: 'Eine Rechnung, Budgetpositionen mit hinterlegten Stundensätzen',
    resourceManager_calendarExport_invoiceMemberPositions_summary: 'Eine Rechnung, Positionen je Mitarbeiter',
    resourceManager_calendarExport_invoiceCombined_summary: 'Eine gemeinsame Rechnung',
    resourceManager_calendarExport_invoicePermission_error: 'Dir fehlt die Berechtigung, Rechnungsentwürfe zu erstellen.',
    resourceManager_calendarExport_timesheetPermission_error: 'Dir fehlt die Berechtigung, Leistungsnachweise zu exportieren.',
    resourceManager_calendarExport_invoiceUserRequired_error: 'Bitte mindestens einen Mitarbeiter für die Rechnung auswählen.',
    resourceManager_calendarExport_outputRequired_error: 'Bitte mindestens eine Ausgabe auswählen: Leistungsnachweis oder Rechnung.',

    fibu_invoice_preview_name: 'Rechnungsvorschau',
    fibu_invoice_title_number: 'Rechnung {{invoiceNumber}}',
    fibu_invoice_new_title: 'Neue Rechnung',
    fibu_invoice_customerNotSelected_label: 'Kunde noch nicht gewählt',
    fibu_invoice_noFinalPdf_message: 'Für diesen Entwurf wurde noch keine finale PDF erzeugt.',
    fibu_invoice_batchCompleteRequired_message: 'Bitte die Pflichtfelder dieser Rechnung vervollständigen und speichern, bevor du zur nächsten Rechnung wechselst.',
    fibu_invoice_draftSaved_message: 'Entwurf wurde gespeichert.',
    fibu_invoice_previewNotReady_message: 'Die Rechnungsvorschau ist noch nicht bereit.',
    fibu_invoice_finalized_message: 'Rechnung {{invoiceNumber}} wurde finalisiert.',
    fibu_invoice_draftLoad_error: 'Rechnungsentwurf konnte nicht geladen werden.',
    fibu_invoice_customerRequired_error: 'Bitte einen Kunden auswählen.',
    fibu_invoice_customerContactRequired_error: 'Bitte einen Ansprechpartner beim Kunden auswählen.',
    fibu_invoice_addressRequired_error: 'Bitte eine Rechnungsanschrift auswählen.',
    fibu_invoice_contactNameRequired_error: 'Bitte einen Ansprechpartner angeben.',
    fibu_invoice_recipientIncomplete_error: 'Der Rechnungsempfänger ist unvollständig.',
    fibu_invoice_addressIncomplete_error: 'Die Rechnungsanschrift ist unvollständig. Straße, PLZ, Ort und Land werden benötigt.',
    fibu_invoice_recipientEmailInvalid_error: 'Beim Rechnungsempfänger ist keine gültige E Mail Adresse hinterlegt.',
    fibu_invoice_sellerContactRequired_error: 'Bitte einen internen Ansprechpartner auswählen.',
    fibu_invoice_bankAccountRequired_error: 'Bitte eine Bankverbindung auswählen.',
    fibu_invoice_subjectRequired_error: 'Bitte eine Leistungsüberschrift eintragen.',
    fibu_invoice_subjectMaxLength_error: 'Die Leistungsüberschrift darf maximal 250 Zeichen lang sein.',
    fibu_invoice_orderNumberMaxLength_error: 'Die Bestellnummer darf maximal 100 Zeichen lang sein.',
    fibu_invoice_customerReferenceMaxLength_error: 'Die Kundenreferenz darf maximal 150 Zeichen lang sein.',
    fibu_invoice_lineItemRequired_error: 'Bitte mindestens eine vollständige Rechnungsposition erfassen.',
    fibu_invoice_dateInvalid_error: 'Bitte ein gültiges Rechnungsdatum auswählen.',
    fibu_invoice_servicePeriodInvalid_error: 'Bitte einen gültigen Leistungszeitraum auswählen.',
    fibu_invoice_servicePeriodOrder_error: 'Der Leistungsbeginn darf nicht nach dem Leistungsende liegen.',
    fibu_invoice_dueDateBeforeInvoiceDate_error: 'Das Fälligkeitsdatum darf nicht vor dem Rechnungsdatum liegen.',
    fibu_invoice_paymentTermsDays_error: 'Das Zahlungsziel muss zwischen 0 und 3650 Tagen liegen.',
    fibu_invoice_discountDays_error: 'Die Skontofrist muss innerhalb des Zahlungsziels liegen.',
    fibu_invoice_paymentTermsRequired_error: 'Bitte eine Zahlungsbedingung angeben.',
    fibu_invoice_paymentTermsMaxLength_error: 'Die Zahlungsbedingung darf maximal 1000 Zeichen lang sein.',
    fibu_invoice_hourlyRateRequired_error: 'Für die zeitbasierte Abrechnung ist ein Stundensatz größer 0 erforderlich.',
    fibu_invoice_projectBudgetRequired_error: 'Bitte mindestens ein Projektbudget für die Abrechnung auswählen.',
    fibu_invoice_paymentTermsOverride_label: 'Für diese Rechnung überschrieben',
    fibu_invoice_projectBudgetSelect_message: 'Bitte mindestens ein Projektbudget auswählen.',
    fibu_invoice_noBillableRemainingBudget_message: 'Für das Projekt ist aktuell kein abrechenbares Restbudget vorhanden.',
    fibu_invoice_remainingProjectAmount_description: '{{projectName}} · Pauschale / offene Projektsumme',
    fibu_invoice_timeEntry_label: 'Zeitbuchung',
    fibu_invoice_noBillableTimes_message: 'Im gewählten Leistungszeitraum wurden keine abrechenbaren Zeiten gefunden.',
    fibu_invoice_positionsGenerated_message: '{{count}} Positionen übernommen. {{details}}',
    fibu_invoice_serviceDataLoad_error: 'Leistungsdaten konnten nicht geladen werden: {{error}}',
    fibu_invoice_oneEmployee_label: '1 Mitarbeiter',
    fibu_invoice_selectedEmployees_label: '{{count}} ausgewählte Mitarbeiter',
    fibu_invoice_projectEmployeesCount_label: '{{count}} Projektmitarbeiter',
    fibu_invoice_projectEmployees_label: 'Projektmitarbeiter',
    fibu_invoice_noExportableTimesheet_message: 'Für diese Rechnung ist kein exportierbarer Leistungsnachweis hinterlegt.',
    fibu_invoice_noExportableServicePeriod_message: 'Für diese Rechnung ist kein exportierbarer Leistungszeitraum hinterlegt.',
    fibu_invoice_noTimesheetEmployees_message: 'Für das Projekt konnten keine Mitarbeiter für den Leistungsnachweis ermittelt werden.',
    fibu_invoice_customerSearchEmpty_text: 'Kunde suchen und auswählen',
    fibu_invoice_noProject_option: 'Kein Projekt',
    fibu_invoice_contactsLoading_text: 'Ansprechpartner werden geladen',
    fibu_invoice_selectContact_text: 'Ansprechpartner auswählen',
    fibu_invoice_billingAddress_label: 'Rechnungsanschrift',
    fibu_invoice_selectBillingAddress_text: 'Rechnungsanschrift auswählen',
    fibu_invoice_noAddress_text: 'Noch keine Anschrift hinterlegt',
    fibu_invoice_details_label: 'Rechnungsdaten',
    fibu_invoice_deliveryDate_label: 'Lieferdatum',
    fibu_invoice_serviceStart_label: 'Leistungsbeginn',
    fibu_invoice_serviceEnd_label: 'Leistungsende',
    fibu_invoice_subject_label: 'Leistungsüberschrift',
    fibu_invoice_scope_label: 'Leistungsumfang',
    fibu_invoice_defaultSubject: 'Leistungsabrechnung',
    fibu_invoice_systemDefault_label: 'Systemstandard',
    fibu_invoice_paymentTermsOverride_hint: 'Abweichend vom {{fallback}}. Die Änderung gilt nur für diese Rechnung.',
    fibu_invoice_paymentTermsFromProject_hint: 'Aus den Zahlungsbedingungen des ausgewählten Projekts übernommen.',
    fibu_invoice_paymentTermsFromCustomer_hint: 'Aus den Standard Zahlungsbedingungen des Kunden übernommen.',
    fibu_invoice_paymentTermsSystemDefault_hint: 'Kein Projekt oder Kundenstandard hinterlegt. Es gilt der Systemstandard.',
    fibu_invoice_sharedProjectBudget_label: 'Gemeinsamer Projekttopf',
    fibu_invoice_projectScopeLoad_error: 'Projektumfang konnte nicht geladen werden: {{error}}',
    fibu_invoice_customerContactsLoad_error: 'Kundenansprechpartner konnten nicht geladen werden: {{error}}',
    fibu_invoice_customerDetailsLoad_error: 'Kundendetails konnten nicht geladen werden: {{error}}',
    fibu_invoice_customerNumberFallback: 'Kunde #{{customerId}}',
    fibu_invoice_projectServicesSubject: 'Unterstützungsleistungen „{{projectName}}“',
    general_actionFailed_error: 'Die Aktion konnte nicht ausgeführt werden.',

    fibu_invoice_dueDate_label: 'Fällig am',
    fibu_invoice_defaultPaymentTerms: '{{days}} Tage netto ohne Abzug.',
    fibu_invoice_defaultIntroText: 'Gemäß Ihrer Bestellung stellen wir Ihnen folgende Leistungen in Rechnung:',
    fibu_invoice_defaultClosingText: 'Wir bedanken uns für Ihren Auftrag und freuen uns auf eine weitere Zusammenarbeit.',
    fibu_invoice_deliveryStatus_notSent: 'Nicht versendet',
    fibu_invoice_deliveryStatus_sent: 'Versendet',
    fibu_invoice_deliveryStatus_ready: 'Versandbereit',
    fibu_invoice_copySubject: '{{subject}} Kopie',
    fibu_invoice_defaultCopySubject: 'Leistungsabrechnung Kopie',
    fibu_invoice_projectBilling_label: 'Projektabrechnung',

    fibu_invoice_imported_message: 'Rechnung {{invoiceNumber}} wurde importiert.',
    fibu_invoice_revisionCreated_message: 'Revision {{revision}} von {{invoiceNumber}} wurde als Entwurf angelegt.',
    fibu_invoice_revisionCreate_error: 'Revision konnte nicht erstellt werden: {{error}}',
    fibu_invoice_duplicated_message: 'Rechnung wurde als neuer Entwurf dupliziert.',
    fibu_invoice_markedPaid_message: '{{invoiceNumber}} wurde als bezahlt markiert.',
    fibu_invoice_cancelled_message: '{{invoiceNumber}} wurde storniert.',
    fibu_invoice_deleteActive_error: 'Aktive finalisierte Rechnungen müssen vor dem Löschen storniert werden.',
    fibu_invoice_draftWithId_label: 'Entwurf {{id}}',
    fibu_invoice_deleted_message: 'Rechnung {{invoice}} wurde gelöscht.',
    fibu_invoice_delete_error: 'Rechnung konnte nicht gelöscht werden: {{error}}',
    fibu_invoice_structuredExportDraft_error: 'Strukturierte Formate können erst nach dem Speichern bzw. Finalisieren exportiert werden.',
    fibu_invoice_noBatchExport_message: 'Es sind keine mehreren Rechnungen zum Export geöffnet.',
    fibu_invoice_finalizeBeforeBatchExport_error: 'Bitte zuerst alle Rechnungen finalisieren. {{count}} Rechnung(en) haben noch keine finale PDF.',
    fibu_invoice_batchExportStarted_message: 'Export für {{count}} Rechnungen und zugehörige Leistungsnachweise gestartet.',
    fibu_invoice_sent_message: '{{invoiceNumber}} wurde versendet.',
    fibu_invoice_number_label: 'Rechnungsnummer',
    fibu_invoice_due_label: 'Fällig',
    fibu_invoice_noMatchingProjectBudget_error: 'Für den ausgewählten Mitarbeiter wurde kein passendes Projektbudget gefunden.',
    fibu_invoice_projectService_label: 'Projektleistung',
    fibu_invoice_customersLoad_error: 'Kunden konnten nicht geladen werden: {{error}}',
    fibu_invoice_projectsLoad_error: 'Projekte konnten nicht geladen werden: {{error}}',
    fibu_invoice_sellerContactsLoad_error: 'Interne Ansprechpartner konnten nicht geladen werden: {{error}}',
    fibu_invoice_projectBillingAddressLoad_error: 'Die Rechnungsanschrift des Projektkunden konnte nicht geladen werden: {{error}}',
    fibu_invoice_positionsGenerate_error: 'Rechnungspositionen konnten nicht automatisch erzeugt werden: {{error}}',
    fibu_invoice_projectForCreationLoad_error: 'Das Projekt konnte für die Rechnungserstellung nicht geladen werden: {{error}}',

    general_unknownError: 'Unbekannter Fehler',

    resourceManager_projectStatistics_budgetExport_receiver_hint: 'Firma, die im Kundenexport als Empfänger mit Anschrift erscheint.',
    resourceManager_projectStatistics_budgetExport_period_label: 'Auswertungszeitraum',
    resourceManager_projectStatistics_budgetExport_period_hint: 'Standardmäßig bis zum Ende des vorherigen Monats.',
    resourceManager_projectStatistics_budgetExport_untilToday_button: 'Bis heute',
    resourceManager_projectStatistics_budgets_label: 'Budgets',
    resourceManager_weekStats_statistics_header: 'Statistik',
    resourceManager_weekStats_total_header: 'Gesamt',
    resourceManager_weekStats_actual_header: 'Ist',
    resourceManager_weekStats_balance_header: 'Saldo',
    resourceManager_weekStats_weekHoursTotal_label: 'Std./Woche Ges',
    resourceManager_weekStats_weekHoursToDate_label: 'Std./Woche bis heute',
    resourceManager_weekStats_overtimeTotal_label: 'Überstunden (Summe)',
    resourceManager_weekStats_workDaysPerWeek_label: 'Arbeitstage/Woche',
    billing_quickCreate_defaultAddress_label: 'Als Standardanschrift verwenden',
    billing_quickCreate_contactCreate_error: 'Ansprechpartner konnte nicht angelegt werden: {{error}}',
    billing_quickCreate_addressCreate_error: 'Anschrift konnte nicht angelegt werden: {{error}}',
    general_dataTools_button: 'Datenwerkzeuge',
    general_details_button: 'Details',
    resourceManager_calendarStatistic_vacationDays_label: 'Urlaubstage',
    general_actionCompleted: 'Aktion erfolgreich ausgeführt.',
    fibu_ocrImport_bookingsImported_message: '{{count}} Buchungen erfolgreich importiert.',
    fibu_ocrImport_bookingsFailed_message: 'Fehler bei Buchungen: {{files}}',
    notification_close_ariaLabel: 'Benachrichtigung schließen',

    resourceManager_projectStatistics_serviceValue_label: 'Leistungswert',
    notification_center_title: 'Benachrichtigungen',
    notification_center_empty: 'Keine Benachrichtigungen vorhanden',
    billing_addPosition_action: 'Position hinzufügen',
    administration_companyLogo_subtitle: 'Firmenlogo verwalten',
    administration_noContent_text: 'Für diesen Bereich sind aktuell keine Inhalte verfügbar.',
    administration_environment_global_header: 'Globale Umgebung',
    administration_environment_companyName_label: 'Firmenname',
    administration_environment_aspNet_label: 'ASP.NET Umgebung',
    administration_environment_paths_header: 'Pfade und Verzeichnisse',
    administration_environment_endpoints_header: 'Endpunkte',
    administration_addresses_title: 'Adressen',
    administration_addresses_description: 'Firmenadressen anzeigen und bearbeiten',
    administration_addresses_subtitle: 'Hinterlegte Firmenadressen und Zustellinformationen',
    administration_payment_title: 'Zahlungsdaten',
    administration_payment_description: 'Bankkonten und Zahlungswege verwalten',
    administration_payment_newAccount_button: 'Neues Konto',
    administration_payment_accounts_title: 'Bankkonten',
    administration_payment_accounts_subtitle: 'Standardkonten, IBAN und Zahlungsinformationen pflegen',
    calendar_previousYearRange_ariaLabel: 'Vorherigen Jahresbereich anzeigen',
    calendar_nextYearRange_ariaLabel: 'Nächsten Jahresbereich anzeigen',

    general_notImplemented: 'Dieser Bereich ist noch nicht implementiert.',
    general_moreActions_ariaLabel: 'Weitere Aktionen',
    product_featureMenu_ariaLabel: 'Funktionsmenü',
    fibu_journal_empty_text: 'Noch keine Daten verfügbar. Bitte buchen Sie über die Stapelbuchung in das Journal.',

    fibu_offer_preview_name: 'Angebotsvorschau',
    fibu_offer_load_error: 'Angebote konnten nicht geladen werden',
    fibu_offer_noGeneratedPositions_message: 'Für die gewählte Grundlage wurden keine Positionen gefunden.',
    fibu_offer_generatedPositions_message: '{{count}} Positionen aus dem Projekt übernommen. Du kannst sie unten direkt bearbeiten.',
    fibu_offer_projectBudgetImport_error: 'Projektbudget konnte nicht übernommen werden',
    fibu_offer_finalized_message: '{{offerNumber}} wurde finalisiert.',
    fibu_offer_draftSaved_message: 'Angebotsentwurf gespeichert.',
    fibu_offer_finalize_error: 'Angebot konnte nicht finalisiert werden',
    fibu_offer_save_error: 'Angebot konnte nicht gespeichert werden',
    fibu_offer_previewNotReady_error: 'Angebotsvorschau ist noch nicht gerendert.',
    fibu_offer_sent_message: '{{offerNumber}} wurde versendet.',
    fibu_offer_send_error: 'Angebot konnte nicht versendet werden',
    fibu_offer_cancel_error: 'Angebot konnte nicht storniert werden',
    fibu_offer_draftWithId_label: 'Entwurf {{id}}',
    fibu_offer_deleted_message: 'Angebot {{offer}} gelöscht.',
    fibu_offer_delete_error: 'Angebot konnte nicht gelöscht werden',
    fibu_offer_invoiceDraft_error: 'Rechnungsentwurf konnte nicht erstellt werden',
    fibu_offer_filePrefix: 'Angebot',
    fibu_offer_noFinalPdf_message: 'Für diesen Entwurf gibt es noch keine finale PDF.',
    fibu_offer_title_number: 'Angebot {{offerNumber}}',
    fibu_offer_new_title: 'Neues Angebot',
    fibu_offer_customerNotSelected_label: 'Kunde noch nicht gewählt',
    fibu_offer_selectCustomerFirst_message: 'Bitte zuerst einen Kunden auswählen.',
    fibu_offer_customerWithId_label: 'Kunde #{{id}}',
    fibu_offer_customerDataLoad_error: 'Kundendaten konnten nicht geladen werden',
    fibu_offer_projectScopeLoad_error: 'Projektumfang konnte nicht geladen werden',
    fibu_offer_projectSubject: 'Angebot „{{projectName}}“',
    fibu_offer_projectLoad_error: 'Projekt konnte nicht für das Angebot geladen werden',
    fibu_offer_defaultSubject: 'Projektangebot',
    fibu_offer_defaultIntroText: 'Vielen Dank für Ihre Anfrage. Gern bieten wir Ihnen folgende Leistungen an:',
    fibu_offer_defaultClosingText: 'Wir hoffen, dass unser Angebot Ihren Vorstellungen entspricht, und freuen uns auf die weitere Zusammenarbeit.',
    fibu_offer_defaultPaymentTerms: '30 Tage netto ohne Abzug.',
    fibu_offer_markedAccepted_message: '{{offerNumber}} wurde als angenommen markiert.',
    fibu_offer_markedRejected_message: '{{offerNumber}} wurde als abgelehnt markiert.',
    fibu_offer_statusChange_error: 'Status konnte nicht geändert werden',
    fibu_offer_number_label: 'Angebotsnummer',
    fibu_offer_freeOffer_label: 'Freies Angebot',
    fibu_offer_customerRequired_error: 'Bitte einen Kunden auswählen.',
    fibu_offer_buyerContactRequired_error: 'Bitte einen Ansprechpartner beim Kunden auswählen.',
    fibu_offer_buyerContactUnavailable_error: 'Der ausgewählte Kundenansprechpartner ist nicht mehr verfügbar.',
    fibu_offer_buyerContactEmail_error: 'Beim Kundenansprechpartner ist keine gültige E Mail Adresse hinterlegt.',
    fibu_offer_addressRequired_error: 'Bitte eine Angebotsanschrift auswählen.',
    fibu_offer_addressUnavailable_error: 'Die ausgewählte Angebotsanschrift ist nicht mehr verfügbar.',
    fibu_offer_addressIncomplete_error: 'Die Angebotsanschrift ist unvollständig. Straße, Hausnummer, PLZ, Ort und Land werden benötigt.',
    fibu_offer_sellerContactRequired_error: 'Bitte einen internen Ansprechpartner auswählen.',
    fibu_offer_bankAccountRequired_error: 'Bitte eine Bankverbindung auswählen.',
    fibu_offer_paymentTermsRequired_error: 'Bitte eine Zahlungsbedingung angeben.',
    fibu_offer_paymentTermsLength_error: 'Die Zahlungsbedingung darf maximal 1000 Zeichen lang sein.',
    fibu_offer_paymentTermsDays_error: 'Das Zahlungsziel muss zwischen 0 und 3650 Tagen liegen.',
    fibu_offer_discountPair_error: 'Für Skonto werden Prozentsatz und Frist benötigt.',
    fibu_offer_discountDays_error: 'Die Skontofrist muss innerhalb des Zahlungsziels liegen.',
    fibu_offer_dateRequired_error: 'Bitte ein gültiges Angebotsdatum auswählen.',
    fibu_offer_validUntilRequired_error: 'Bitte ein gültiges Gültigkeitsdatum auswählen.',
    fibu_offer_validUntilBeforeDate_error: 'Das Gültigkeitsdatum darf nicht vor dem Angebotsdatum liegen.',
    fibu_offer_subjectRequired_error: 'Bitte einen Betreff eintragen.',
    fibu_offer_subjectLength_error: 'Der Betreff darf maximal 250 Zeichen lang sein.',
    fibu_offer_introRequired_error: 'Bitte einen Einleitungstext eintragen.',
    fibu_offer_introLength_error: 'Der Einleitungstext darf maximal 4000 Zeichen lang sein.',
    fibu_offer_closingLength_error: 'Der Abschlusstext darf maximal 4000 Zeichen lang sein.',
    fibu_offer_customerReferenceLength_error: 'Die Kundenreferenz darf maximal 150 Zeichen lang sein.',
    fibu_offer_projectUnavailable_error: 'Das ausgewählte Projekt ist nicht mehr verfügbar.',
    fibu_offer_projectCustomerMismatch_error: 'Das ausgewählte Projekt gehört zu einem anderen Kunden.',
    fibu_offer_projectRequiredForBasis_error: 'Für die gewählte Kalkulationsgrundlage muss ein Projekt ausgewählt sein.',
    fibu_offer_positionsRequired_error: 'Das Angebot benötigt mindestens eine Position.',
    fibu_offer_positionsInvalid_error: 'Bitte alle Positionen vollständig mit gültiger Menge, Preis und Umsatzsteuer ausfüllen.',
    fibu_offer_hourlyRateRequired_error: 'Für eine stundenbasierte Kalkulation ist ein Stundensatz größer 0 erforderlich.',
    fibu_offer_defaultHoursRequired_error: 'Die Planstunden müssen größer 0 sein.',
    fibu_offer_paymentTermsWithDiscount: '{{days}} Tage netto, {{percent}} % Skonto bei Zahlung innerhalb von {{discountDays}} Tagen.',
    fibu_offer_paymentTermsNet: '{{days}} Tage netto ohne Abzug.',

    resourceManager_projectStatistics_customerWithId_label: 'Kunde {{id}}',
    resourceManager_projectStatistics_timesheetReceiverWithId_label: 'Leistungsnachweisempfänger {{id}}',

    billingSendAttachments_header: 'Anhänge',
    billingSendAttachments_description: 'PDF plus bevorzugtes strukturiertes Format sind vorausgewählt.',
    billingSendFormatsLess_button: 'Weniger',
    billingSendFormatsMore_button: 'Weitere Formate',
    billingSendPreferredStandard_label: 'Kunden oder Projektstandard',
    billingSendFormats_hint: 'Mindestens ein Format auswählen. EDIFACT und VW können zusätzliche Partnerdaten erfordern.',

    fibu_invoice_import_eyebrow: 'Rechnungsimport',
    fibu_invoice_import_title: 'Externe Rechnung übernehmen',
    fibu_invoice_import_description: 'Unterstützt werden XRechnung und ZUGFeRD XML sowie EDIFACT INVOIC und Volkswagen VDA 4938 T2.',
    fibu_invoice_import_checking_label: 'Rechnung wird geprüft …',
    fibu_invoice_import_selectFile_label: 'Rechnungsdatei auswählen',
    fibu_invoice_import_upload_hint: 'XML, EDI oder TXT · Das Original wird beim Import unverändert gespeichert.',
    fibu_invoice_import_detectedFormat_label: 'Erkanntes Format',
    fibu_invoice_import_issuer_label: 'Aussteller',
    fibu_invoice_import_preview_hint: 'Die Vorschau wird aus den strukturierten Rechnungsdaten erzeugt. Beim Speichern bleibt die hochgeladene Datei zusätzlich als Originaldokument erhalten.',
    fibu_invoice_import_otherFile_button: 'Andere Datei',
    fibu_invoice_import_importing_label: 'Importiere …',
    fibu_invoice_import_action: 'Rechnung importieren',
    fibu_invoice_import_structuredInvoice_label: 'Strukturierte Rechnung',
    fibu_invoice_import_read_error: 'Die Rechnung konnte nicht gelesen werden.',

    fibu_invoice_previewPng_error: 'Rechnungsvorschau konnte nicht in PNG umgewandelt werden.',
    fibu_offer_previewPng_error: 'Angebotsvorschau konnte nicht in PNG umgewandelt werden.',
    resourceManager_timeTracking_noProject_label: 'Ohne Projekt',
    resourceManager_timeTracking_projectWithId_label: 'Projekt {{id}}',

    fibu_invoice_freeRecipientRequired_error: 'Bitte Firma oder Empfänger angeben.',
    fibu_invoice_introRequired_error: 'Bitte einen Einleitungstext eintragen.',
    fibu_invoice_introMaxLength_error: 'Der Einleitungstext darf maximal 4000 Zeichen lang sein.',
    fibu_invoice_closingMaxLength_error: 'Der Abschlusstext darf maximal 4000 Zeichen lang sein.',
    fibu_invoice_internalNoteMaxLength_error: 'Die interne Notiz darf maximal 8000 Zeichen lang sein.',
    fibu_invoice_discountPair_error: 'Für Skonto werden Prozentsatz und Frist benötigt.',
    fibu_invoice_discountPercent_error: 'Skonto muss zwischen 0 und 100 Prozent liegen.',
    fibu_invoice_alreadyBilledExcluded_message: '{{count}} bereits fakturierte Buchungen wurden automatisch ausgeschlossen.',
    fibu_invoice_budgetOverflow_message: '{{hours}} h passen nicht mehr in das ausgewählte Restbudget und wurden nicht übernommen.',

    fibu_invoice_filePrefix: 'Rechnung',
    resourceManager_employeeTimeOverview_overtimeSheet: 'Überstunden',


    calendarTypeTraining: 'Schulung',
    calendarTypeBusinessTrip: 'Dienstreise',
    calendarTypeProjectStart: 'Projektstart',
    calendarTypeProjectEnd: 'Projektende',
    calendarTypePublicHoliday: 'Feiertag',
    calendarTypeSpecialLeave: 'Sonderurlaub',
    calendarTypeBirthday: 'Geburtstag',
    calendarTypeTeamsStatus: 'Teams Status',
    calendarTypeUnknownWithId: 'Typ {{type}}',
    resourceManager_projectStatistics_orderedValue_label: 'Beauftragter Wert',
    resourceManager_projectStatistics_remainingValue_label: 'Restwert',
    fibu_offer_discountPercent_error: 'Skonto muss zwischen 0 und 100 Prozent liegen.',
    fibu_offer_internalNoteMaxLength_error: 'Die interne Notiz darf maximal 8000 Zeichen lang sein.',
    general_validationFailed: 'Validierung fehlgeschlagen',

    fibu_invoice_previewNotReady_error: 'Die Rechnungsvorschau ist noch nicht gerendert.',
    calendarTypeBirthdays: 'Geburtstage',
    calendar_birthday_single_tooltip: '{{name}} hat Geburtstag',
    calendar_birthday_multiple_tooltip: 'Geburtstage: {{names}}',
    billing_unit_hour_short: 'Std.',
    billing_unit_day_short: 'Tag',
    billing_unit_piece_short: 'Stk.',
    billing_unit_flat_short: 'Pausch.',

    fibu_invoice_paymentTermsWithDiscount: '{{days}} Tage netto, {{percent}} % Skonto bei Zahlung innerhalb von {{discountDays}} Tagen.',

    resourceManager_projectStatistics_performance_label: 'Leistung',

    general_germany: 'Deutschland',
    fibu_invoice_notFound_error: 'Rechnung wurde nicht gefunden.',
    fibu_invoice_mock_freePosition: 'Freie Rechnungsposition',
    fibu_invoice_mock_manualPosition: 'Manuelle Position',
    fibu_invoice_quantityPositive_error: 'Positionsmengen müssen größer als null sein.',
    fibu_invoice_priceNonNegative_error: 'Preise dürfen nicht negativ sein.',
    fibu_invoice_mock_accountingContact: 'Rechnungswesen',
    fibu_invoice_mock_projectServicesDescription: '{{projectName}} · Entwicklungs und Unterstützungsleistungen',
    fibu_invoice_mock_projectService: 'Mock Projektleistung',
}
